import St, { useState as xr, useEffect as zt, useCallback as pt, createContext as Wo, useContext as Vo, useMemo as Wt } from "react";
import { a as Sn } from "./index-DIyqYqBT.js";
import { g as kn } from "./tailwind-BXrsiEcF.js";
import "react/jsx-runtime";
import { b as Xo, s as Jo } from "./localisationConfig-BfnSuGmH.js";
import { A as Ko, M as Zo, C as Qo } from "./conversations-B6_5aJ5K.js";
function dc(i, e) {
  const [t, r] = xr(i);
  return zt(() => {
    const s = setTimeout(() => r(i), e || 500);
    return () => {
      clearTimeout(s);
    };
  }, [i, e]), t;
}
const hc = () => {
  const [i, e] = xr(null), t = pt((a) => {
    e(a);
  }, []), r = pt(
    (a) => {
      if (!i)
        return;
      const l = {
        left: i.scrollLeft,
        top: i.scrollTop,
        x: a.clientX,
        y: a.clientY
      }, u = (d) => {
        const h = d.clientX - l.x, p = d.clientY - l.y;
        i.scrollTop = l.top - p, i.scrollLeft = l.left - h, n(i);
      }, c = () => {
        document.removeEventListener("mousemove", u), document.removeEventListener("mouseup", c), o(i);
      };
      document.addEventListener("mousemove", u), document.addEventListener("mouseup", c);
    },
    [i]
  ), s = pt(
    (a) => {
      if (!i)
        return;
      const l = a.touches[0], u = {
        left: i.scrollLeft,
        top: i.scrollTop,
        x: l.clientX,
        y: l.clientY
      }, c = (h) => {
        const p = h.touches[0], g = p.clientX - u.x, v = p.clientY - u.y;
        i.scrollTop = u.top - v, i.scrollLeft = u.left - g, n(i);
      }, d = () => {
        document.removeEventListener("touchmove", c), document.removeEventListener("touchend", d), o(i);
      };
      document.addEventListener("touchmove", c), document.addEventListener("touchend", d);
    },
    [i]
  ), n = (a) => {
    a.style.cursor = "grabbing", a.style.userSelect = "none";
  }, o = (a) => {
    a.style.cursor = "grab", a.style.removeProperty("user-select");
  };
  return zt(() => {
    if (i)
      return i.addEventListener("mousedown", r), i.addEventListener("touchstart", s), () => {
        i.removeEventListener("mousedown", r), i.removeEventListener("touchstart", s);
      };
  }, [i]), [t];
};
var $r, es;
function ea() {
  if (es) return $r;
  es = 1;
  const i = /* @__PURE__ */ new Set([
    "ENOTFOUND",
    "ENETUNREACH",
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    "UNABLE_TO_GET_ISSUER_CERT",
    "UNABLE_TO_GET_CRL",
    "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
    "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
    "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
    "CERT_SIGNATURE_FAILURE",
    "CRL_SIGNATURE_FAILURE",
    "CERT_NOT_YET_VALID",
    "CERT_HAS_EXPIRED",
    "CRL_NOT_YET_VALID",
    "CRL_HAS_EXPIRED",
    "ERROR_IN_CERT_NOT_BEFORE_FIELD",
    "ERROR_IN_CERT_NOT_AFTER_FIELD",
    "ERROR_IN_CRL_LAST_UPDATE_FIELD",
    "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
    "OUT_OF_MEM",
    "DEPTH_ZERO_SELF_SIGNED_CERT",
    "SELF_SIGNED_CERT_IN_CHAIN",
    "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
    "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
    "CERT_CHAIN_TOO_LONG",
    "CERT_REVOKED",
    "INVALID_CA",
    "PATH_LENGTH_EXCEEDED",
    "INVALID_PURPOSE",
    "CERT_UNTRUSTED",
    "CERT_REJECTED",
    "HOSTNAME_MISMATCH"
  ]);
  return $r = (e) => !i.has(e && e.code), $r;
}
var ta = ea();
const ra = /* @__PURE__ */ kn(ta), $i = "axios-retry";
function xn(i) {
  const e = ["ERR_CANCELED", "ECONNABORTED"];
  return i.response || !i.code || e.includes(i.code) ? !1 : ra(i);
}
const Rn = ["get", "head", "options"], ia = Rn.concat(["put", "delete"]);
function Mi(i) {
  return i.code !== "ECONNABORTED" && (!i.response || i.response.status === 429 || i.response.status >= 500 && i.response.status <= 599);
}
function sa(i) {
  var e;
  return (e = i.config) != null && e.method ? Mi(i) && Rn.indexOf(i.config.method) !== -1 : !1;
}
function Tn(i) {
  var e;
  return (e = i.config) != null && e.method ? Mi(i) && ia.indexOf(i.config.method) !== -1 : !1;
}
function In(i) {
  return xn(i) || Tn(i);
}
function Li(i = void 0) {
  var r;
  const e = (r = i == null ? void 0 : i.response) == null ? void 0 : r.headers["retry-after"];
  if (!e)
    return 0;
  let t = (Number(e) || 0) * 1e3;
  return t === 0 && (t = (new Date(e).valueOf() || 0) - Date.now()), Math.max(0, t);
}
function na(i = 0, e = void 0) {
  return Math.max(0, Li(e));
}
function oa(i = 0, e = void 0, t = 100) {
  const r = 2 ** i * t, s = Math.max(r, Li(e)), n = s * 0.2 * Math.random();
  return s + n;
}
function aa(i = 100) {
  return (e = 0, t = void 0) => {
    const r = e * i;
    return Math.max(r, Li(t));
  };
}
const la = {
  retries: 3,
  retryCondition: In,
  retryDelay: na,
  shouldResetTimeout: !1,
  onRetry: () => {
  },
  onMaxRetryTimesExceeded: () => {
  },
  validateResponse: null
};
function ua(i, e) {
  return { ...la, ...e, ...i[$i] };
}
function ts(i, e, t = !1) {
  const r = ua(i, e || {});
  return r.retryCount = r.retryCount || 0, (!r.lastRequestTime || t) && (r.lastRequestTime = Date.now()), i[$i] = r, r;
}
function ca(i, e) {
  i.defaults.agent === e.agent && delete e.agent, i.defaults.httpAgent === e.httpAgent && delete e.httpAgent, i.defaults.httpsAgent === e.httpsAgent && delete e.httpsAgent;
}
async function da(i, e) {
  const { retries: t, retryCondition: r } = i, s = (i.retryCount || 0) < t && r(e);
  if (typeof s == "object")
    try {
      return await s !== !1;
    } catch {
      return !1;
    }
  return s;
}
async function ha(i, e, t, r) {
  var l;
  e.retryCount += 1;
  const { retryDelay: s, shouldResetTimeout: n, onRetry: o } = e, a = s(e.retryCount, t);
  if (ca(i, r), !n && r.timeout && e.lastRequestTime) {
    const u = Date.now() - e.lastRequestTime, c = r.timeout - u - a;
    if (c <= 0)
      return Promise.reject(t);
    r.timeout = c;
  }
  return r.transformRequest = [(u) => u], await o(e.retryCount, t, r), (l = r.signal) != null && l.aborted ? Promise.resolve(i(r)) : new Promise((u) => {
    var h;
    const c = () => {
      clearTimeout(d), u(i(r));
    }, d = setTimeout(() => {
      var p;
      u(i(r)), (p = r.signal) != null && p.removeEventListener && r.signal.removeEventListener("abort", c);
    }, a);
    (h = r.signal) != null && h.addEventListener && r.signal.addEventListener("abort", c, { once: !0 });
  });
}
async function pa(i, e) {
  i.retryCount >= i.retries && await i.onMaxRetryTimesExceeded(e, i.retryCount);
}
const Ge = (i, e) => {
  const t = i.interceptors.request.use((s) => {
    var n;
    return ts(s, e, !0), (n = s[$i]) != null && n.validateResponse && (s.validateStatus = () => !1), s;
  }), r = i.interceptors.response.use(null, async (s) => {
    var a;
    const { config: n } = s;
    if (!n)
      return Promise.reject(s);
    const o = ts(n, e);
    return s.response && ((a = o.validateResponse) != null && a.call(o, s.response)) ? s.response : await da(o, s) ? ha(i, o, s, n) : (await pa(o, s), Promise.reject(s));
  });
  return { requestInterceptorId: t, responseInterceptorId: r };
};
Ge.isNetworkError = xn;
Ge.isSafeRequestError = sa;
Ge.isIdempotentRequestError = Tn;
Ge.isNetworkOrIdempotentRequestError = In;
Ge.exponentialDelay = oa;
Ge.linearDelay = aa;
Ge.isRetryableError = Mi;
Ge(Sn, { retries: 3, retryDelay: Ge.exponentialDelay });
function pc(i, e = "http://localhost:8000") {
  zt(() => {
    var t;
    if (i) {
      const r = document.getElementById("gettext-translations");
      r && ((t = r.parentNode) == null || t.removeChild(r)), window.django && (window.django = {}), (() => {
        const n = document.createElement("script");
        n.id = "gettext-translations", n.async = !0, n.defer = !0, Sn.get(`${e}/jsi18n/`, {
          headers: {
            "Accept-Language": i || navigator.language,
            Accept: "application/javascript"
          },
          responseType: "text"
        }).then((o) => {
          n.textContent = o.data, document.head.appendChild(n), console.log(
            `${i} JavaScriptCatalog translations loaded successfully`
          );
          const a = () => {
            window.django && !window.django.reactInterpolate && import("./i18n-DoHK2p36.js").then((l) => l.j).then((l) => {
              l.interpolate("", {}), console.log("React-aware interpolation initialized");
            });
          };
          a(), setTimeout(a, 100), setTimeout(a, 300), setTimeout(a, 500);
        }).catch((o) => {
          console.error(
            "Failed to load JavaScriptCatalog translations:",
            o
          );
        });
      })();
    }
  }, [i]);
}
const Mr = 768;
function fc() {
  const [i, e] = xr(void 0);
  return zt(() => {
    const t = window.matchMedia(`(max-width: ${Mr - 1}px)`), r = () => {
      e(window.innerWidth < Mr);
    };
    return t.addEventListener("change", r), e(window.innerWidth < Mr), () => t.removeEventListener("change", r);
  }, []), !!i;
}
function vc() {
  return document.body.getAttribute("dir") === "rtl";
}
var Vt = { exports: {} }, Xt = { exports: {} }, B = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rs;
function fa() {
  if (rs) return B;
  rs = 1;
  var i = typeof Symbol == "function" && Symbol.for, e = i ? Symbol.for("react.element") : 60103, t = i ? Symbol.for("react.portal") : 60106, r = i ? Symbol.for("react.fragment") : 60107, s = i ? Symbol.for("react.strict_mode") : 60108, n = i ? Symbol.for("react.profiler") : 60114, o = i ? Symbol.for("react.provider") : 60109, a = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, u = i ? Symbol.for("react.concurrent_mode") : 60111, c = i ? Symbol.for("react.forward_ref") : 60112, d = i ? Symbol.for("react.suspense") : 60113, h = i ? Symbol.for("react.suspense_list") : 60120, p = i ? Symbol.for("react.memo") : 60115, g = i ? Symbol.for("react.lazy") : 60116, v = i ? Symbol.for("react.block") : 60121, _ = i ? Symbol.for("react.fundamental") : 60117, w = i ? Symbol.for("react.responder") : 60118, $ = i ? Symbol.for("react.scope") : 60119;
  function I(y) {
    if (typeof y == "object" && y !== null) {
      var X = y.$$typeof;
      switch (X) {
        case e:
          switch (y = y.type, y) {
            case l:
            case u:
            case r:
            case n:
            case s:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case c:
                case g:
                case p:
                case o:
                  return y;
                default:
                  return X;
              }
          }
        case t:
          return X;
      }
    }
  }
  function T(y) {
    return I(y) === u;
  }
  return B.AsyncMode = l, B.ConcurrentMode = u, B.ContextConsumer = a, B.ContextProvider = o, B.Element = e, B.ForwardRef = c, B.Fragment = r, B.Lazy = g, B.Memo = p, B.Portal = t, B.Profiler = n, B.StrictMode = s, B.Suspense = d, B.isAsyncMode = function(y) {
    return T(y) || I(y) === l;
  }, B.isConcurrentMode = T, B.isContextConsumer = function(y) {
    return I(y) === a;
  }, B.isContextProvider = function(y) {
    return I(y) === o;
  }, B.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, B.isForwardRef = function(y) {
    return I(y) === c;
  }, B.isFragment = function(y) {
    return I(y) === r;
  }, B.isLazy = function(y) {
    return I(y) === g;
  }, B.isMemo = function(y) {
    return I(y) === p;
  }, B.isPortal = function(y) {
    return I(y) === t;
  }, B.isProfiler = function(y) {
    return I(y) === n;
  }, B.isStrictMode = function(y) {
    return I(y) === s;
  }, B.isSuspense = function(y) {
    return I(y) === d;
  }, B.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === u || y === n || y === s || y === d || y === h || typeof y == "object" && y !== null && (y.$$typeof === g || y.$$typeof === p || y.$$typeof === o || y.$$typeof === a || y.$$typeof === c || y.$$typeof === _ || y.$$typeof === w || y.$$typeof === $ || y.$$typeof === v);
  }, B.typeOf = I, B;
}
var G = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var is;
function va() {
  return is || (is = 1, process.env.NODE_ENV !== "production" && function() {
    var i = typeof Symbol == "function" && Symbol.for, e = i ? Symbol.for("react.element") : 60103, t = i ? Symbol.for("react.portal") : 60106, r = i ? Symbol.for("react.fragment") : 60107, s = i ? Symbol.for("react.strict_mode") : 60108, n = i ? Symbol.for("react.profiler") : 60114, o = i ? Symbol.for("react.provider") : 60109, a = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, u = i ? Symbol.for("react.concurrent_mode") : 60111, c = i ? Symbol.for("react.forward_ref") : 60112, d = i ? Symbol.for("react.suspense") : 60113, h = i ? Symbol.for("react.suspense_list") : 60120, p = i ? Symbol.for("react.memo") : 60115, g = i ? Symbol.for("react.lazy") : 60116, v = i ? Symbol.for("react.block") : 60121, _ = i ? Symbol.for("react.fundamental") : 60117, w = i ? Symbol.for("react.responder") : 60118, $ = i ? Symbol.for("react.scope") : 60119;
    function I(S) {
      return typeof S == "string" || typeof S == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      S === r || S === u || S === n || S === s || S === d || S === h || typeof S == "object" && S !== null && (S.$$typeof === g || S.$$typeof === p || S.$$typeof === o || S.$$typeof === a || S.$$typeof === c || S.$$typeof === _ || S.$$typeof === w || S.$$typeof === $ || S.$$typeof === v);
    }
    function T(S) {
      if (typeof S == "object" && S !== null) {
        var ye = S.$$typeof;
        switch (ye) {
          case e:
            var Qe = S.type;
            switch (Qe) {
              case l:
              case u:
              case r:
              case n:
              case s:
              case d:
                return Qe;
              default:
                var Et = Qe && Qe.$$typeof;
                switch (Et) {
                  case a:
                  case c:
                  case g:
                  case p:
                  case o:
                    return Et;
                  default:
                    return ye;
                }
            }
          case t:
            return ye;
        }
      }
    }
    var y = l, X = u, ie = a, j = o, ge = e, se = c, le = r, ue = g, ke = p, ne = t, _e = n, oe = s, ce = d, Te = !1;
    function me(S) {
      return Te || (Te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), m(S) || T(S) === l;
    }
    function m(S) {
      return T(S) === u;
    }
    function R(S) {
      return T(S) === a;
    }
    function O(S) {
      return T(S) === o;
    }
    function A(S) {
      return typeof S == "object" && S !== null && S.$$typeof === e;
    }
    function P(S) {
      return T(S) === c;
    }
    function L(S) {
      return T(S) === r;
    }
    function F(S) {
      return T(S) === g;
    }
    function N(S) {
      return T(S) === p;
    }
    function H(S) {
      return T(S) === t;
    }
    function U(S) {
      return T(S) === n;
    }
    function M(S) {
      return T(S) === s;
    }
    function de(S) {
      return T(S) === d;
    }
    G.AsyncMode = y, G.ConcurrentMode = X, G.ContextConsumer = ie, G.ContextProvider = j, G.Element = ge, G.ForwardRef = se, G.Fragment = le, G.Lazy = ue, G.Memo = ke, G.Portal = ne, G.Profiler = _e, G.StrictMode = oe, G.Suspense = ce, G.isAsyncMode = me, G.isConcurrentMode = m, G.isContextConsumer = R, G.isContextProvider = O, G.isElement = A, G.isForwardRef = P, G.isFragment = L, G.isLazy = F, G.isMemo = N, G.isPortal = H, G.isProfiler = U, G.isStrictMode = M, G.isSuspense = de, G.isValidElementType = I, G.typeOf = T;
  }()), G;
}
var ss;
function Pn() {
  return ss || (ss = 1, process.env.NODE_ENV === "production" ? Xt.exports = fa() : Xt.exports = va()), Xt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Lr, ns;
function ga() {
  if (ns) return Lr;
  ns = 1;
  var i = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(n) {
    if (n == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(n);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var n = new String("abc");
      if (n[5] = "de", Object.getOwnPropertyNames(n)[0] === "5")
        return !1;
      for (var o = {}, a = 0; a < 10; a++)
        o["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Lr = s() ? Object.assign : function(n, o) {
    for (var a, l = r(n), u, c = 1; c < arguments.length; c++) {
      a = Object(arguments[c]);
      for (var d in a)
        e.call(a, d) && (l[d] = a[d]);
      if (i) {
        u = i(a);
        for (var h = 0; h < u.length; h++)
          t.call(a, u[h]) && (l[u[h]] = a[u[h]]);
      }
    }
    return l;
  }, Lr;
}
var Nr, os;
function Ni() {
  if (os) return Nr;
  os = 1;
  var i = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Nr = i, Nr;
}
var Dr, as;
function Cn() {
  return as || (as = 1, Dr = Function.call.bind(Object.prototype.hasOwnProperty)), Dr;
}
var jr, ls;
function _a() {
  if (ls) return jr;
  ls = 1;
  var i = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ Ni(), t = {}, r = /* @__PURE__ */ Cn();
    i = function(n) {
      var o = "Warning: " + n;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function s(n, o, a, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in n)
        if (r(n, c)) {
          var d;
          try {
            if (typeof n[c] != "function") {
              var h = Error(
                (l || "React class") + ": " + a + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            d = n[c](o, c, l, a, null, e);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && i(
            (l || "React class") + ": type specification of " + a + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var p = u ? u() : "";
            i(
              "Failed " + a + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, jr = s, jr;
}
var Hr, us;
function ma() {
  if (us) return Hr;
  us = 1;
  var i = Pn(), e = ga(), t = /* @__PURE__ */ Ni(), r = /* @__PURE__ */ Cn(), s = /* @__PURE__ */ _a(), n = function() {
  };
  process.env.NODE_ENV !== "production" && (n = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Hr = function(a, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(m) {
      var R = m && (u && m[u] || m[c]);
      if (typeof R == "function")
        return R;
    }
    var h = "<<anonymous>>", p = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: $(),
      arrayOf: I,
      element: T(),
      elementType: y(),
      instanceOf: X,
      node: se(),
      objectOf: j,
      oneOf: ie,
      oneOfType: ge,
      shape: ue,
      exact: ke
    };
    function g(m, R) {
      return m === R ? m !== 0 || 1 / m === 1 / R : m !== m && R !== R;
    }
    function v(m, R) {
      this.message = m, this.data = R && typeof R == "object" ? R : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function _(m) {
      if (process.env.NODE_ENV !== "production")
        var R = {}, O = 0;
      function A(L, F, N, H, U, M, de) {
        if (H = H || h, M = M || N, de !== t) {
          if (l) {
            var S = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw S.name = "Invariant Violation", S;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ye = H + ":" + N;
            !R[ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            O < 3 && (n(
              "You are manually calling a React.PropTypes validation function for the `" + M + "` prop on `" + H + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), R[ye] = !0, O++);
          }
        }
        return F[N] == null ? L ? F[N] === null ? new v("The " + U + " `" + M + "` is marked as required " + ("in `" + H + "`, but its value is `null`.")) : new v("The " + U + " `" + M + "` is marked as required in " + ("`" + H + "`, but its value is `undefined`.")) : null : m(F, N, H, U, M);
      }
      var P = A.bind(null, !1);
      return P.isRequired = A.bind(null, !0), P;
    }
    function w(m) {
      function R(O, A, P, L, F, N) {
        var H = O[A], U = oe(H);
        if (U !== m) {
          var M = ce(H);
          return new v(
            "Invalid " + L + " `" + F + "` of type " + ("`" + M + "` supplied to `" + P + "`, expected ") + ("`" + m + "`."),
            { expectedType: m }
          );
        }
        return null;
      }
      return _(R);
    }
    function $() {
      return _(o);
    }
    function I(m) {
      function R(O, A, P, L, F) {
        if (typeof m != "function")
          return new v("Property `" + F + "` of component `" + P + "` has invalid PropType notation inside arrayOf.");
        var N = O[A];
        if (!Array.isArray(N)) {
          var H = oe(N);
          return new v("Invalid " + L + " `" + F + "` of type " + ("`" + H + "` supplied to `" + P + "`, expected an array."));
        }
        for (var U = 0; U < N.length; U++) {
          var M = m(N, U, P, L, F + "[" + U + "]", t);
          if (M instanceof Error)
            return M;
        }
        return null;
      }
      return _(R);
    }
    function T() {
      function m(R, O, A, P, L) {
        var F = R[O];
        if (!a(F)) {
          var N = oe(F);
          return new v("Invalid " + P + " `" + L + "` of type " + ("`" + N + "` supplied to `" + A + "`, expected a single ReactElement."));
        }
        return null;
      }
      return _(m);
    }
    function y() {
      function m(R, O, A, P, L) {
        var F = R[O];
        if (!i.isValidElementType(F)) {
          var N = oe(F);
          return new v("Invalid " + P + " `" + L + "` of type " + ("`" + N + "` supplied to `" + A + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return _(m);
    }
    function X(m) {
      function R(O, A, P, L, F) {
        if (!(O[A] instanceof m)) {
          var N = m.name || h, H = me(O[A]);
          return new v("Invalid " + L + " `" + F + "` of type " + ("`" + H + "` supplied to `" + P + "`, expected ") + ("instance of `" + N + "`."));
        }
        return null;
      }
      return _(R);
    }
    function ie(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? n(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : n("Invalid argument supplied to oneOf, expected an array.")), o;
      function R(O, A, P, L, F) {
        for (var N = O[A], H = 0; H < m.length; H++)
          if (g(N, m[H]))
            return null;
        var U = JSON.stringify(m, function(de, S) {
          var ye = ce(S);
          return ye === "symbol" ? String(S) : S;
        });
        return new v("Invalid " + L + " `" + F + "` of value `" + String(N) + "` " + ("supplied to `" + P + "`, expected one of " + U + "."));
      }
      return _(R);
    }
    function j(m) {
      function R(O, A, P, L, F) {
        if (typeof m != "function")
          return new v("Property `" + F + "` of component `" + P + "` has invalid PropType notation inside objectOf.");
        var N = O[A], H = oe(N);
        if (H !== "object")
          return new v("Invalid " + L + " `" + F + "` of type " + ("`" + H + "` supplied to `" + P + "`, expected an object."));
        for (var U in N)
          if (r(N, U)) {
            var M = m(N, U, P, L, F + "." + U, t);
            if (M instanceof Error)
              return M;
          }
        return null;
      }
      return _(R);
    }
    function ge(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && n("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var R = 0; R < m.length; R++) {
        var O = m[R];
        if (typeof O != "function")
          return n(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Te(O) + " at index " + R + "."
          ), o;
      }
      function A(P, L, F, N, H) {
        for (var U = [], M = 0; M < m.length; M++) {
          var de = m[M], S = de(P, L, F, N, H, t);
          if (S == null)
            return null;
          S.data && r(S.data, "expectedType") && U.push(S.data.expectedType);
        }
        var ye = U.length > 0 ? ", expected one of type [" + U.join(", ") + "]" : "";
        return new v("Invalid " + N + " `" + H + "` supplied to " + ("`" + F + "`" + ye + "."));
      }
      return _(A);
    }
    function se() {
      function m(R, O, A, P, L) {
        return ne(R[O]) ? null : new v("Invalid " + P + " `" + L + "` supplied to " + ("`" + A + "`, expected a ReactNode."));
      }
      return _(m);
    }
    function le(m, R, O, A, P) {
      return new v(
        (m || "React class") + ": " + R + " type `" + O + "." + A + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + P + "`."
      );
    }
    function ue(m) {
      function R(O, A, P, L, F) {
        var N = O[A], H = oe(N);
        if (H !== "object")
          return new v("Invalid " + L + " `" + F + "` of type `" + H + "` " + ("supplied to `" + P + "`, expected `object`."));
        for (var U in m) {
          var M = m[U];
          if (typeof M != "function")
            return le(P, L, F, U, ce(M));
          var de = M(N, U, P, L, F + "." + U, t);
          if (de)
            return de;
        }
        return null;
      }
      return _(R);
    }
    function ke(m) {
      function R(O, A, P, L, F) {
        var N = O[A], H = oe(N);
        if (H !== "object")
          return new v("Invalid " + L + " `" + F + "` of type `" + H + "` " + ("supplied to `" + P + "`, expected `object`."));
        var U = e({}, O[A], m);
        for (var M in U) {
          var de = m[M];
          if (r(m, M) && typeof de != "function")
            return le(P, L, F, M, ce(de));
          if (!de)
            return new v(
              "Invalid " + L + " `" + F + "` key `" + M + "` supplied to `" + P + "`.\nBad object: " + JSON.stringify(O[A], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(m), null, "  ")
            );
          var S = de(N, M, P, L, F + "." + M, t);
          if (S)
            return S;
        }
        return null;
      }
      return _(R);
    }
    function ne(m) {
      switch (typeof m) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !m;
        case "object":
          if (Array.isArray(m))
            return m.every(ne);
          if (m === null || a(m))
            return !0;
          var R = d(m);
          if (R) {
            var O = R.call(m), A;
            if (R !== m.entries) {
              for (; !(A = O.next()).done; )
                if (!ne(A.value))
                  return !1;
            } else
              for (; !(A = O.next()).done; ) {
                var P = A.value;
                if (P && !ne(P[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function _e(m, R) {
      return m === "symbol" ? !0 : R ? R["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && R instanceof Symbol : !1;
    }
    function oe(m) {
      var R = typeof m;
      return Array.isArray(m) ? "array" : m instanceof RegExp ? "object" : _e(R, m) ? "symbol" : R;
    }
    function ce(m) {
      if (typeof m > "u" || m === null)
        return "" + m;
      var R = oe(m);
      if (R === "object") {
        if (m instanceof Date)
          return "date";
        if (m instanceof RegExp)
          return "regexp";
      }
      return R;
    }
    function Te(m) {
      var R = ce(m);
      switch (R) {
        case "array":
        case "object":
          return "an " + R;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + R;
        default:
          return R;
      }
    }
    function me(m) {
      return !m.constructor || !m.constructor.name ? h : m.constructor.name;
    }
    return p.checkPropTypes = s, p.resetWarningCache = s.resetWarningCache, p.PropTypes = p, p;
  }, Hr;
}
var qr, cs;
function ya() {
  if (cs) return qr;
  cs = 1;
  var i = /* @__PURE__ */ Ni();
  function e() {
  }
  function t() {
  }
  return t.resetWarningCache = e, qr = function() {
    function r(o, a, l, u, c, d) {
      if (d !== i) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function s() {
      return r;
    }
    var n = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: s,
      element: r,
      elementType: r,
      instanceOf: s,
      node: r,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: t,
      resetWarningCache: e
    };
    return n.PropTypes = n, n;
  }, qr;
}
var ds;
function ba() {
  if (ds) return Vt.exports;
  if (ds = 1, process.env.NODE_ENV !== "production") {
    var i = Pn(), e = !0;
    Vt.exports = /* @__PURE__ */ ma()(i.isElement, e);
  } else
    Vt.exports = /* @__PURE__ */ ya()();
  return Vt.exports;
}
var wa = /* @__PURE__ */ ba();
const gc = /* @__PURE__ */ kn(wa);
function On({
  conversation: i,
  noticeboardData: e,
  useSystemLanguage: t
}) {
  const r = t ? "system_language_raw_output" : "raw_output", s = t ? "system_language_parsed_output" : "parsed_output", n = i == null ? void 0 : i.panel_experts_config, o = pt(
    (l) => {
      var d, h, p, g, v;
      const u = n == null ? void 0 : n.find((_) => _.name === l);
      let c;
      if (u && u.output_key === "raw_output") {
        const _ = (d = e == null ? void 0 : e[u.expert_name]) == null ? void 0 : d[r];
        _ != null && (c = _);
      } else if (u && u.output_key) {
        const _ = (h = e == null ? void 0 : e[u.expert_name]) == null ? void 0 : h[s];
        _ && typeof _ == "object" && (c = _[u.output_key]);
      } else if (u) {
        const _ = (p = e == null ? void 0 : e[u.expert_name]) == null ? void 0 : p[r];
        _ != null && (c = _);
      }
      return {
        ...u,
        content: c,
        parsedOutput: (g = e == null ? void 0 : e[(u == null ? void 0 : u.expert_name) || ""]) == null ? void 0 : g[s],
        systemLanguageParsedOutput: (v = e == null ? void 0 : e[(u == null ? void 0 : u.expert_name) || ""]) == null ? void 0 : v.system_language_parsed_output
      };
    },
    [e, n, s, r]
  ), a = pt(
    (l) => ((n == null ? void 0 : n.filter((c) => c.name.startsWith(l))) || []).map((c) => {
      var h, p, g, v, _;
      let d;
      if (c && c.output_key === "raw_output") {
        const w = (h = e == null ? void 0 : e[c.expert_name]) == null ? void 0 : h[r];
        w != null && (d = w);
      } else if (c && c.output_key) {
        const w = (p = e == null ? void 0 : e[c.expert_name]) == null ? void 0 : p[s];
        w && typeof w == "object" && (d = w[c.output_key]);
      } else if (c) {
        const w = (g = e == null ? void 0 : e[c.expert_name]) == null ? void 0 : g[r];
        w != null && (d = w);
      }
      return {
        ...c,
        content: d,
        parsedOutput: (v = e == null ? void 0 : e[(c == null ? void 0 : c.expert_name) || ""]) == null ? void 0 : v[s],
        systemLanguageParsedOutput: (_ = e == null ? void 0 : e[(c == null ? void 0 : c.expert_name) || ""]) == null ? void 0 : _.system_language_parsed_output
      };
    }),
    [e, n, s, r]
  );
  return {
    getConfig: o,
    getConfigs: a
  };
}
function _c(i, e) {
  if (!i) return !1;
  const t = i.frontend_expert_output_config, r = t == null ? void 0 : t[e];
  return !!(r != null && r.enable_detailed_analysis);
}
const Ea = void 0;
function mc(i, e) {
  if (!i) return !1;
  if (["dev", "dojo"].includes(Ea)) return !0;
  const t = i.frontend_expert_output_config, r = t == null ? void 0 : t[e];
  return !!(r != null && r.enable_follow_up_flow);
}
var f = typeof window < "u" ? window : void 0, Ee = typeof globalThis < "u" ? globalThis : f, An = Array.prototype, hs = An.forEach, ps = An.indexOf, xe = Ee == null ? void 0 : Ee.navigator, x = Ee == null ? void 0 : Ee.document, we = Ee == null ? void 0 : Ee.location, ri = Ee == null ? void 0 : Ee.fetch, ii = Ee != null && Ee.XMLHttpRequest && "withCredentials" in new Ee.XMLHttpRequest() ? Ee.XMLHttpRequest : void 0, fs = Ee == null ? void 0 : Ee.AbortController, be = xe == null ? void 0 : xe.userAgent, C = f ?? {}, Ue = { DEBUG: !1, LIB_VERSION: "1.268.0" };
function vs(i, e, t, r, s, n, o) {
  try {
    var a = i[n](o), l = a.value;
  } catch (u) {
    return void t(u);
  }
  a.done ? e(l) : Promise.resolve(l).then(r, s);
}
function gs(i) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(r, s) {
      var n = i.apply(e, t);
      function o(l) {
        vs(n, r, s, o, a, "next", l);
      }
      function a(l) {
        vs(n, r, s, o, a, "throw", l);
      }
      o(void 0);
    });
  };
}
function E() {
  return E = Object.assign ? Object.assign.bind() : function(i) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (i[r] = t[r]);
    }
    return i;
  }, E.apply(null, arguments);
}
function Fn(i, e) {
  if (i == null) return {};
  var t = {};
  for (var r in i) if ({}.hasOwnProperty.call(i, r)) {
    if (e.indexOf(r) !== -1) continue;
    t[r] = i[r];
  }
  return t;
}
var Sa = ["$snapshot", "$pageview", "$pageleave", "$set", "survey dismissed", "survey sent", "survey shown", "$identify", "$groupidentify", "$create_alias", "$$client_ingestion_warning", "$web_experiment_applied", "$feature_enrollment_update", "$feature_flag_called"];
function D(i, e) {
  return i.indexOf(e) !== -1;
}
var Rr = function(i) {
  return i.trim();
}, si = function(i) {
  return i.replace(/^\$/, "");
}, ka = Array.isArray, $n = Object.prototype, Mn = $n.hasOwnProperty, Tr = $n.toString, W = ka || function(i) {
  return Tr.call(i) === "[object Array]";
}, Ie = (i) => typeof i == "function", K = (i) => i === Object(i) && !W(i), dt = (i) => {
  if (K(i)) {
    for (var e in i) if (Mn.call(i, e)) return !1;
    return !0;
  }
  return !1;
}, b = (i) => i === void 0, Z = (i) => Tr.call(i) == "[object String]", ni = (i) => Z(i) && i.trim().length === 0, Ye = (i) => i === null, q = (i) => b(i) || Ye(i), pe = (i) => Tr.call(i) == "[object Number]", Ae = (i) => Tr.call(i) === "[object Boolean]", xa = (i) => i instanceof FormData, Ra = (i) => D(Sa, i);
function oi(i) {
  return i === null || typeof i != "object";
}
function ur(i, e) {
  return Object.prototype.toString.call(i) === "[object " + e + "]";
}
function Ln(i) {
  return !b(Event) && function(e, t) {
    try {
      return e instanceof t;
    } catch {
      return !1;
    }
  }(i, Event);
}
var Ta = [!0, "true", 1, "1", "yes"], Ur = (i) => D(Ta, i), Ia = [!1, "false", 0, "0", "no"];
function Re(i, e, t, r, s) {
  return e > t && (r.warn("min cannot be greater than max."), e = t), pe(i) ? i > t ? (r.warn(" cannot be  greater than max: " + t + ". Using max value instead."), t) : i < e ? (r.warn(" cannot be less than min: " + e + ". Using min value instead."), e) : i : (r.warn(" must be a number. using max or fallback. max: " + t + ", fallback: " + s), Re(s || t, e, t, r));
}
class Nn {
  stop() {
    this.t && (clearInterval(this.t), this.t = void 0);
  }
  constructor(e) {
    this.i = e, this.o = {}, this.h = () => {
      Object.keys(this.o).forEach((t) => {
        var r = this.m(t) + this.S;
        r >= this.k ? delete this.o[t] : this.$(t, r);
      });
    }, this.m = (t) => this.o[String(t)], this.$ = (t, r) => {
      this.o[String(t)] = r;
    }, this.consumeRateLimit = (t) => {
      var r, s = (r = this.m(t)) != null ? r : this.k;
      if ((s = Math.max(s - 1, 0)) === 0) return !0;
      this.$(t, s);
      var n, o = s === 0;
      return o && ((n = this.P) == null || n.call(this, t)), o;
    }, this.P = this.i.P, this.k = Re(this.i.bucketSize, 0, 100, this.i.I), this.S = Re(this.i.refillRate, 0, this.k, this.i.I), this.R = Re(this.i.refillInterval, 0, 864e5, this.i.I), this.t = setInterval(() => {
      this.h();
    }, this.R);
  }
}
var Jt, _s, Br, Pa = (i) => i instanceof Error;
function Ca(i) {
  var e = globalThis._posthogChunkIds;
  if (e) {
    var t = Object.keys(e);
    return Br && t.length === _s || (_s = t.length, Br = t.reduce((r, s) => {
      Jt || (Jt = {});
      var n = Jt[s];
      if (n) r[n[0]] = n[1];
      else for (var o = i(s), a = o.length - 1; a >= 0; a--) {
        var l = o[a], u = l == null ? void 0 : l.filename, c = e[s];
        if (u && c) {
          r[u] = c, Jt[s] = [u, c];
          break;
        }
      }
      return r;
    }, {})), Br;
  }
}
var gt = "?";
function ai(i, e, t, r) {
  var s = { platform: "web:javascript", filename: i, function: e === "<anonymous>" ? gt : e, in_app: !0 };
  return b(t) || (s.lineno = t), b(r) || (s.colno = r), s;
}
var Dn = (i, e) => {
  var t = i.indexOf("safari-extension") !== -1, r = i.indexOf("safari-web-extension") !== -1;
  return t || r ? [i.indexOf("@") !== -1 ? i.split("@")[0] : gt, t ? "safari-extension:" + e : "safari-web-extension:" + e] : [i, e];
}, Oa = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, Aa = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, Fa = /\((\S*)(?::(\d+))(?::(\d+))\)/, $a = (i) => {
  var e = Oa.exec(i);
  if (e) {
    var [, t, r, s] = e;
    return ai(t, gt, +r, +s);
  }
  var n = Aa.exec(i);
  if (n) {
    if (n[2] && n[2].indexOf("eval") === 0) {
      var o = Fa.exec(n[2]);
      o && (n[2] = o[1], n[3] = o[2], n[4] = o[3]);
    }
    var [a, l] = Dn(n[1] || gt, n[2]);
    return ai(l, a, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
  }
}, Ma = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, La = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, Na = (i) => {
  var e = Ma.exec(i);
  if (e) {
    if (e[3] && e[3].indexOf(" > eval") > -1) {
      var t = La.exec(e[3]);
      t && (e[1] = e[1] || "eval", e[3] = t[1], e[4] = t[2], e[5] = "");
    }
    var r = e[3], s = e[1] || gt;
    return [s, r] = Dn(s, r), ai(r, s, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
  }
}, ms = /\(error: (.*)\)/, ys = 50;
function Da() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++) e[t] = arguments[t];
  return function(r) {
    for (var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = [], o = r.split(`
`), a = s; a < o.length; a++) {
      var l = o[a];
      if (!(l.length > 1024)) {
        var u = ms.test(l) ? l.replace(ms, "$1") : l;
        if (!u.match(/\S*Error: /)) {
          for (var c of e) {
            var d = c(u);
            if (d) {
              n.push(d);
              break;
            }
          }
          if (n.length >= ys) break;
        }
      }
    }
    return function(h) {
      if (!h.length) return [];
      var p = Array.from(h);
      return p.reverse(), p.slice(0, ys).map((g) => {
        return E({}, g, { filename: g.filename || (v = p, v[v.length - 1] || {}).filename, function: g.function || gt });
        var v;
      });
    }(n);
  };
}
class ja {
  buildFromUnknown(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t && t.mechanism || { handled: !0, type: "generic" }, s = this.buildCoercingContext(r, t, 0).apply(e), n = this.buildParsingContext(), o = this.parseStacktrace(s, n);
    return { $exception_list: this.convertToExceptionList(o, r), $exception_level: "error" };
  }
  coerceFallback(e) {
    var t;
    return { type: "Error", value: "Unknown error", stack: (t = e.syntheticException) == null ? void 0 : t.stack, synthetic: !0 };
  }
  parseStacktrace(e, t) {
    var r, s;
    return e.cause != null && (r = this.parseStacktrace(e.cause, t)), e.stack != "" && e.stack != null && (s = this.applyChunkIds(this.stackParser(e.stack, e.synthetic ? 1 : 0), t.chunkIdMap)), E({}, e, { cause: r, stack: s });
  }
  applyChunkIds(e, t) {
    return e.map((r) => (r.filename && t && (r.chunk_id = t[r.filename]), r));
  }
  applyCoercers(e, t) {
    for (var r of this.coercers) if (r.match(e)) return r.coerce(e, t);
    return this.coerceFallback(t);
  }
  applyModifiers(e) {
    var t = this;
    return gs(function* () {
      var r = e;
      for (var s of t.modifiers) r = yield s(r);
      return r;
    })();
  }
  modifyFrames(e) {
    var t = this;
    return gs(function* () {
      var r;
      e.cause != null && (r = yield t.modifyFrames(e.cause));
      var s = [];
      return e.stack != null && (s = yield t.applyModifiers(e.stack)), E({}, e, { cause: r, stack: s });
    })();
  }
  convertToExceptionList(e, t) {
    var r, s, n, o = { type: e.type, value: e.value, mechanism: { type: (r = t.type) != null ? r : "generic", handled: (s = t.handled) == null || s, synthetic: (n = e.synthetic) != null && n } };
    e.stack && (o.stacktrace = { type: "raw", frames: e.stack });
    var a = [o];
    return e.cause != null && a.push(...this.convertToExceptionList(e.cause, E({}, t, { handled: !0 }))), a;
  }
  buildParsingContext() {
    return { chunkIdMap: Ca(this.stackParser) };
  }
  buildCoercingContext(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, s = (n, o) => {
      if (o <= 4) {
        var a = this.buildCoercingContext(e, t, o);
        return this.applyCoercers(n, a);
      }
    };
    return E({}, t, { syntheticException: r == 0 ? t.syntheticException : void 0, mechanism: e, apply: (n) => s(n, r), next: (n) => s(n, r + 1) });
  }
  constructor(e, t, r) {
    e === void 0 && (e = []), t === void 0 && (t = []), r === void 0 && (r = []), this.coercers = e, this.modifiers = r, this.stackParser = Da(...t);
  }
}
class Ha {
  match(e) {
    return this.isDOMException(e) || this.isDOMError(e);
  }
  coerce(e, t) {
    var r = Z(e.stack);
    return { type: this.getType(e), value: this.getValue(e), stack: r ? e.stack : void 0, cause: e.cause ? t.next(e.cause) : void 0, synthetic: !1 };
  }
  getType(e) {
    return this.isDOMError(e) ? "DOMError" : "DOMException";
  }
  getValue(e) {
    var t = e.name || (this.isDOMError(e) ? "DOMError" : "DOMException");
    return e.message ? t + ": " + e.message : t;
  }
  isDOMException(e) {
    return ur(e, "DOMException");
  }
  isDOMError(e) {
    return ur(e, "DOMError");
  }
}
class qa {
  match(e) {
    return ((t) => t instanceof Error)(e);
  }
  coerce(e, t) {
    return { type: this.getType(e), value: this.getMessage(e, t), stack: this.getStack(e), cause: e.cause ? t.next(e.cause) : void 0, synthetic: !1 };
  }
  getType(e) {
    return e.name || e.constructor.name;
  }
  getMessage(e, t) {
    var r = e.message;
    return r.error && typeof r.error.message == "string" ? String(r.error.message) : String(r);
  }
  getStack(e) {
    return e.stacktrace || e.stack || void 0;
  }
}
class Ua {
  match(e) {
    return ur(e, "ErrorEvent") && e.error != null;
  }
  coerce(e, t) {
    var r, s = t.apply(e.error);
    return s || { type: "ErrorEvent", value: e.message, stack: (r = t.syntheticException) == null ? void 0 : r.stack, synthetic: !0 };
  }
  constructor() {
  }
}
var Ba = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class Ga {
  match(e) {
    return typeof e == "string";
  }
  coerce(e, t) {
    var r, [s, n] = this.getInfos(e);
    return { type: s ?? "Error", value: n ?? e, stack: (r = t.syntheticException) == null ? void 0 : r.stack, synthetic: !0 };
  }
  getInfos(e) {
    var t = "Error", r = e, s = e.match(Ba);
    return s && (t = s[1], r = s[2]), [t, r];
  }
}
var Ya = ["fatal", "error", "warning", "log", "info", "debug"];
function jn(i) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40, t = Object.keys(i);
  if (t.sort(), !t.length) return "[object has no keys]";
  for (var r = t.length; r > 0; r--) {
    var s = t.slice(0, r).join(", ");
    if (!(s.length > e)) return r === t.length || s.length <= e ? s : s.slice(0, e) + "...";
  }
  return "";
}
class za {
  match(e) {
    return typeof e == "object" && e !== null;
  }
  coerce(e, t) {
    var r, s = this.getErrorPropertyFromObject(e);
    return s ? t.apply(s) : { type: this.getType(e), value: this.getValue(e), stack: (r = t.syntheticException) == null ? void 0 : r.stack, level: this.isSeverityLevel(e.level) ? e.level : "error", synthetic: !0 };
  }
  getType(e) {
    return Ln(e) ? e.constructor.name : "Error";
  }
  getValue(e) {
    if ("name" in e && typeof e.name == "string") {
      var t = "'" + e.name + "' captured as exception";
      return "message" in e && typeof e.message == "string" && (t += " with message: '" + e.message + "'"), t;
    }
    if ("message" in e && typeof e.message == "string") return e.message;
    var r = this.getObjectClassName(e);
    return (r && r !== "Object" ? "'" + r + "'" : "Object") + " captured as exception with keys: " + jn(e);
  }
  isSeverityLevel(e) {
    return Z(e) && !ni(e) && Ya.indexOf(e) >= 0;
  }
  getErrorPropertyFromObject(e) {
    for (var t in e) if (Object.prototype.hasOwnProperty.call(e, t)) {
      var r = e[t];
      if (Pa(r)) return r;
    }
  }
  getObjectClassName(e) {
    try {
      var t = Object.getPrototypeOf(e);
      return t ? t.constructor.name : void 0;
    } catch {
      return;
    }
  }
}
class Wa {
  match(e) {
    return Ln(e);
  }
  coerce(e, t) {
    var r, s = e.constructor.name;
    return { type: s, value: s + " captured as exception with keys: " + jn(e), stack: (r = t.syntheticException) == null ? void 0 : r.stack, synthetic: !0 };
  }
}
class Va {
  match(e) {
    return oi(e);
  }
  coerce(e, t) {
    var r;
    return { type: "Error", value: "Primitive value captured as exception: " + String(e), stack: (r = t.syntheticException) == null ? void 0 : r.stack, synthetic: !0 };
  }
}
class Xa {
  match(e) {
    return ur(e, "PromiseRejectionEvent");
  }
  coerce(e, t) {
    var r, s = this.getUnhandledRejectionReason(e);
    return oi(s) ? { type: "UnhandledRejection", value: "Non-Error promise rejection captured with value: " + String(s), stack: (r = t.syntheticException) == null ? void 0 : r.stack, synthetic: !0 } : t.apply(s);
  }
  getUnhandledRejectionReason(e) {
    if (oi(e)) return e;
    try {
      if ("reason" in e) return e.reason;
      if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch {
    }
    return e;
  }
}
var Hn = (i) => {
  var e = { T: function(t) {
    if (f && (Ue.DEBUG || C.POSTHOG_DEBUG) && !b(f.console) && f.console) {
      for (var r = ("__rrweb_original__" in f.console[t]) ? f.console[t].__rrweb_original__ : f.console[t], s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++) n[o - 1] = arguments[o];
      r(i, ...n);
    }
  }, info: function() {
    for (var t = arguments.length, r = new Array(t), s = 0; s < t; s++) r[s] = arguments[s];
    e.T("log", ...r);
  }, warn: function() {
    for (var t = arguments.length, r = new Array(t), s = 0; s < t; s++) r[s] = arguments[s];
    e.T("warn", ...r);
  }, error: function() {
    for (var t = arguments.length, r = new Array(t), s = 0; s < t; s++) r[s] = arguments[s];
    e.T("error", ...r);
  }, critical: function() {
    for (var t = arguments.length, r = new Array(t), s = 0; s < t; s++) r[s] = arguments[s];
    console.error(i, ...r);
  }, uninitializedWarning: (t) => {
    e.error("You must initialize PostHog before calling " + t);
  }, createLogger: (t) => Hn(i + " " + t) };
  return e;
}, k = Hn("[PostHog.js]"), te = k.createLogger, Ja = te("[ExternalScriptsLoader]"), bs = (i, e, t) => {
  if (i.config.disable_external_dependency_loading) return Ja.warn(e + " was requested but loading of external scripts is disabled."), t("Loading of external scripts is disabled");
  var r = x == null ? void 0 : x.querySelectorAll("script");
  if (r) {
    for (var s, n = function() {
      if (r[o].src === e) {
        var l = r[o];
        return l.__posthog_loading_callback_fired ? { v: t() } : (l.addEventListener("load", (u) => {
          l.__posthog_loading_callback_fired = !0, t(void 0, u);
        }), l.onerror = (u) => t(u), { v: void 0 });
      }
    }, o = 0; o < r.length; o++) if (s = n()) return s.v;
  }
  var a = () => {
    if (!x) return t("document not found");
    var l = x.createElement("script");
    if (l.type = "text/javascript", l.crossOrigin = "anonymous", l.src = e, l.onload = (d) => {
      l.__posthog_loading_callback_fired = !0, t(void 0, d);
    }, l.onerror = (d) => t(d), i.config.prepare_external_dependency_script && (l = i.config.prepare_external_dependency_script(l)), !l) return t("prepare_external_dependency_script returned null");
    var u, c = x.querySelectorAll("body > script");
    c.length > 0 ? (u = c[0].parentNode) == null || u.insertBefore(l, c[0]) : x.body.appendChild(l);
  };
  x != null && x.body ? a() : x == null || x.addEventListener("DOMContentLoaded", a);
};
C.__PosthogExtensions__ = C.__PosthogExtensions__ || {}, C.__PosthogExtensions__.loadExternalDependency = (i, e, t) => {
  var r = "/static/" + e + ".js?v=" + i.version;
  if (e === "remote-config" && (r = "/array/" + i.config.token + "/config.js"), e === "toolbar") {
    var s = 3e5;
    r = r + "&t=" + Math.floor(Date.now() / s) * s;
  }
  var n = i.requestRouter.endpointFor("assets", r);
  bs(i, n, t);
}, C.__PosthogExtensions__.loadSiteApp = (i, e, t) => {
  var r = i.requestRouter.endpointFor("api", e);
  bs(i, r, t);
};
var cr = {};
function Je(i, e, t) {
  if (W(i)) {
    if (hs && i.forEach === hs) i.forEach(e, t);
    else if ("length" in i && i.length === +i.length) {
      for (var r = 0, s = i.length; r < s; r++) if (r in i && e.call(t, i[r], r) === cr) return;
    }
  }
}
function z(i, e, t) {
  if (!q(i)) {
    if (W(i)) return Je(i, e, t);
    if (xa(i)) {
      for (var r of i.entries()) if (e.call(t, r[1], r[0]) === cr) return;
    } else for (var s in i) if (Mn.call(i, s) && e.call(t, i[s], s) === cr) return;
  }
}
var Q = function(i) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) t[r - 1] = arguments[r];
  return Je(t, function(s) {
    for (var n in s) s[n] !== void 0 && (i[n] = s[n]);
  }), i;
}, Ir = function(i) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) t[r - 1] = arguments[r];
  return Je(t, function(s) {
    Je(s, function(n) {
      i.push(n);
    });
  }), i;
};
function or(i) {
  for (var e = Object.keys(i), t = e.length, r = new Array(t); t--; ) r[t] = [e[t], i[e[t]]];
  return r;
}
var ws = function(i) {
  try {
    return i();
  } catch {
    return;
  }
}, Ka = function(i) {
  return function() {
    try {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
      return i.apply(this, t);
    } catch (s) {
      k.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), k.critical(s);
    }
  };
}, Di = function(i) {
  var e = {};
  return z(i, function(t, r) {
    (Z(t) && t.length > 0 || pe(t)) && (e[r] = t);
  }), e;
};
function Za(i, e) {
  return t = i, r = (n) => Z(n) && !Ye(e) ? n.slice(0, e) : n, s = /* @__PURE__ */ new Set(), function n(o, a) {
    return o !== Object(o) ? r ? r(o, a) : o : s.has(o) ? void 0 : (s.add(o), W(o) ? (l = [], Je(o, (u) => {
      l.push(n(u));
    })) : (l = {}, z(o, (u, c) => {
      s.has(u) || (l[c] = n(u, c));
    })), l);
    var l;
  }(t);
  var t, r, s;
}
var Qa = ["herokuapp.com", "vercel.app", "netlify.app"];
function el(i) {
  var e = i == null ? void 0 : i.hostname;
  if (!Z(e)) return !1;
  var t = e.split(".").slice(-2).join(".");
  for (var r of Qa) if (t === r) return !1;
  return !0;
}
function qn(i, e) {
  for (var t = 0; t < i.length; t++) if (e(i[t])) return i[t];
}
function J(i, e, t, r) {
  var { capture: s = !1, passive: n = !0 } = r ?? {};
  i == null || i.addEventListener(e, t, { capture: s, passive: n });
}
var Un = "$people_distinct_id", Ct = "__alias", Ot = "__timers", Es = "$autocapture_disabled_server_side", li = "$heatmaps_enabled_server_side", Ss = "$exception_capture_enabled_server_side", ui = "$error_tracking_suppression_rules", ks = "$error_tracking_capture_extension_exceptions", xs = "$web_vitals_enabled_server_side", Bn = "$dead_clicks_enabled_server_side", Rs = "$web_vitals_allowed_metrics", qt = "$session_recording_enabled_server_side", Ts = "$console_log_recording_enabled_server_side", Is = "$session_recording_network_payload_capture", Ps = "$session_recording_masking", Cs = "$session_recording_canvas_recording", Os = "$replay_sample_rate", As = "$replay_minimum_duration", dr = "$replay_script_config", hr = "$sesid", At = "$session_is_sampled", ci = "$session_recording_url_trigger_activated_session", di = "$session_recording_event_trigger_activated_session", ht = "$enabled_feature_flags", Ft = "$early_access_features", hi = "$feature_flag_details", $t = "$stored_person_properties", st = "$stored_group_properties", pi = "$surveys", Kt = "$surveys_activated", pr = "$flag_call_reported", je = "$user_state", fi = "$client_session_props", vi = "$capture_rate_limit", gi = "$initial_campaign_params", _i = "$initial_referrer_info", fr = "$initial_person_info", vr = "$epp", Gn = "__POSTHOG_TOOLBAR__", kt = "$posthog_cookieless", tl = [Un, Ct, "__cmpns", Ot, qt, li, hr, ht, ui, je, Ft, hi, st, $t, pi, pr, fi, vi, gi, _i, vr, fr];
function Fs(i) {
  return i instanceof Element && (i.id === Gn || !(i.closest == null || !i.closest(".toolbar-global-fade-container")));
}
function Pr(i) {
  return !!i && i.nodeType === 1;
}
function Ke(i, e) {
  return !!i && !!i.tagName && i.tagName.toLowerCase() === e.toLowerCase();
}
function Yn(i) {
  return !!i && i.nodeType === 3;
}
function zn(i) {
  return !!i && i.nodeType === 11;
}
function ji(i) {
  return i ? Rr(i).split(/\s+/) : [];
}
function $s(i) {
  var e = f == null ? void 0 : f.location.href;
  return !!(e && i && i.some((t) => e.match(t)));
}
function gr(i) {
  var e = "";
  switch (typeof i.className) {
    case "string":
      e = i.className;
      break;
    case "object":
      e = (i.className && "baseVal" in i.className ? i.className.baseVal : null) || i.getAttribute("class") || "";
      break;
    default:
      e = "";
  }
  return ji(e);
}
function Wn(i) {
  return q(i) ? null : Rr(i).split(/(\s+)/).filter((e) => _t(e)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function Cr(i) {
  var e = "";
  return mi(i) && !Zn(i) && i.childNodes && i.childNodes.length && z(i.childNodes, function(t) {
    var r;
    Yn(t) && t.textContent && (e += (r = Wn(t.textContent)) !== null && r !== void 0 ? r : "");
  }), Rr(e);
}
function Vn(i) {
  return b(i.target) ? i.srcElement || null : (e = i.target) != null && e.shadowRoot ? i.composedPath()[0] || null : i.target || null;
  var e;
}
var Hi = ["a", "button", "form", "input", "select", "textarea", "label"];
function Xn(i, e) {
  if (b(e)) return !0;
  var t, r = function(n) {
    if (e.some((o) => n.matches(o))) return { v: !0 };
  };
  for (var s of i) if (t = r(s)) return t.v;
  return !1;
}
function Jn(i) {
  var e = i.parentNode;
  return !(!e || !Pr(e)) && e;
}
var Ms = [".ph-no-rageclick", ".ph-no-capture"], qi = (i) => !i || Ke(i, "html") || !Pr(i), Kn = (i, e) => {
  if (!f || qi(i)) return { parentIsUsefulElement: !1, targetElementList: [] };
  for (var t = !1, r = [i], s = i; s.parentNode && !Ke(s, "body"); ) if (zn(s.parentNode)) r.push(s.parentNode.host), s = s.parentNode.host;
  else {
    var n = Jn(s);
    if (!n) break;
    if (e || Hi.indexOf(n.tagName.toLowerCase()) > -1) t = !0;
    else {
      var o = f.getComputedStyle(n);
      o && o.getPropertyValue("cursor") === "pointer" && (t = !0);
    }
    r.push(n), s = n;
  }
  return { parentIsUsefulElement: t, targetElementList: r };
};
function rl(i, e, t, r, s) {
  var n, o, a, l;
  if (t === void 0 && (t = void 0), !f || qi(i) || (n = t) != null && n.url_allowlist && !$s(t.url_allowlist) || (o = t) != null && o.url_ignorelist && $s(t.url_ignorelist)) return !1;
  if ((a = t) != null && a.dom_event_allowlist) {
    var u = t.dom_event_allowlist;
    if (u && !u.some((g) => e.type === g)) return !1;
  }
  var { parentIsUsefulElement: c, targetElementList: d } = Kn(i, r);
  if (!function(g, v) {
    var _ = v == null ? void 0 : v.element_allowlist;
    if (b(_)) return !0;
    var w, $ = function(T) {
      if (_.some((y) => T.tagName.toLowerCase() === y)) return { v: !0 };
    };
    for (var I of g) if (w = $(I)) return w.v;
    return !1;
  }(d, t) || !Xn(d, (l = t) == null ? void 0 : l.css_selector_allowlist)) return !1;
  var h = f.getComputedStyle(i);
  if (h && h.getPropertyValue("cursor") === "pointer" && e.type === "click") return !0;
  var p = i.tagName.toLowerCase();
  switch (p) {
    case "html":
      return !1;
    case "form":
      return (s || ["submit"]).indexOf(e.type) >= 0;
    case "input":
    case "select":
    case "textarea":
      return (s || ["change", "click"]).indexOf(e.type) >= 0;
    default:
      return c ? (s || ["click"]).indexOf(e.type) >= 0 : (s || ["click"]).indexOf(e.type) >= 0 && (Hi.indexOf(p) > -1 || i.getAttribute("contenteditable") === "true");
  }
}
function mi(i) {
  for (var e = i; e.parentNode && !Ke(e, "body"); e = e.parentNode) {
    var t = gr(e);
    if (D(t, "ph-sensitive") || D(t, "ph-no-capture")) return !1;
  }
  if (D(gr(i), "ph-include")) return !0;
  var r = i.type || "";
  if (Z(r)) switch (r.toLowerCase()) {
    case "hidden":
    case "password":
      return !1;
  }
  var s = i.name || i.id || "";
  return !(Z(s) && /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, "")));
}
function Zn(i) {
  return !!(Ke(i, "input") && !["button", "checkbox", "submit", "reset"].includes(i.type) || Ke(i, "select") || Ke(i, "textarea") || i.getAttribute("contenteditable") === "true");
}
var Qn = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", il = new RegExp("^(?:" + Qn + ")$"), sl = new RegExp(Qn), eo = "\\d{3}-?\\d{2}-?\\d{4}", nl = new RegExp("^(" + eo + ")$"), ol = new RegExp("(" + eo + ")");
function _t(i, e) {
  return e === void 0 && (e = !0), !(q(i) || Z(i) && (i = Rr(i), (e ? il : sl).test((i || "").replace(/[- ]/g, "")) || (e ? nl : ol).test(i)));
}
function to(i) {
  var e = Cr(i);
  return _t(e = (e + " " + ro(i)).trim()) ? e : "";
}
function ro(i) {
  var e = "";
  return i && i.childNodes && i.childNodes.length && z(i.childNodes, function(t) {
    var r;
    if (t && ((r = t.tagName) == null ? void 0 : r.toLowerCase()) === "span") try {
      var s = Cr(t);
      e = (e + " " + s).trim(), t.childNodes && t.childNodes.length && (e = (e + " " + ro(t)).trim());
    } catch (n) {
      k.error("[AutoCapture]", n);
    }
  }), e;
}
function al(i) {
  return function(e) {
    var t = e.map((r) => {
      var s, n, o = "";
      if (r.tag_name && (o += r.tag_name), r.attr_class) for (var a of (r.attr_class.sort(), r.attr_class)) o += "." + a.replace(/"/g, "");
      var l = E({}, r.text ? { text: r.text } : {}, { "nth-child": (s = r.nth_child) !== null && s !== void 0 ? s : 0, "nth-of-type": (n = r.nth_of_type) !== null && n !== void 0 ? n : 0 }, r.href ? { href: r.href } : {}, r.attr_id ? { attr_id: r.attr_id } : {}, r.attributes), u = {};
      return or(l).sort((c, d) => {
        var [h] = c, [p] = d;
        return h.localeCompare(p);
      }).forEach((c) => {
        var [d, h] = c;
        return u[Ls(d.toString())] = Ls(h.toString());
      }), o += ":", o += or(u).map((c) => {
        var [d, h] = c;
        return d + '="' + h + '"';
      }).join("");
    });
    return t.join(";");
  }(function(e) {
    return e.map((t) => {
      var r, s, n = { text: (r = t.$el_text) == null ? void 0 : r.slice(0, 400), tag_name: t.tag_name, href: (s = t.attr__href) == null ? void 0 : s.slice(0, 2048), attr_class: ll(t), attr_id: t.attr__id, nth_child: t.nth_child, nth_of_type: t.nth_of_type, attributes: {} };
      return or(t).filter((o) => {
        var [a] = o;
        return a.indexOf("attr__") === 0;
      }).forEach((o) => {
        var [a, l] = o;
        return n.attributes[a] = l;
      }), n;
    });
  }(i));
}
function Ls(i) {
  return i.replace(/"|\\"/g, '\\"');
}
function ll(i) {
  var e = i.attr__class;
  return e ? W(e) ? e : ji(e) : void 0;
}
class io {
  constructor() {
    this.clicks = [];
  }
  isRageClick(e, t, r) {
    var s = this.clicks[this.clicks.length - 1];
    if (s && Math.abs(e - s.x) + Math.abs(t - s.y) < 30 && r - s.timestamp < 1e3) {
      if (this.clicks.push({ x: e, y: t, timestamp: r }), this.clicks.length === 3) return !0;
    } else this.clicks = [{ x: e, y: t, timestamp: r }];
    return !1;
  }
}
var Gr = "$copy_autocapture", Be = function(i) {
  return i.GZipJS = "gzip-js", i.Base64 = "base64", i;
}({}), ul = ["localhost", "127.0.0.1"], mt = (i) => {
  var e = x == null ? void 0 : x.createElement("a");
  return b(e) ? null : (e.href = i, e);
}, cl = function(i, e) {
  var t, r;
  e === void 0 && (e = "&");
  var s = [];
  return z(i, function(n, o) {
    b(n) || b(o) || o === "undefined" || (t = encodeURIComponent(((a) => a instanceof File)(n) ? n.name : n.toString()), r = encodeURIComponent(o), s[s.length] = r + "=" + t);
  }), s.join(e);
}, _r = function(i, e) {
  for (var t, r = ((i.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++) {
    var n = r[s].split("=");
    if (n[0] === e) {
      t = n;
      break;
    }
  }
  if (!W(t) || t.length < 2) return "";
  var o = t[1];
  try {
    o = decodeURIComponent(o);
  } catch {
    k.error("Skipping decoding for malformed query param: " + o);
  }
  return o.replace(/\+/g, " ");
}, Ui = function(i, e, t) {
  if (!i || !e || !e.length) return i;
  for (var r = i.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], u = (a || "").split("&"), c = [], d = 0; d < u.length; d++) {
    var h = u[d].split("=");
    W(h) && (e.includes(h[0]) ? c.push(h[0] + "=" + t) : c.push(u[d]));
  }
  var p = l;
  return a != null && (p += "?" + c.join("&")), n != null && (p += "#" + n), p;
}, mr = function(i, e) {
  var t = i.match(new RegExp(e + "=([^&]*)"));
  return t ? t[1] : null;
}, Ns = te("[AutoCapture]");
function Yr(i, e) {
  return e.length > i ? e.slice(0, i) + "..." : e;
}
function dl(i) {
  if (i.previousElementSibling) return i.previousElementSibling;
  var e = i;
  do
    e = e.previousSibling;
  while (e && !Pr(e));
  return e;
}
function hl(i, e, t, r) {
  var s = i.tagName.toLowerCase(), n = { tag_name: s };
  Hi.indexOf(s) > -1 && !t && (s.toLowerCase() === "a" || s.toLowerCase() === "button" ? n.$el_text = Yr(1024, to(i)) : n.$el_text = Yr(1024, Cr(i)));
  var o = gr(i);
  o.length > 0 && (n.classes = o.filter(function(c) {
    return c !== "";
  })), z(i.attributes, function(c) {
    var d;
    if ((!Zn(i) || ["name", "id", "class", "aria-label"].indexOf(c.name) !== -1) && (r == null || !r.includes(c.name)) && !e && _t(c.value) && (d = c.name, !Z(d) || d.substring(0, 10) !== "_ngcontent" && d.substring(0, 7) !== "_nghost")) {
      var h = c.value;
      c.name === "class" && (h = ji(h).join(" ")), n["attr__" + c.name] = Yr(1024, h);
    }
  });
  for (var a = 1, l = 1, u = i; u = dl(u); ) a++, u.tagName === i.tagName && l++;
  return n.nth_child = a, n.nth_of_type = l, n;
}
function pl(i, e) {
  for (var t, r, { e: s, maskAllElementAttributes: n, maskAllText: o, elementAttributeIgnoreList: a, elementsChainAsString: l } = e, u = [i], c = i; c.parentNode && !Ke(c, "body"); ) zn(c.parentNode) ? (u.push(c.parentNode.host), c = c.parentNode.host) : (u.push(c.parentNode), c = c.parentNode);
  var d, h = [], p = {}, g = !1, v = !1;
  if (z(u, (T) => {
    var y = mi(T);
    T.tagName.toLowerCase() === "a" && (g = T.getAttribute("href"), g = y && g && _t(g) && g), D(gr(T), "ph-no-capture") && (v = !0), h.push(hl(T, n, o, a));
    var X = function(ie) {
      if (!mi(ie)) return {};
      var j = {};
      return z(ie.attributes, function(ge) {
        if (ge.name && ge.name.indexOf("data-ph-capture-attribute") === 0) {
          var se = ge.name.replace("data-ph-capture-attribute-", ""), le = ge.value;
          se && le && _t(le) && (j[se] = le);
        }
      }), j;
    }(T);
    Q(p, X);
  }), v) return { props: {}, explicitNoCapture: v };
  if (o || (i.tagName.toLowerCase() === "a" || i.tagName.toLowerCase() === "button" ? h[0].$el_text = to(i) : h[0].$el_text = Cr(i)), g) {
    var _, w;
    h[0].attr__href = g;
    var $ = (_ = mt(g)) == null ? void 0 : _.host, I = f == null || (w = f.location) == null ? void 0 : w.host;
    $ && I && $ !== I && (d = g);
  }
  return { props: Q({ $event_type: s.type, $ce_version: 1 }, l ? {} : { $elements: h }, { $elements_chain: al(h) }, (t = h[0]) != null && t.$el_text ? { $el_text: (r = h[0]) == null ? void 0 : r.$el_text } : {}, d && s.type === "click" ? { $external_click_url: d } : {}, p) };
}
class fl {
  constructor(e) {
    this.C = !1, this.M = null, this.rageclicks = new io(), this.O = !1, this.instance = e, this.F = null;
  }
  get A() {
    var e, t, r = K(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
    return r.url_allowlist = (e = r.url_allowlist) == null ? void 0 : e.map((s) => new RegExp(s)), r.url_ignorelist = (t = r.url_ignorelist) == null ? void 0 : t.map((s) => new RegExp(s)), r;
  }
  D() {
    if (this.isBrowserSupported()) {
      if (f && x) {
        var e = (r) => {
          r = r || (f == null ? void 0 : f.event);
          try {
            this.j(r);
          } catch (s) {
            Ns.error("Failed to capture event", s);
          }
        };
        if (J(x, "submit", e, { capture: !0 }), J(x, "change", e, { capture: !0 }), J(x, "click", e, { capture: !0 }), this.A.capture_copied_text) {
          var t = (r) => {
            r = r || (f == null ? void 0 : f.event), this.j(r, Gr);
          };
          J(x, "copy", t, { capture: !0 }), J(x, "cut", t, { capture: !0 });
        }
      }
    } else Ns.info("Disabling Automatic Event Collection because this browser is not supported");
  }
  startIfEnabled() {
    this.isEnabled && !this.C && (this.D(), this.C = !0);
  }
  onRemoteConfig(e) {
    e.elementsChainAsString && (this.O = e.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({ [Es]: !!e.autocapture_opt_out }), this.M = !!e.autocapture_opt_out, this.startIfEnabled();
  }
  setElementSelectors(e) {
    this.F = e;
  }
  getElementSelectors(e) {
    var t, r = [];
    return (t = this.F) == null || t.forEach((s) => {
      var n = x == null ? void 0 : x.querySelectorAll(s);
      n == null || n.forEach((o) => {
        e === o && r.push(s);
      });
    }), r;
  }
  get isEnabled() {
    var e, t, r = (e = this.instance.persistence) == null ? void 0 : e.props[Es], s = this.M;
    if (Ye(s) && !Ae(r) && !this.instance.L()) return !1;
    var n = (t = this.M) !== null && t !== void 0 ? t : !!r;
    return !!this.instance.config.autocapture && !n;
  }
  j(e, t) {
    if (t === void 0 && (t = "$autocapture"), this.isEnabled) {
      var r, s = Vn(e);
      Yn(s) && (s = s.parentNode || null), t === "$autocapture" && e.type === "click" && e instanceof MouseEvent && this.instance.config.rageclick && (r = this.rageclicks) != null && r.isRageClick(e.clientX, e.clientY, (/* @__PURE__ */ new Date()).getTime()) && function(h, p) {
        if (!f || qi(h)) return !1;
        var g, v;
        if ((g = Ae(p) ? !!p && Ms : (v = p == null ? void 0 : p.css_selector_ignorelist) !== null && v !== void 0 ? v : Ms) === !1) return !1;
        var { targetElementList: _ } = Kn(h, !1);
        return !Xn(_, g);
      }(s, this.instance.config.rageclick) && this.j(e, "$rageclick");
      var n = t === Gr;
      if (s && rl(s, e, this.A, n, n ? ["copy", "cut"] : void 0)) {
        var { props: o, explicitNoCapture: a } = pl(s, { e, maskAllElementAttributes: this.instance.config.mask_all_element_attributes, maskAllText: this.instance.config.mask_all_text, elementAttributeIgnoreList: this.A.element_attribute_ignorelist, elementsChainAsString: this.O });
        if (a) return !1;
        var l = this.getElementSelectors(s);
        if (l && l.length > 0 && (o.$element_selectors = l), t === Gr) {
          var u, c = Wn(f == null || (u = f.getSelection()) == null ? void 0 : u.toString()), d = e.type || "clipboard";
          if (!c) return !1;
          o.$selected_content = c, o.$copy_type = d;
        }
        return this.instance.capture(t, o), !0;
      }
    }
  }
  isBrowserSupported() {
    return Ie(x == null ? void 0 : x.querySelectorAll);
  }
}
Math.trunc || (Math.trunc = function(i) {
  return i < 0 ? Math.ceil(i) : Math.floor(i);
}), Number.isInteger || (Number.isInteger = function(i) {
  return pe(i) && isFinite(i) && Math.floor(i) === i;
});
var Ds = "0123456789abcdef";
class yr {
  constructor(e) {
    if (this.bytes = e, e.length !== 16) throw new TypeError("not 128-bit length");
  }
  static fromFieldsV7(e, t, r, s) {
    if (!Number.isInteger(e) || !Number.isInteger(t) || !Number.isInteger(r) || !Number.isInteger(s) || e < 0 || t < 0 || r < 0 || s < 0 || e > 281474976710655 || t > 4095 || r > 1073741823 || s > 4294967295) throw new RangeError("invalid field value");
    var n = new Uint8Array(16);
    return n[0] = e / Math.pow(2, 40), n[1] = e / Math.pow(2, 32), n[2] = e / Math.pow(2, 24), n[3] = e / Math.pow(2, 16), n[4] = e / Math.pow(2, 8), n[5] = e, n[6] = 112 | t >>> 8, n[7] = t, n[8] = 128 | r >>> 24, n[9] = r >>> 16, n[10] = r >>> 8, n[11] = r, n[12] = s >>> 24, n[13] = s >>> 16, n[14] = s >>> 8, n[15] = s, new yr(n);
  }
  toString() {
    for (var e = "", t = 0; t < this.bytes.length; t++) e = e + Ds.charAt(this.bytes[t] >>> 4) + Ds.charAt(15 & this.bytes[t]), t !== 3 && t !== 5 && t !== 7 && t !== 9 || (e += "-");
    if (e.length !== 36) throw new Error("Invalid UUIDv7 was generated");
    return e;
  }
  clone() {
    return new yr(this.bytes.slice(0));
  }
  equals(e) {
    return this.compareTo(e) === 0;
  }
  compareTo(e) {
    for (var t = 0; t < 16; t++) {
      var r = this.bytes[t] - e.bytes[t];
      if (r !== 0) return Math.sign(r);
    }
    return 0;
  }
}
class vl {
  constructor() {
    this.N = 0, this.U = 0, this.q = new gl();
  }
  generate() {
    var e = this.generateOrAbort();
    if (b(e)) {
      this.N = 0;
      var t = this.generateOrAbort();
      if (b(t)) throw new Error("Could not generate UUID after timestamp reset");
      return t;
    }
    return e;
  }
  generateOrAbort() {
    var e = Date.now();
    if (e > this.N) this.N = e, this.B();
    else {
      if (!(e + 1e4 > this.N)) return;
      this.U++, this.U > 4398046511103 && (this.N++, this.B());
    }
    return yr.fromFieldsV7(this.N, Math.trunc(this.U / Math.pow(2, 30)), this.U & Math.pow(2, 30) - 1, this.q.nextUint32());
  }
  B() {
    this.U = 1024 * this.q.nextUint32() + (1023 & this.q.nextUint32());
  }
}
var js, so = (i) => {
  if (typeof UUIDV7_DENY_WEAK_RNG < "u" && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
  for (var e = 0; e < i.length; e++) i[e] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
  return i;
};
f && !b(f.crypto) && crypto.getRandomValues && (so = (i) => crypto.getRandomValues(i));
class gl {
  constructor() {
    this.H = new Uint32Array(8), this.W = 1 / 0;
  }
  nextUint32() {
    return this.W >= this.H.length && (so(this.H), this.W = 0), this.H[this.W++];
  }
}
var Xe = () => _l().toString(), _l = () => (js || (js = new vl())).generate(), xt = "", ml = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function yl(i, e) {
  if (e) {
    var t = function(s, n) {
      if (n === void 0 && (n = x), xt) return xt;
      if (!n || ["localhost", "127.0.0.1"].includes(s)) return "";
      for (var o = s.split("."), a = Math.min(o.length, 8), l = "dmn_chk_" + Xe(); !xt && a--; ) {
        var u = o.slice(a).join("."), c = l + "=1;domain=." + u + ";path=/";
        n.cookie = c + ";max-age=3", n.cookie.includes(l) && (n.cookie = c + ";max-age=0", xt = u);
      }
      return xt;
    }(i);
    if (!t) {
      var r = ((s) => {
        var n = s.match(ml);
        return n ? n[0] : "";
      })(i);
      r !== t && k.info("Warning: cookie subdomain discovery mismatch", r, t), t = r;
    }
    return t ? "; domain=." + t : "";
  }
  return "";
}
var Me = { G: () => !!x, V: function(i) {
  k.error("cookieStore error: " + i);
}, J: function(i) {
  if (x) {
    try {
      for (var e = i + "=", t = x.cookie.split(";").filter((n) => n.length), r = 0; r < t.length; r++) {
        for (var s = t[r]; s.charAt(0) == " "; ) s = s.substring(1, s.length);
        if (s.indexOf(e) === 0) return decodeURIComponent(s.substring(e.length, s.length));
      }
    } catch {
    }
    return null;
  }
}, K: function(i) {
  var e;
  try {
    e = JSON.parse(Me.J(i)) || {};
  } catch {
  }
  return e;
}, Y: function(i, e, t, r, s) {
  if (x) try {
    var n = "", o = "", a = yl(x.location.hostname, r);
    if (t) {
      var l = /* @__PURE__ */ new Date();
      l.setTime(l.getTime() + 24 * t * 60 * 60 * 1e3), n = "; expires=" + l.toUTCString();
    }
    s && (o = "; secure");
    var u = i + "=" + encodeURIComponent(JSON.stringify(e)) + n + "; SameSite=Lax; path=/" + a + o;
    return u.length > 3686.4 && k.warn("cookieStore warning: large cookie, len=" + u.length), x.cookie = u, u;
  } catch {
    return;
  }
}, X: function(i, e) {
  if (x != null && x.cookie) try {
    Me.Y(i, "", -1, e);
  } catch {
    return;
  }
} }, zr = null, ee = { G: function() {
  if (!Ye(zr)) return zr;
  var i = !0;
  if (b(f)) i = !1;
  else try {
    var e = "__mplssupport__";
    ee.Y(e, "xyz"), ee.J(e) !== '"xyz"' && (i = !1), ee.X(e);
  } catch {
    i = !1;
  }
  return i || k.error("localStorage unsupported; falling back to cookie store"), zr = i, i;
}, V: function(i) {
  k.error("localStorage error: " + i);
}, J: function(i) {
  try {
    return f == null ? void 0 : f.localStorage.getItem(i);
  } catch (e) {
    ee.V(e);
  }
  return null;
}, K: function(i) {
  try {
    return JSON.parse(ee.J(i)) || {};
  } catch {
  }
  return null;
}, Y: function(i, e) {
  try {
    f == null || f.localStorage.setItem(i, JSON.stringify(e));
  } catch (t) {
    ee.V(t);
  }
}, X: function(i) {
  try {
    f == null || f.localStorage.removeItem(i);
  } catch (e) {
    ee.V(e);
  }
} }, bl = ["distinct_id", hr, At, vr, fr], Zt = E({}, ee, { K: function(i) {
  try {
    var e = {};
    try {
      e = Me.K(i) || {};
    } catch {
    }
    var t = Q(e, JSON.parse(ee.J(i) || "{}"));
    return ee.Y(i, t), t;
  } catch {
  }
  return null;
}, Y: function(i, e, t, r, s, n) {
  try {
    ee.Y(i, e, void 0, void 0, n);
    var o = {};
    bl.forEach((a) => {
      e[a] && (o[a] = e[a]);
    }), Object.keys(o).length && Me.Y(i, o, t, r, s, n);
  } catch (a) {
    ee.V(a);
  }
}, X: function(i, e) {
  try {
    f == null || f.localStorage.removeItem(i), Me.X(i, e);
  } catch (t) {
    ee.V(t);
  }
} }), Qt = {}, wl = { G: function() {
  return !0;
}, V: function(i) {
  k.error("memoryStorage error: " + i);
}, J: function(i) {
  return Qt[i] || null;
}, K: function(i) {
  return Qt[i] || null;
}, Y: function(i, e) {
  Qt[i] = e;
}, X: function(i) {
  delete Qt[i];
} }, et = null, ae = { G: function() {
  if (!Ye(et)) return et;
  if (et = !0, b(f)) et = !1;
  else try {
    var i = "__support__";
    ae.Y(i, "xyz"), ae.J(i) !== '"xyz"' && (et = !1), ae.X(i);
  } catch {
    et = !1;
  }
  return et;
}, V: function(i) {
  k.error("sessionStorage error: ", i);
}, J: function(i) {
  try {
    return f == null ? void 0 : f.sessionStorage.getItem(i);
  } catch (e) {
    ae.V(e);
  }
  return null;
}, K: function(i) {
  try {
    return JSON.parse(ae.J(i)) || null;
  } catch {
  }
  return null;
}, Y: function(i, e) {
  try {
    f == null || f.sessionStorage.setItem(i, JSON.stringify(e));
  } catch (t) {
    ae.V(t);
  }
}, X: function(i) {
  try {
    f == null || f.sessionStorage.removeItem(i);
  } catch (e) {
    ae.V(e);
  }
} }, He = function(i) {
  return i[i.PENDING = -1] = "PENDING", i[i.DENIED = 0] = "DENIED", i[i.GRANTED = 1] = "GRANTED", i;
}({});
class El {
  constructor(e) {
    this._instance = e;
  }
  get A() {
    return this._instance.config;
  }
  get consent() {
    return this.Z() ? He.DENIED : this.tt;
  }
  isOptedOut() {
    return this.A.cookieless_mode === "always" || this.consent === He.DENIED || this.consent === He.PENDING && (this.A.opt_out_capturing_by_default || this.A.cookieless_mode === "on_reject");
  }
  isOptedIn() {
    return !this.isOptedOut();
  }
  isExplicitlyOptedOut() {
    return this.consent === He.DENIED;
  }
  optInOut(e) {
    this.it.Y(this.et, e ? 1 : 0, this.A.cookie_expiration, this.A.cross_subdomain_cookie, this.A.secure_cookie);
  }
  reset() {
    this.it.X(this.et, this.A.cross_subdomain_cookie);
  }
  get et() {
    var { token: e, opt_out_capturing_cookie_prefix: t, consent_persistence_name: r } = this._instance.config;
    return r || (t ? t + e : "__ph_opt_in_out_" + e);
  }
  get tt() {
    var e = this.it.J(this.et);
    return Ur(e) ? He.GRANTED : D(Ia, e) ? He.DENIED : He.PENDING;
  }
  get it() {
    if (!this.rt) {
      var e = this.A.opt_out_capturing_persistence_type;
      this.rt = e === "localStorage" ? ee : Me;
      var t = e === "localStorage" ? Me : ee;
      t.J(this.et) && (this.rt.J(this.et) || this.optInOut(Ur(t.J(this.et))), t.X(this.et, this.A.cross_subdomain_cookie));
    }
    return this.rt;
  }
  Z() {
    return !!this.A.respect_dnt && !!qn([xe == null ? void 0 : xe.doNotTrack, xe == null ? void 0 : xe.msDoNotTrack, C.doNotTrack], (e) => Ur(e));
  }
}
var er = te("[Dead Clicks]"), Sl = () => !0, kl = (i) => {
  var e, t = !((e = i.instance.persistence) == null || !e.get_property(Bn)), r = i.instance.config.capture_dead_clicks;
  return Ae(r) ? r : t;
};
class no {
  get lazyLoadedDeadClicksAutocapture() {
    return this.st;
  }
  constructor(e, t, r) {
    this.instance = e, this.isEnabled = t, this.onCapture = r, this.startIfEnabled();
  }
  onRemoteConfig(e) {
    this.instance.persistence && this.instance.persistence.register({ [Bn]: e == null ? void 0 : e.captureDeadClicks }), this.startIfEnabled();
  }
  startIfEnabled() {
    this.isEnabled(this) && this.nt(() => {
      this.ot();
    });
  }
  nt(e) {
    var t, r;
    (t = C.__PosthogExtensions__) != null && t.initDeadClicksAutocapture && e(), (r = C.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this.instance, "dead-clicks-autocapture", (s) => {
      s ? er.error("failed to load script", s) : e();
    });
  }
  ot() {
    var e;
    if (x) {
      if (!this.st && (e = C.__PosthogExtensions__) != null && e.initDeadClicksAutocapture) {
        var t = K(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
        t.__onCapture = this.onCapture, this.st = C.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, t), this.st.start(x), er.info("starting...");
      }
    } else er.error("`document` not found. Cannot start.");
  }
  stop() {
    this.st && (this.st.stop(), this.st = void 0, er.info("stopping..."));
  }
}
var Rt = te("[ExceptionAutocapture]");
class xl {
  constructor(e) {
    var t, r, s;
    this.lt = () => {
      var n;
      if (f && this.isEnabled && (n = C.__PosthogExtensions__) != null && n.errorWrappingFunctions) {
        var o = C.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, a = C.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, l = C.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
        try {
          !this.ht && this.A.capture_unhandled_errors && (this.ht = o(this.captureException.bind(this))), !this.ut && this.A.capture_unhandled_rejections && (this.ut = a(this.captureException.bind(this))), !this.dt && this.A.capture_console_errors && (this.dt = l(this.captureException.bind(this)));
        } catch (u) {
          Rt.error("failed to start", u), this.vt();
        }
      }
    }, this._instance = e, this.ct = !((t = this._instance.persistence) == null || !t.props[Ss]), this.A = this.ft(), this.gt = new Nn({ refillRate: (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) !== null && r !== void 0 ? r : 1, bucketSize: (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) !== null && s !== void 0 ? s : 10, refillInterval: 1e4, I: Rt }), this.startIfEnabled();
  }
  ft() {
    var e = this._instance.config.capture_exceptions, t = { capture_unhandled_errors: !1, capture_unhandled_rejections: !1, capture_console_errors: !1 };
    return K(e) ? t = E({}, t, e) : (b(e) ? this.ct : e) && (t = E({}, t, { capture_unhandled_errors: !0, capture_unhandled_rejections: !0 })), t;
  }
  get isEnabled() {
    return this.A.capture_console_errors || this.A.capture_unhandled_errors || this.A.capture_unhandled_rejections;
  }
  startIfEnabled() {
    this.isEnabled && (Rt.info("enabled"), this.nt(this.lt));
  }
  nt(e) {
    var t, r;
    (t = C.__PosthogExtensions__) != null && t.errorWrappingFunctions && e(), (r = C.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, "exception-autocapture", (s) => {
      if (s) return Rt.error("failed to load script", s);
      e();
    });
  }
  vt() {
    var e, t, r;
    (e = this.ht) == null || e.call(this), this.ht = void 0, (t = this.ut) == null || t.call(this), this.ut = void 0, (r = this.dt) == null || r.call(this), this.dt = void 0;
  }
  onRemoteConfig(e) {
    var t = e.autocaptureExceptions;
    this.ct = !!t || !1, this.A = this.ft(), this._instance.persistence && this._instance.persistence.register({ [Ss]: this.ct }), this.startIfEnabled();
  }
  captureException(e) {
    var t, r, s = (t = e == null || (r = e.$exception_list) == null || (r = r[0]) == null ? void 0 : r.type) !== null && t !== void 0 ? t : "Exception";
    this.gt.consumeRateLimit(s) ? Rt.info("Skipping exception capture because of client rate limiting.", { exception: s }) : this._instance.exceptions.sendExceptionEvent(e);
  }
}
function Hs(i, e, t) {
  try {
    if (!(e in i)) return () => {
    };
    var r = i[e], s = t(r);
    return Ie(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, { __posthog_wrapped__: { enumerable: !1, value: !0 } })), i[e] = s, () => {
      i[e] = r;
    };
  } catch {
    return () => {
    };
  }
}
class Rl {
  constructor(e) {
    var t;
    this._instance = e, this._t = (f == null || (t = f.location) == null ? void 0 : t.pathname) || "";
  }
  get isEnabled() {
    return this._instance.config.capture_pageview === "history_change";
  }
  startIfEnabled() {
    this.isEnabled && (k.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
  }
  stop() {
    this.yt && this.yt(), this.yt = void 0, k.info("History API monitoring stopped");
  }
  monitorHistoryChanges() {
    var e, t;
    if (f && f.history) {
      var r = this;
      (e = f.history.pushState) != null && e.__posthog_wrapped__ || Hs(f.history, "pushState", (s) => function(n, o, a) {
        s.call(this, n, o, a), r.bt("pushState");
      }), (t = f.history.replaceState) != null && t.__posthog_wrapped__ || Hs(f.history, "replaceState", (s) => function(n, o, a) {
        s.call(this, n, o, a), r.bt("replaceState");
      }), this.wt();
    }
  }
  bt(e) {
    try {
      var t, r = f == null || (t = f.location) == null ? void 0 : t.pathname;
      if (!r) return;
      r !== this._t && this.isEnabled && this._instance.capture("$pageview", { navigation_type: e }), this._t = r;
    } catch (s) {
      k.error("Error capturing " + e + " pageview", s);
    }
  }
  wt() {
    if (!this.yt) {
      var e = () => {
        this.bt("popstate");
      };
      J(f, "popstate", e), this.yt = () => {
        f && f.removeEventListener("popstate", e);
      };
    }
  }
}
function br(i) {
  var e, t;
  return ((e = JSON.stringify(i, (t = [], function(r, s) {
    if (K(s)) {
      for (; t.length > 0 && t[t.length - 1] !== this; ) t.pop();
      return t.includes(s) ? "[Circular]" : (t.push(s), s);
    }
    return s;
  }))) == null ? void 0 : e.length) || 0;
}
function yi(i, e) {
  if (e === void 0 && (e = 66060288e-1), i.size >= e && i.data.length > 1) {
    var t = Math.floor(i.data.length / 2), r = i.data.slice(0, t), s = i.data.slice(t);
    return [yi({ size: br(r), data: r, sessionId: i.sessionId, windowId: i.windowId }), yi({ size: br(s), data: s, sessionId: i.sessionId, windowId: i.windowId })].flatMap((n) => n);
  }
  return [i];
}
var qe = ((i) => (i[i.DomContentLoaded = 0] = "DomContentLoaded", i[i.Load = 1] = "Load", i[i.FullSnapshot = 2] = "FullSnapshot", i[i.IncrementalSnapshot = 3] = "IncrementalSnapshot", i[i.Meta = 4] = "Meta", i[i.Custom = 5] = "Custom", i[i.Plugin = 6] = "Plugin", i))(qe || {}), Oe = ((i) => (i[i.Mutation = 0] = "Mutation", i[i.MouseMove = 1] = "MouseMove", i[i.MouseInteraction = 2] = "MouseInteraction", i[i.Scroll = 3] = "Scroll", i[i.ViewportResize = 4] = "ViewportResize", i[i.Input = 5] = "Input", i[i.TouchMove = 6] = "TouchMove", i[i.MediaInteraction = 7] = "MediaInteraction", i[i.StyleSheetRule = 8] = "StyleSheetRule", i[i.CanvasMutation = 9] = "CanvasMutation", i[i.Font = 10] = "Font", i[i.Log = 11] = "Log", i[i.Drag = 12] = "Drag", i[i.StyleDeclaration = 13] = "StyleDeclaration", i[i.Selection = 14] = "Selection", i[i.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", i[i.CustomElement = 16] = "CustomElement", i))(Oe || {}), bi = "[SessionRecording]", wi = "redacted", tr = { initiatorTypes: ["audio", "beacon", "body", "css", "early-hint", "embed", "fetch", "frame", "iframe", "icon", "image", "img", "input", "link", "navigation", "object", "ping", "script", "track", "video", "xmlhttprequest"], maskRequestFn: (i) => i, recordHeaders: !1, recordBody: !1, recordInitialRequests: !1, recordPerformance: !1, performanceEntryTypeToObserve: ["first-input", "navigation", "paint", "resource"], payloadSizeLimitBytes: 1e6, payloadHostDenyList: [".lr-ingest.io", ".ingest.sentry.io", ".clarity.ms", "analytics.google.com", "bam.nr-data.net"] }, Tl = ["authorization", "x-forwarded-for", "authorization", "cookie", "set-cookie", "x-api-key", "x-real-ip", "remote-addr", "forwarded", "proxy-authorization", "x-csrf-token", "x-csrftoken", "x-xsrf-token"], Il = ["password", "secret", "passwd", "api_key", "apikey", "auth", "credentials", "mysql_pwd", "privatekey", "private_key", "token"], Pl = ["/s/", "/e/", "/i/"];
function qs(i, e, t, r) {
  if (q(i)) return i;
  var s = (e == null ? void 0 : e["content-length"]) || function(n) {
    return new Blob([n]).size;
  }(i);
  return Z(s) && (s = parseInt(s)), s > t ? bi + " " + r + " body too large to record (" + s + " bytes)" : i;
}
function Us(i, e) {
  if (q(i)) return i;
  var t = i;
  return _t(t, !1) || (t = bi + " " + e + " body " + wi), z(Il, (r) => {
    var s, n;
    (s = t) != null && s.length && ((n = t) == null ? void 0 : n.indexOf(r)) !== -1 && (t = bi + " " + e + " body " + wi + " as might contain: " + r);
  }), t;
}
var Cl = (i, e) => {
  var t, r, s, n = { payloadSizeLimitBytes: tr.payloadSizeLimitBytes, performanceEntryTypeToObserve: [...tr.performanceEntryTypeToObserve], payloadHostDenyList: [...e.payloadHostDenyList || [], ...tr.payloadHostDenyList] }, o = i.session_recording.recordHeaders !== !1 && e.recordHeaders, a = i.session_recording.recordBody !== !1 && e.recordBody, l = i.capture_performance !== !1 && e.recordPerformance, u = (t = n, s = Math.min(1e6, (r = t.payloadSizeLimitBytes) !== null && r !== void 0 ? r : 1e6), (h) => (h != null && h.requestBody && (h.requestBody = qs(h.requestBody, h.requestHeaders, s, "Request")), h != null && h.responseBody && (h.responseBody = qs(h.responseBody, h.responseHeaders, s, "Response")), h)), c = (h) => {
    return u(((v, _) => {
      var w, $ = mt(v.name), I = _.indexOf("http") === 0 ? (w = mt(_)) == null ? void 0 : w.pathname : _;
      I === "/" && (I = "");
      var T = $ == null ? void 0 : $.pathname.replace(I || "", "");
      if (!($ && T && Pl.some((y) => T.indexOf(y) === 0))) return v;
    })((g = (p = h).requestHeaders, q(g) || z(Object.keys(g ?? {}), (v) => {
      Tl.includes(v.toLowerCase()) && (g[v] = wi);
    }), p), i.api_host));
    var p, g;
  }, d = Ie(i.session_recording.maskNetworkRequestFn);
  return d && Ie(i.session_recording.maskCapturedNetworkRequestFn) && k.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), d && (i.session_recording.maskCapturedNetworkRequestFn = (h) => {
    var p = i.session_recording.maskNetworkRequestFn({ url: h.name });
    return E({}, h, { name: p == null ? void 0 : p.url });
  }), n.maskRequestFn = Ie(i.session_recording.maskCapturedNetworkRequestFn) ? (h) => {
    var p, g = c(h);
    return g && (p = i.session_recording.maskCapturedNetworkRequestFn == null ? void 0 : i.session_recording.maskCapturedNetworkRequestFn(g)) !== null && p !== void 0 ? p : void 0;
  } : (h) => function(p) {
    if (!b(p)) return p.requestBody = Us(p.requestBody, "Request"), p.responseBody = Us(p.responseBody, "Response"), p;
  }(c(h)), E({}, tr, n, { recordHeaders: o, recordBody: a, recordPerformance: l, recordInitialRequests: l });
};
class Ol {
  constructor(e, t) {
    var r, s;
    t === void 0 && (t = {}), this.St = {}, this.kt = (n) => {
      if (!this.St[n]) {
        var o, a;
        this.St[n] = !0;
        var l = this.$t(n);
        (o = (a = this.i).onBlockedNode) == null || o.call(a, n, l);
      }
    }, this.xt = (n) => {
      var o = this.$t(n);
      if ((o == null ? void 0 : o.nodeName) !== "svg" && o instanceof Element) {
        var a = o.closest("svg");
        if (a) return [this._rrweb.mirror.getId(a), a];
      }
      return [n, o];
    }, this.$t = (n) => this._rrweb.mirror.getNode(n), this.Et = (n) => {
      var o, a, l, u, c, d, h, p;
      return ((o = (a = n.removes) == null ? void 0 : a.length) !== null && o !== void 0 ? o : 0) + ((l = (u = n.attributes) == null ? void 0 : u.length) !== null && l !== void 0 ? l : 0) + ((c = (d = n.texts) == null ? void 0 : d.length) !== null && c !== void 0 ? c : 0) + ((h = (p = n.adds) == null ? void 0 : p.length) !== null && h !== void 0 ? h : 0);
    }, this.throttleMutations = (n) => {
      if (n.type !== 3 || n.data.source !== 0) return n;
      var o = n.data, a = this.Et(o);
      o.attributes && (o.attributes = o.attributes.filter((u) => {
        var [c] = this.xt(u.id);
        return !this.gt.consumeRateLimit(c) && u;
      }));
      var l = this.Et(o);
      return l !== 0 || a === l ? n : void 0;
    }, this._rrweb = e, this.i = t, this.gt = new Nn({ bucketSize: (r = this.i.bucketSize) !== null && r !== void 0 ? r : 100, refillRate: (s = this.i.refillRate) !== null && s !== void 0 ? s : 10, refillInterval: 1e3, P: this.kt, I: k });
  }
}
var Pe = Uint8Array, Se = Uint16Array, yt = Uint32Array, Bi = new Pe([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), Gi = new Pe([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), Bs = new Pe([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), oo = function(i, e) {
  for (var t = new Se(31), r = 0; r < 31; ++r) t[r] = e += 1 << i[r - 1];
  var s = new yt(t[30]);
  for (r = 1; r < 30; ++r) for (var n = t[r]; n < t[r + 1]; ++n) s[n] = n - t[r] << 5 | r;
  return [t, s];
}, ao = oo(Bi, 2), Al = ao[0], Ei = ao[1];
Al[28] = 258, Ei[258] = 28;
for (var Gs = oo(Gi, 0)[1], lo = new Se(32768), V = 0; V < 32768; ++V) {
  var tt = (43690 & V) >>> 1 | (21845 & V) << 1;
  tt = (61680 & (tt = (52428 & tt) >>> 2 | (13107 & tt) << 2)) >>> 4 | (3855 & tt) << 4, lo[V] = ((65280 & tt) >>> 8 | (255 & tt) << 8) >>> 1;
}
var jt = function(i, e, t) {
  for (var r = i.length, s = 0, n = new Se(e); s < r; ++s) ++n[i[s] - 1];
  var o, a = new Se(e);
  for (s = 0; s < e; ++s) a[s] = a[s - 1] + n[s - 1] << 1;
  for (o = new Se(r), s = 0; s < r; ++s) o[s] = lo[a[i[s] - 1]++] >>> 15 - i[s];
  return o;
}, ot = new Pe(288);
for (V = 0; V < 144; ++V) ot[V] = 8;
for (V = 144; V < 256; ++V) ot[V] = 9;
for (V = 256; V < 280; ++V) ot[V] = 7;
for (V = 280; V < 288; ++V) ot[V] = 8;
var wr = new Pe(32);
for (V = 0; V < 32; ++V) wr[V] = 5;
var Fl = jt(ot, 9), $l = jt(wr, 5), uo = function(i) {
  return (i / 8 >> 0) + (7 & i && 1);
}, co = function(i, e, t) {
  (t == null || t > i.length) && (t = i.length);
  var r = new (i instanceof Se ? Se : i instanceof yt ? yt : Pe)(t - e);
  return r.set(i.subarray(e, t)), r;
}, De = function(i, e, t) {
  t <<= 7 & e;
  var r = e / 8 >> 0;
  i[r] |= t, i[r + 1] |= t >>> 8;
}, Tt = function(i, e, t) {
  t <<= 7 & e;
  var r = e / 8 >> 0;
  i[r] |= t, i[r + 1] |= t >>> 8, i[r + 2] |= t >>> 16;
}, Wr = function(i, e) {
  for (var t = [], r = 0; r < i.length; ++r) i[r] && t.push({ s: r, f: i[r] });
  var s = t.length, n = t.slice();
  if (!s) return [new Pe(0), 0];
  if (s == 1) {
    var o = new Pe(t[0].s + 1);
    return o[t[0].s] = 1, [o, 1];
  }
  t.sort(function(y, X) {
    return y.f - X.f;
  }), t.push({ s: -1, f: 25001 });
  var a = t[0], l = t[1], u = 0, c = 1, d = 2;
  for (t[0] = { s: -1, f: a.f + l.f, l: a, r: l }; c != s - 1; ) a = t[t[u].f < t[d].f ? u++ : d++], l = t[u != c && t[u].f < t[d].f ? u++ : d++], t[c++] = { s: -1, f: a.f + l.f, l: a, r: l };
  var h = n[0].s;
  for (r = 1; r < s; ++r) n[r].s > h && (h = n[r].s);
  var p = new Se(h + 1), g = Si(t[c - 1], p, 0);
  if (g > e) {
    r = 0;
    var v = 0, _ = g - e, w = 1 << _;
    for (n.sort(function(y, X) {
      return p[X.s] - p[y.s] || y.f - X.f;
    }); r < s; ++r) {
      var $ = n[r].s;
      if (!(p[$] > e)) break;
      v += w - (1 << g - p[$]), p[$] = e;
    }
    for (v >>>= _; v > 0; ) {
      var I = n[r].s;
      p[I] < e ? v -= 1 << e - p[I]++ - 1 : ++r;
    }
    for (; r >= 0 && v; --r) {
      var T = n[r].s;
      p[T] == e && (--p[T], ++v);
    }
    g = e;
  }
  return [new Pe(p), g];
}, Si = function(i, e, t) {
  return i.s == -1 ? Math.max(Si(i.l, e, t + 1), Si(i.r, e, t + 1)) : e[i.s] = t;
}, Ys = function(i) {
  for (var e = i.length; e && !i[--e]; ) ;
  for (var t = new Se(++e), r = 0, s = i[0], n = 1, o = function(l) {
    t[r++] = l;
  }, a = 1; a <= e; ++a) if (i[a] == s && a != e) ++n;
  else {
    if (!s && n > 2) {
      for (; n > 138; n -= 138) o(32754);
      n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
    } else if (n > 3) {
      for (o(s), --n; n > 6; n -= 6) o(8304);
      n > 2 && (o(n - 3 << 5 | 8208), n = 0);
    }
    for (; n--; ) o(s);
    n = 1, s = i[a];
  }
  return [t.subarray(0, r), e];
}, It = function(i, e) {
  for (var t = 0, r = 0; r < e.length; ++r) t += i[r] * e[r];
  return t;
}, ki = function(i, e, t) {
  var r = t.length, s = uo(e + 2);
  i[s] = 255 & r, i[s + 1] = r >>> 8, i[s + 2] = 255 ^ i[s], i[s + 3] = 255 ^ i[s + 1];
  for (var n = 0; n < r; ++n) i[s + n + 4] = t[n];
  return 8 * (s + 4 + r);
}, zs = function(i, e, t, r, s, n, o, a, l, u, c) {
  De(e, c++, t), ++s[256];
  for (var d = Wr(s, 15), h = d[0], p = d[1], g = Wr(n, 15), v = g[0], _ = g[1], w = Ys(h), $ = w[0], I = w[1], T = Ys(v), y = T[0], X = T[1], ie = new Se(19), j = 0; j < $.length; ++j) ie[31 & $[j]]++;
  for (j = 0; j < y.length; ++j) ie[31 & y[j]]++;
  for (var ge = Wr(ie, 7), se = ge[0], le = ge[1], ue = 19; ue > 4 && !se[Bs[ue - 1]]; --ue) ;
  var ke, ne, _e, oe, ce = u + 5 << 3, Te = It(s, ot) + It(n, wr) + o, me = It(s, h) + It(n, v) + o + 14 + 3 * ue + It(ie, se) + (2 * ie[16] + 3 * ie[17] + 7 * ie[18]);
  if (ce <= Te && ce <= me) return ki(e, c, i.subarray(l, l + u));
  if (De(e, c, 1 + (me < Te)), c += 2, me < Te) {
    ke = jt(h, p), ne = h, _e = jt(v, _), oe = v;
    var m = jt(se, le);
    for (De(e, c, I - 257), De(e, c + 5, X - 1), De(e, c + 10, ue - 4), c += 14, j = 0; j < ue; ++j) De(e, c + 3 * j, se[Bs[j]]);
    c += 3 * ue;
    for (var R = [$, y], O = 0; O < 2; ++O) {
      var A = R[O];
      for (j = 0; j < A.length; ++j) {
        var P = 31 & A[j];
        De(e, c, m[P]), c += se[P], P > 15 && (De(e, c, A[j] >>> 5 & 127), c += A[j] >>> 12);
      }
    }
  } else ke = Fl, ne = ot, _e = $l, oe = wr;
  for (j = 0; j < a; ++j) if (r[j] > 255) {
    P = r[j] >>> 18 & 31, Tt(e, c, ke[P + 257]), c += ne[P + 257], P > 7 && (De(e, c, r[j] >>> 23 & 31), c += Bi[P]);
    var L = 31 & r[j];
    Tt(e, c, _e[L]), c += oe[L], L > 3 && (Tt(e, c, r[j] >>> 5 & 8191), c += Gi[L]);
  } else Tt(e, c, ke[r[j]]), c += ne[r[j]];
  return Tt(e, c, ke[256]), c + ne[256];
}, Ml = new yt([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), Ll = function() {
  for (var i = new yt(256), e = 0; e < 256; ++e) {
    for (var t = e, r = 9; --r; ) t = (1 & t && 3988292384) ^ t >>> 1;
    i[e] = t;
  }
  return i;
}(), Nl = function() {
  var i = 4294967295;
  return { p: function(e) {
    for (var t = i, r = 0; r < e.length; ++r) t = Ll[255 & t ^ e[r]] ^ t >>> 8;
    i = t;
  }, d: function() {
    return 4294967295 ^ i;
  } };
}, Dl = function(i, e, t, r, s) {
  return function(n, o, a, l, u, c) {
    var d = n.length, h = new Pe(l + d + 5 * (1 + Math.floor(d / 7e3)) + u), p = h.subarray(l, h.length - u), g = 0;
    if (!o || d < 8) for (var v = 0; v <= d; v += 65535) {
      var _ = v + 65535;
      _ < d ? g = ki(p, g, n.subarray(v, _)) : (p[v] = c, g = ki(p, g, n.subarray(v, d)));
    }
    else {
      for (var w = Ml[o - 1], $ = w >>> 13, I = 8191 & w, T = (1 << a) - 1, y = new Se(32768), X = new Se(T + 1), ie = Math.ceil(a / 3), j = 2 * ie, ge = function(Fr) {
        return (n[Fr] ^ n[Fr + 1] << ie ^ n[Fr + 2] << j) & T;
      }, se = new yt(25e3), le = new Se(288), ue = new Se(32), ke = 0, ne = 0, _e = (v = 0, 0), oe = 0, ce = 0; v < d; ++v) {
        var Te = ge(v), me = 32767 & v, m = X[Te];
        if (y[me] = m, X[Te] = me, oe <= v) {
          var R = d - v;
          if ((ke > 7e3 || _e > 24576) && R > 423) {
            g = zs(n, p, 0, se, le, ue, ne, _e, ce, v - ce, g), _e = ke = ne = 0, ce = v;
            for (var O = 0; O < 286; ++O) le[O] = 0;
            for (O = 0; O < 30; ++O) ue[O] = 0;
          }
          var A = 2, P = 0, L = I, F = me - m & 32767;
          if (R > 2 && Te == ge(v - F)) for (var N = Math.min($, R) - 1, H = Math.min(32767, v), U = Math.min(258, R); F <= H && --L && me != m; ) {
            if (n[v + A] == n[v + A - F]) {
              for (var M = 0; M < U && n[v + M] == n[v + M - F]; ++M) ;
              if (M > A) {
                if (A = M, P = F, M > N) break;
                var de = Math.min(F, M - 2), S = 0;
                for (O = 0; O < de; ++O) {
                  var ye = v - F + O + 32768 & 32767, Qe = ye - y[ye] + 32768 & 32767;
                  Qe > S && (S = Qe, m = ye);
                }
              }
            }
            F += (me = m) - (m = y[me]) + 32768 & 32767;
          }
          if (P) {
            se[_e++] = 268435456 | Ei[A] << 18 | Gs[P];
            var Et = 31 & Ei[A], Qi = 31 & Gs[P];
            ne += Bi[Et] + Gi[Qi], ++le[257 + Et], ++ue[Qi], oe = v + A, ++ke;
          } else se[_e++] = n[v], ++le[n[v]];
        }
      }
      g = zs(n, p, c, se, le, ue, ne, _e, ce, v - ce, g);
    }
    return co(h, 0, l + uo(g) + u);
  }(i, e.level == null ? 6 : e.level, e.mem == null ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(i.length)))) : 12 + e.mem, t, r, !0);
}, xi = function(i, e, t) {
  for (; t; ++e) i[e] = t, t >>>= 8;
}, jl = function(i, e) {
  var t = e.filename;
  if (i[0] = 31, i[1] = 139, i[2] = 8, i[8] = e.level < 2 ? 4 : e.level == 9 ? 2 : 0, i[9] = 3, e.mtime != 0 && xi(i, 4, Math.floor(new Date(e.mtime || Date.now()) / 1e3)), t) {
    i[3] = 8;
    for (var r = 0; r <= t.length; ++r) i[r + 10] = t.charCodeAt(r);
  }
}, Hl = function(i) {
  return 10 + (i.filename && i.filename.length + 1 || 0);
};
function ho(i, e) {
  e === void 0 && (e = {});
  var t = Nl(), r = i.length;
  t.p(i);
  var s = Dl(i, e, Hl(e), 8), n = s.length;
  return jl(s, e), xi(s, n - 8, t.d()), xi(s, n - 4, r), s;
}
function po(i, e) {
  var t = i.length;
  if (typeof TextEncoder < "u") return new TextEncoder().encode(i);
  for (var r = new Pe(i.length + (i.length >>> 1)), s = 0, n = function(u) {
    r[s++] = u;
  }, o = 0; o < t; ++o) {
    if (s + 5 > r.length) {
      var a = new Pe(s + 8 + (t - o << 1));
      a.set(r), r = a;
    }
    var l = i.charCodeAt(o);
    l < 128 || e ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & i.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
  }
  return co(r, 0, s);
}
function ql(i, e) {
  return function(t) {
    for (var r = 0, s = 0; s < t.length; s++) r = (r << 5) - r + t.charCodeAt(s), r |= 0;
    return Math.abs(r);
  }(i) % 100 < Re(100 * e, 0, 100, k);
}
var Ze = "disabled", Yi = "sampled", Er = "active", at = "buffering", zi = "paused", Wi = "trigger", Le = Wi + "_activated", fe = Wi + "_pending", Ne = Wi + "_" + Ze;
function Ws(i, e) {
  return e.some((t) => t.matching === "regex" && new RegExp(t.url).test(i));
}
class fo {
  constructor(e) {
    this.Pt = e;
  }
  triggerStatus(e) {
    var t = this.Pt.map((r) => r.triggerStatus(e));
    return t.includes(Le) ? Le : t.includes(fe) ? fe : Ne;
  }
  stop() {
    this.Pt.forEach((e) => e.stop());
  }
}
class vo {
  constructor(e) {
    this.Pt = e;
  }
  triggerStatus(e) {
    var t = /* @__PURE__ */ new Set();
    for (var r of this.Pt) t.add(r.triggerStatus(e));
    switch (t.delete(Ne), t.size) {
      case 0:
        return Ne;
      case 1:
        return Array.from(t)[0];
      default:
        return fe;
    }
  }
  stop() {
    this.Pt.forEach((e) => e.stop());
  }
}
class Ul {
  triggerStatus() {
    return fe;
  }
  stop() {
  }
}
class Bl {
  constructor(e) {
    this.It = [], this.Rt = [], this.urlBlocked = !1, this._instance = e;
  }
  onRemoteConfig(e) {
    var t, r;
    this.It = ((t = e.sessionRecording) == null ? void 0 : t.urlTriggers) || [], this.Rt = ((r = e.sessionRecording) == null ? void 0 : r.urlBlocklist) || [];
  }
  Tt(e) {
    var t;
    return this.It.length === 0 ? Ne : ((t = this._instance) == null ? void 0 : t.get_property(ci)) === e ? Le : fe;
  }
  triggerStatus(e) {
    var t = this.Tt(e), r = t === Le ? Le : t === fe ? fe : Ne;
    return this._instance.register_for_session({ $sdk_debug_replay_url_trigger_status: r }), r;
  }
  checkUrlTriggerConditions(e, t, r) {
    if (f !== void 0 && f.location.href) {
      var s = f.location.href, n = this.urlBlocked, o = Ws(s, this.Rt);
      n && o || (o && !n ? e() : !o && n && t(), Ws(s, this.It) && r("url"));
    }
  }
  stop() {
  }
}
class Gl {
  constructor(e) {
    this.linkedFlag = null, this.linkedFlagSeen = !1, this.Ct = () => {
    }, this._instance = e;
  }
  triggerStatus() {
    var e = fe;
    return q(this.linkedFlag) && (e = Ne), this.linkedFlagSeen && (e = Le), this._instance.register_for_session({ $sdk_debug_replay_linked_flag_trigger_status: e }), e;
  }
  onRemoteConfig(e, t) {
    var r;
    if (this.linkedFlag = ((r = e.sessionRecording) == null ? void 0 : r.linkedFlag) || null, !q(this.linkedFlag) && !this.linkedFlagSeen) {
      var s = Z(this.linkedFlag) ? this.linkedFlag : this.linkedFlag.flag, n = Z(this.linkedFlag) ? null : this.linkedFlag.variant;
      this.Ct = this._instance.onFeatureFlags((o, a) => {
        var l = !1;
        if (K(a) && s in a) {
          var u = a[s];
          l = Ae(u) ? u === !0 : n ? u === n : !!u;
        }
        this.linkedFlagSeen = l, l && t(s, n);
      });
    }
  }
  stop() {
    this.Ct();
  }
}
class Yl {
  constructor(e) {
    this.Mt = [], this._instance = e;
  }
  onRemoteConfig(e) {
    var t;
    this.Mt = ((t = e.sessionRecording) == null ? void 0 : t.eventTriggers) || [];
  }
  Ot(e) {
    var t;
    return this.Mt.length === 0 ? Ne : ((t = this._instance) == null ? void 0 : t.get_property(di)) === e ? Le : fe;
  }
  triggerStatus(e) {
    var t = this.Ot(e), r = t === Le ? Le : t === fe ? fe : Ne;
    return this._instance.register_for_session({ $sdk_debug_replay_event_trigger_status: r }), r;
  }
  stop() {
  }
}
function zl(i) {
  return i.isRecordingEnabled ? at : Ze;
}
function Wl(i) {
  if (!i.receivedFlags) return at;
  if (!i.isRecordingEnabled) return Ze;
  if (i.urlTriggerMatching.urlBlocked) return zi;
  var e = i.isSampled === !0, t = new fo([i.eventTriggerMatching, i.urlTriggerMatching, i.linkedFlagMatching]).triggerStatus(i.sessionId);
  return e ? Yi : t === Le ? Er : t === fe ? at : i.isSampled === !1 ? Ze : Er;
}
function Vl(i) {
  if (!i.receivedFlags) return at;
  if (!i.isRecordingEnabled) return Ze;
  if (i.urlTriggerMatching.urlBlocked) return zi;
  var e = new vo([i.eventTriggerMatching, i.urlTriggerMatching, i.linkedFlagMatching]).triggerStatus(i.sessionId), t = e !== Ne, r = Ae(i.isSampled);
  return t && e === fe ? at : t && e === Ne || r && !i.isSampled ? Ze : i.isSampled === !0 ? Yi : Er;
}
var Mt = "[SessionRecording]", re = te(Mt);
function rr() {
  var i;
  return C == null || (i = C.__PosthogExtensions__) == null || (i = i.rrweb) == null ? void 0 : i.record;
}
var Xl = 3e5, Jl = [Oe.MouseMove, Oe.MouseInteraction, Oe.Scroll, Oe.ViewportResize, Oe.Input, Oe.TouchMove, Oe.MediaInteraction, Oe.Drag], Vs = (i) => ({ rrwebMethod: i, enqueuedAt: Date.now(), attempt: 1 });
function rt(i) {
  return function(e, t) {
    for (var r = "", s = 0; s < e.length; ) {
      var n = e[s++];
      r += String.fromCharCode(n);
    }
    return r;
  }(ho(po(JSON.stringify(i))));
}
function Xs(i) {
  return i.type === qe.Custom && i.data.tag === "sessionIdle";
}
class Js {
  get sessionId() {
    return this.Ft;
  }
  get At() {
    return this._instance.config.session_recording.session_idle_threshold_ms || 3e5;
  }
  get started() {
    return this.Dt;
  }
  get jt() {
    if (!this._instance.sessionManager) throw new Error(Mt + " must be started with a valid sessionManager.");
    return this._instance.sessionManager;
  }
  get Lt() {
    var e, t;
    return this.Nt.triggerStatus(this.sessionId) === fe ? 6e4 : (e = (t = this._instance.config.session_recording) == null ? void 0 : t.full_snapshot_interval_millis) !== null && e !== void 0 ? e : Xl;
  }
  get Ut() {
    var e = this._instance.get_property(At);
    return Ae(e) ? e : null;
  }
  get zt() {
    var e, t, r = (e = this.H) == null ? void 0 : e.data[((t = this.H) == null ? void 0 : t.data.length) - 1], { sessionStartTimestamp: s } = this.jt.checkAndGetSessionAndWindowId(!0);
    return r ? r.timestamp - s : null;
  }
  get qt() {
    var e = !!this._instance.get_property(qt), t = !this._instance.config.disable_session_recording;
    return f && e && t;
  }
  get Bt() {
    var e = !!this._instance.get_property(Ts), t = this._instance.config.enable_recording_console_log;
    return t ?? e;
  }
  get Ht() {
    var e, t, r, s, n, o, a = this._instance.config.session_recording.captureCanvas, l = this._instance.get_property(Cs), u = (e = (t = a == null ? void 0 : a.recordCanvas) !== null && t !== void 0 ? t : l == null ? void 0 : l.enabled) !== null && e !== void 0 && e, c = (r = (s = a == null ? void 0 : a.canvasFps) !== null && s !== void 0 ? s : l == null ? void 0 : l.fps) !== null && r !== void 0 ? r : 4, d = (n = (o = a == null ? void 0 : a.canvasQuality) !== null && o !== void 0 ? o : l == null ? void 0 : l.quality) !== null && n !== void 0 ? n : 0.4;
    if (typeof d == "string") {
      var h = parseFloat(d);
      d = isNaN(h) ? 0.4 : h;
    }
    return { enabled: u, fps: Re(c, 0, 12, re.createLogger("canvas recording fps"), 4), quality: Re(d, 0, 1, re.createLogger("canvas recording quality"), 0.4) };
  }
  get Wt() {
    var e, t, r = this._instance.get_property(Is), s = { recordHeaders: (e = this._instance.config.session_recording) == null ? void 0 : e.recordHeaders, recordBody: (t = this._instance.config.session_recording) == null ? void 0 : t.recordBody }, n = (s == null ? void 0 : s.recordHeaders) || (r == null ? void 0 : r.recordHeaders), o = (s == null ? void 0 : s.recordBody) || (r == null ? void 0 : r.recordBody), a = K(this._instance.config.capture_performance) ? this._instance.config.capture_performance.network_timing : this._instance.config.capture_performance, l = !!(Ae(a) ? a : r != null && r.capturePerformance);
    return n || o || l ? { recordHeaders: n, recordBody: o, recordPerformance: l } : void 0;
  }
  get Gt() {
    var e, t, r, s, n, o, a = this._instance.get_property(Ps), l = { maskAllInputs: (e = this._instance.config.session_recording) == null ? void 0 : e.maskAllInputs, maskTextSelector: (t = this._instance.config.session_recording) == null ? void 0 : t.maskTextSelector, blockSelector: (r = this._instance.config.session_recording) == null ? void 0 : r.blockSelector }, u = (s = l == null ? void 0 : l.maskAllInputs) !== null && s !== void 0 ? s : a == null ? void 0 : a.maskAllInputs, c = (n = l == null ? void 0 : l.maskTextSelector) !== null && n !== void 0 ? n : a == null ? void 0 : a.maskTextSelector, d = (o = l == null ? void 0 : l.blockSelector) !== null && o !== void 0 ? o : a == null ? void 0 : a.blockSelector;
    return b(u) && b(c) && b(d) ? void 0 : { maskAllInputs: u == null || u, maskTextSelector: c, blockSelector: d };
  }
  get Vt() {
    var e = this._instance.get_property(Os);
    return pe(e) ? e : null;
  }
  get Jt() {
    var e = this._instance.get_property(As);
    return pe(e) ? e : null;
  }
  get status() {
    return this.Kt ? this.Yt({ receivedFlags: this.Kt, isRecordingEnabled: this.qt, isSampled: this.Ut, urlTriggerMatching: this.Xt, eventTriggerMatching: this.Qt, linkedFlagMatching: this.Zt, sessionId: this.sessionId }) : at;
  }
  constructor(e) {
    if (this.Yt = zl, this.Kt = !1, this.ti = [], this.ii = "unknown", this.ei = Date.now(), this.Nt = new Ul(), this.ri = void 0, this.si = void 0, this.ni = void 0, this.oi = void 0, this.ai = void 0, this._forceAllowLocalhostNetworkCapture = !1, this.li = () => {
      this.hi();
    }, this.ui = () => {
      this.tryAddCustomEvent("browser offline", {});
    }, this.di = () => {
      this.tryAddCustomEvent("browser online", {});
    }, this.vi = () => {
      if (x != null && x.visibilityState) {
        var s = "window " + x.visibilityState;
        this.tryAddCustomEvent(s, {});
      }
    }, this._instance = e, this.Dt = !1, this.ci = "/s/", this.fi = void 0, this.Kt = !1, !this._instance.sessionManager) throw re.error("started without valid sessionManager"), new Error(Mt + " started without valid sessionManager. This is a bug.");
    if (this._instance.config.cookieless_mode === "always") throw new Error(Mt + ' cannot be used with cookieless_mode="always"');
    this.Zt = new Gl(this._instance), this.Xt = new Bl(this._instance), this.Qt = new Yl(this._instance);
    var { sessionId: t, windowId: r } = this.jt.checkAndGetSessionAndWindowId();
    this.Ft = t, this.pi = r, this.H = this.gi(), this.At >= this.jt.sessionTimeoutMs && re.warn("session_idle_threshold_ms (" + this.At + ") is greater than the session timeout (" + this.jt.sessionTimeoutMs + "). Session will never be detected as idle");
  }
  startIfEnabledOrStop(e) {
    this.qt ? (this.mi(e), J(f, "beforeunload", this.li), J(f, "offline", this.ui), J(f, "online", this.di), J(f, "visibilitychange", this.vi), this.yi(), this.bi(), q(this.ri) && (this.ri = this._instance.on("eventCaptured", (t) => {
      try {
        if (t.event === "$pageview") {
          var r = t != null && t.properties.$current_url ? this.wi(t == null ? void 0 : t.properties.$current_url) : "";
          if (!r) return;
          this.tryAddCustomEvent("$pageview", { href: r });
        }
      } catch (s) {
        re.error("Could not add $pageview to rrweb session", s);
      }
    })), this.si || (this.si = this.jt.onSessionId((t, r, s) => {
      var n, o;
      s && (this.tryAddCustomEvent("$session_id_change", { sessionId: t, windowId: r, changeReason: s }), (n = this._instance) == null || (n = n.persistence) == null || n.unregister(di), (o = this._instance) == null || (o = o.persistence) == null || o.unregister(ci));
    }))) : this.stopRecording();
  }
  stopRecording() {
    var e, t, r, s;
    this.Dt && this.fi && (this.fi(), this.fi = void 0, this.Dt = !1, f == null || f.removeEventListener("beforeunload", this.li), f == null || f.removeEventListener("offline", this.ui), f == null || f.removeEventListener("online", this.di), f == null || f.removeEventListener("visibilitychange", this.vi), this.gi(), clearInterval(this.Si), (e = this.ri) == null || e.call(this), this.ri = void 0, (t = this.ai) == null || t.call(this), this.ai = void 0, (r = this.si) == null || r.call(this), this.si = void 0, (s = this.oi) == null || s.call(this), this.oi = void 0, this.Qt.stop(), this.Xt.stop(), this.Zt.stop(), re.info("stopped"));
  }
  ki() {
    var e;
    (e = this._instance.persistence) == null || e.unregister(At);
  }
  $i(e) {
    var t, r = this.Ft !== e, s = this.Vt;
    if (pe(s)) {
      var n = this.Ut, o = r || !Ae(n), a = o ? ql(e, s) : n;
      o && (a ? this.xi(Yi) : re.warn("Sample rate (" + s + ") has determined that this sessionId (" + e + ") will not be sent to the server."), this.tryAddCustomEvent("samplingDecisionMade", { sampleRate: s, isSampled: a })), (t = this._instance.persistence) == null || t.register({ [At]: a });
    } else this.ki();
  }
  onRemoteConfig(e) {
    var t, r, s, n;
    this.tryAddCustomEvent("$remote_config_received", e), this.Ei(e), (t = e.sessionRecording) != null && t.endpoint && (this.ci = (n = e.sessionRecording) == null ? void 0 : n.endpoint), this.yi(), ((r = e.sessionRecording) == null ? void 0 : r.triggerMatchType) === "any" ? (this.Yt = Wl, this.Nt = new fo([this.Qt, this.Xt])) : (this.Yt = Vl, this.Nt = new vo([this.Qt, this.Xt])), this._instance.register_for_session({ $sdk_debug_replay_remote_trigger_matching_config: (s = e.sessionRecording) == null ? void 0 : s.triggerMatchType }), this.Xt.onRemoteConfig(e), this.Qt.onRemoteConfig(e), this.Zt.onRemoteConfig(e, (o, a) => {
      this.xi("linked_flag_matched", { flag: o, variant: a });
    }), this.Kt = !0, this.startIfEnabledOrStop();
  }
  yi() {
    pe(this.Vt) && q(this.oi) && (this.oi = this.jt.onSessionId((e) => {
      this.$i(e);
    }));
  }
  Ei(e) {
    if (this._instance.persistence) {
      var t, r = this._instance.persistence, s = () => {
        var n, o, a, l, u, c, d, h, p, g = (n = e.sessionRecording) == null ? void 0 : n.sampleRate, v = q(g) ? null : parseFloat(g);
        q(v) && this.ki();
        var _ = (o = e.sessionRecording) == null ? void 0 : o.minimumDurationMilliseconds;
        r.register({ [qt]: !!e.sessionRecording, [Ts]: (a = e.sessionRecording) == null ? void 0 : a.consoleLogRecordingEnabled, [Is]: E({ capturePerformance: e.capturePerformance }, (l = e.sessionRecording) == null ? void 0 : l.networkPayloadCapture), [Ps]: (u = e.sessionRecording) == null ? void 0 : u.masking, [Cs]: { enabled: (c = e.sessionRecording) == null ? void 0 : c.recordCanvas, fps: (d = e.sessionRecording) == null ? void 0 : d.canvasFps, quality: (h = e.sessionRecording) == null ? void 0 : h.canvasQuality }, [Os]: v, [As]: b(_) ? null : _, [dr]: (p = e.sessionRecording) == null ? void 0 : p.scriptConfig });
      };
      s(), (t = this.ni) == null || t.call(this), this.ni = this.jt.onSessionId(s);
    }
  }
  log(e, t) {
    var r;
    t === void 0 && (t = "log"), (r = this._instance.sessionRecording) == null || r.onRRwebEmit({ type: 6, data: { plugin: "rrweb/console@1", payload: { level: t, trace: [], payload: [JSON.stringify(e)] } }, timestamp: Date.now() });
  }
  mi(e) {
    if (!b(Object.assign) && !b(Array.from) && !(this.Dt || this._instance.config.disable_session_recording || this._instance.consent.isOptedOut())) {
      var t;
      this.Dt = !0, this.jt.checkAndGetSessionAndWindowId(), rr() ? this.Pi() : (t = C.__PosthogExtensions__) == null || t.loadExternalDependency == null || t.loadExternalDependency(this._instance, this.Ii, (r) => {
        if (r) return re.error("could not load recorder", r);
        this.Pi();
      }), re.info("starting"), this.status === Er && this.xi(e || "recording_initialized");
    }
  }
  get Ii() {
    var e;
    return ((e = this._instance) == null || (e = e.persistence) == null || (e = e.get_property(dr)) == null ? void 0 : e.script) || "recorder";
  }
  Ri(e) {
    var t;
    return e.type === 3 && Jl.indexOf((t = e.data) == null ? void 0 : t.source) !== -1;
  }
  Ti(e) {
    var t = this.Ri(e);
    t || this.ii || e.timestamp - this.ei > this.At && (this.ii = !0, clearInterval(this.Si), this.tryAddCustomEvent("sessionIdle", { eventTimestamp: e.timestamp, lastActivityTimestamp: this.ei, threshold: this.At, bufferLength: this.H.data.length, bufferSize: this.H.size }), this.hi());
    var r = !1;
    if (t && (this.ei = e.timestamp, this.ii)) {
      var s = this.ii === "unknown";
      this.ii = !1, s || (this.tryAddCustomEvent("sessionNoLongerIdle", { reason: "user activity", type: e.type }), r = !0);
    }
    if (!this.ii) {
      var { windowId: n, sessionId: o } = this.jt.checkAndGetSessionAndWindowId(!t, e.timestamp), a = this.Ft !== o, l = this.pi !== n;
      this.pi = n, this.Ft = o, a || l ? (this.stopRecording(), this.startIfEnabledOrStop("session_id_changed")) : r && this.Ci();
    }
  }
  Mi(e) {
    try {
      return e.rrwebMethod(), !0;
    } catch (t) {
      return this.ti.length < 10 ? this.ti.push({ enqueuedAt: e.enqueuedAt || Date.now(), attempt: e.attempt++, rrwebMethod: e.rrwebMethod }) : re.warn("could not emit queued rrweb event.", t, e), !1;
    }
  }
  tryAddCustomEvent(e, t) {
    return this.Mi(Vs(() => rr().addCustomEvent(e, t)));
  }
  Oi() {
    return this.Mi(Vs(() => rr().takeFullSnapshot()));
  }
  Pi() {
    var e, t, r, s, n = { blockClass: "ph-no-capture", blockSelector: void 0, ignoreClass: "ph-ignore-input", maskTextClass: "ph-mask", maskTextSelector: void 0, maskTextFn: void 0, maskAllInputs: !0, maskInputOptions: { password: !0 }, maskInputFn: void 0, slimDOMOptions: {}, collectFonts: !1, inlineStylesheet: !0, recordCrossOriginIframes: !1 }, o = this._instance.config.session_recording;
    for (var [a, l] of Object.entries(o || {})) a in n && (a === "maskInputOptions" ? n.maskInputOptions = E({ password: !0 }, l) : n[a] = l);
    this.Ht && this.Ht.enabled && (n.recordCanvas = !0, n.sampling = { canvas: this.Ht.fps }, n.dataURLOptions = { type: "image/webp", quality: this.Ht.quality }), this.Gt && (n.maskAllInputs = (t = this.Gt.maskAllInputs) === null || t === void 0 || t, n.maskTextSelector = (r = this.Gt.maskTextSelector) !== null && r !== void 0 ? r : void 0, n.blockSelector = (s = this.Gt.blockSelector) !== null && s !== void 0 ? s : void 0);
    var u = rr();
    if (u) {
      this.Fi = (e = this.Fi) !== null && e !== void 0 ? e : new Ol(u, { refillRate: this._instance.config.session_recording.__mutationThrottlerRefillRate, bucketSize: this._instance.config.session_recording.__mutationThrottlerBucketSize, onBlockedNode: (d, h) => {
        var p = "Too many mutations on node '" + d + "'. Rate limiting. This could be due to SVG animations or something similar";
        re.info(p, { node: h }), this.log(Mt + " " + p, "warn");
      } });
      var c = this.Ai();
      this.fi = u(E({ emit: (d) => {
        this.onRRwebEmit(d);
      }, plugins: c }, n)), this.ei = Date.now(), this.ii = Ae(this.ii) ? this.ii : "unknown", this.tryAddCustomEvent("$session_options", { sessionRecordingOptions: n, activePlugins: c.map((d) => d == null ? void 0 : d.name) }), this.tryAddCustomEvent("$posthog_config", { config: this._instance.config });
    } else re.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
  }
  Ci() {
    if (this.Si && clearInterval(this.Si), this.ii !== !0) {
      var e = this.Lt;
      e && (this.Si = setInterval(() => {
        this.Oi();
      }, e));
    }
  }
  Ai() {
    var e, t, r = [], s = (e = C.__PosthogExtensions__) == null || (e = e.rrwebPlugins) == null ? void 0 : e.getRecordConsolePlugin;
    s && this.Bt && r.push(s());
    var n = (t = C.__PosthogExtensions__) == null || (t = t.rrwebPlugins) == null ? void 0 : t.getRecordNetworkPlugin;
    return this.Wt && Ie(n) && (!ul.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? r.push(n(Cl(this._instance.config, this.Wt))) : re.info("NetworkCapture not started because we are on localhost.")), r;
  }
  onRRwebEmit(e) {
    var t;
    if (this.Di(), e && K(e)) {
      if (e.type === qe.Meta) {
        var r = this.wi(e.data.href);
        if (this.ji = r, !r) return;
        e.data.href = r;
      } else this.Li();
      if (this.Xt.checkUrlTriggerConditions(() => this.Ni(), () => this.Ui(), (h) => this.zi(h)), !this.Xt.urlBlocked || (s = e).type === qe.Custom && s.data.tag === "recording paused") {
        var s;
        e.type === qe.FullSnapshot && this.Ci(), e.type === qe.FullSnapshot && this.Kt && this.Nt.triggerStatus(this.sessionId) === fe && this.gi();
        var n = this.Fi ? this.Fi.throttleMutations(e) : e;
        if (n) {
          var o = function(h) {
            var p = h;
            if (p && K(p) && p.type === 6 && K(p.data) && p.data.plugin === "rrweb/console@1") {
              p.data.payload.payload.length > 10 && (p.data.payload.payload = p.data.payload.payload.slice(0, 10), p.data.payload.payload.push("...[truncated]"));
              for (var g = [], v = 0; v < p.data.payload.payload.length; v++) p.data.payload.payload[v] && p.data.payload.payload[v].length > 2e3 ? g.push(p.data.payload.payload[v].slice(0, 2e3) + "...[truncated]") : g.push(p.data.payload.payload[v]);
              return p.data.payload.payload = g, h;
            }
            return h;
          }(n);
          if (this.Ti(o), this.ii !== !0 || Xs(o)) {
            if (Xs(o)) {
              var a = o.data.payload;
              if (a) {
                var l = a.lastActivityTimestamp, u = a.threshold;
                o.timestamp = l + u;
              }
            }
            var c = (t = this._instance.config.session_recording.compress_events) === null || t === void 0 || t ? function(h) {
              if (br(h) < 1024) return h;
              try {
                if (h.type === qe.FullSnapshot) return E({}, h, { data: rt(h.data), cv: "2024-10" });
                if (h.type === qe.IncrementalSnapshot && h.data.source === Oe.Mutation) return E({}, h, { cv: "2024-10", data: E({}, h.data, { texts: rt(h.data.texts), attributes: rt(h.data.attributes), removes: rt(h.data.removes), adds: rt(h.data.adds) }) });
                if (h.type === qe.IncrementalSnapshot && h.data.source === Oe.StyleSheetRule) return E({}, h, { cv: "2024-10", data: E({}, h.data, { adds: h.data.adds ? rt(h.data.adds) : void 0, removes: h.data.removes ? rt(h.data.removes) : void 0 }) });
              } catch (p) {
                re.error("could not compress event - will use uncompressed event", p);
              }
              return h;
            }(o) : o, d = { $snapshot_bytes: br(c), $snapshot_data: c, $session_id: this.Ft, $window_id: this.pi };
            this.status !== Ze ? this.qi(d) : this.gi();
          }
        }
      }
    }
  }
  Li() {
    if (!this._instance.config.capture_pageview && f) {
      var e = this.wi(f.location.href);
      this.ji !== e && (this.tryAddCustomEvent("$url_changed", { href: e }), this.ji = e);
    }
  }
  Di() {
    if (this.ti.length) {
      var e = [...this.ti];
      this.ti = [], e.forEach((t) => {
        Date.now() - t.enqueuedAt <= 2e3 && this.Mi(t);
      });
    }
  }
  wi(e) {
    var t = this._instance.config.session_recording;
    if (t.maskNetworkRequestFn) {
      var r, s = { url: e };
      return (r = s = t.maskNetworkRequestFn(s)) == null ? void 0 : r.url;
    }
    return e;
  }
  gi() {
    return this.H = { size: 0, data: [], sessionId: this.Ft, windowId: this.pi }, this.H;
  }
  hi() {
    this.Bi && (clearTimeout(this.Bi), this.Bi = void 0);
    var e = this.Jt, t = this.zt, r = pe(t) && t >= 0, s = pe(e) && r && t < e;
    return this.status === at || this.status === zi || this.status === Ze || s ? (this.Bi = setTimeout(() => {
      this.hi();
    }, 2e3), this.H) : (this.H.data.length > 0 && yi(this.H).forEach((n) => {
      this.Hi({ $snapshot_bytes: n.size, $snapshot_data: n.data, $session_id: n.sessionId, $window_id: n.windowId, $lib: "web", $lib_version: Ue.LIB_VERSION });
    }), this.gi());
  }
  qi(e) {
    var t, r = 2 + (((t = this.H) == null ? void 0 : t.data.length) || 0);
    !this.ii && (this.H.size + e.$snapshot_bytes + r > 943718.4 || this.H.sessionId !== this.Ft) && (this.H = this.hi()), this.H.size += e.$snapshot_bytes, this.H.data.push(e.$snapshot_data), this.Bi || this.ii || (this.Bi = setTimeout(() => {
      this.hi();
    }, 2e3));
  }
  Hi(e) {
    this._instance.capture("$snapshot", e, { _url: this._instance.requestRouter.endpointFor("api", this.ci), _noTruncate: !0, _batchKey: "recordings", skip_client_rate_limiting: !0 });
  }
  zi(e) {
    var t;
    this.Nt.triggerStatus(this.sessionId) === fe && ((t = this._instance) == null || (t = t.persistence) == null || t.register({ [e === "url" ? ci : di]: this.Ft }), this.hi(), this.xi(e + "_trigger_matched"));
  }
  Ni() {
    this.Xt.urlBlocked || (this.Xt.urlBlocked = !0, clearInterval(this.Si), re.info("recording paused due to URL blocker"), this.tryAddCustomEvent("recording paused", { reason: "url blocker" }));
  }
  Ui() {
    this.Xt.urlBlocked && (this.Xt.urlBlocked = !1, this.Oi(), this.Ci(), this.tryAddCustomEvent("recording resumed", { reason: "left blocked url" }), re.info("recording resumed"));
  }
  bi() {
    this.Qt.Mt.length !== 0 && q(this.ai) && (this.ai = this._instance.on("eventCaptured", (e) => {
      try {
        this.Qt.Mt.includes(e.event) && this.zi("event");
      } catch (t) {
        re.error("Could not activate event trigger", t);
      }
    }));
  }
  overrideLinkedFlag() {
    this.Zt.linkedFlagSeen = !0, this.Oi(), this.xi("linked_flag_overridden");
  }
  overrideSampling() {
    var e;
    (e = this._instance.persistence) == null || e.register({ [At]: !0 }), this.Oi(), this.xi("sampling_overridden");
  }
  overrideTrigger(e) {
    this.zi(e);
  }
  xi(e, t) {
    this._instance.register_for_session({ $session_recording_start_reason: e }), re.info(e.replace("_", " "), t), D(["recording_initialized", "session_id_changed"], e) || this.tryAddCustomEvent(e, t);
  }
  get sdkDebugProperties() {
    var { sessionStartTimestamp: e } = this.jt.checkAndGetSessionAndWindowId(!0);
    return { $recording_status: this.status, $sdk_debug_replay_internal_buffer_length: this.H.data.length, $sdk_debug_replay_internal_buffer_size: this.H.size, $sdk_debug_current_session_duration: this.zt, $sdk_debug_session_start: e };
  }
}
var Vr = te("[SegmentIntegration]");
function Kl(i, e) {
  var t = i.config.segment;
  if (!t) return e();
  (function(r, s) {
    var n = r.config.segment;
    if (!n) return s();
    var o = (l) => {
      var u = () => l.anonymousId() || Xe();
      r.config.get_device_id = u, l.id() && (r.register({ distinct_id: l.id(), $device_id: u() }), r.persistence.set_property(je, "identified")), s();
    }, a = n.user();
    "then" in a && Ie(a.then) ? a.then((l) => o(l)) : o(a);
  })(i, () => {
    t.register(((r) => {
      Promise && Promise.resolve || Vr.warn("This browser does not have Promise support, and can not use the segment integration");
      var s = (n, o) => {
        if (!o) return n;
        n.event.userId || n.event.anonymousId === r.get_distinct_id() || (Vr.info("No userId set, resetting PostHog"), r.reset()), n.event.userId && n.event.userId !== r.get_distinct_id() && (Vr.info("UserId set, identifying with PostHog"), r.identify(n.event.userId));
        var a = r.calculateEventProperties(o, n.event.properties);
        return n.event.properties = Object.assign({}, a, n.event.properties), n;
      };
      return { name: "PostHog JS", type: "enrichment", version: "1.0.0", isLoaded: () => !0, load: () => Promise.resolve(), track: (n) => s(n, n.event.event), page: (n) => s(n, "$pageview"), identify: (n) => s(n, "$identify"), screen: (n) => s(n, "$screen") };
    })(i)).then(() => {
      e();
    });
  });
}
var go = "posthog-js";
function _o(i, e) {
  var { organization: t, projectId: r, prefix: s, severityAllowList: n = ["error"], sendExceptionsToPostHog: o = !0 } = e === void 0 ? {} : e;
  return (a) => {
    var l, u, c, d, h;
    if (!(n === "*" || n.includes(a.level)) || !i.__loaded) return a;
    a.tags || (a.tags = {});
    var p = i.requestRouter.endpointFor("ui", "/project/" + i.config.token + "/person/" + i.get_distinct_id());
    a.tags["PostHog Person URL"] = p, i.sessionRecordingStarted() && (a.tags["PostHog Recording URL"] = i.get_session_replay_url({ withTimestamp: !0 }));
    var g = ((l = a.exception) == null ? void 0 : l.values) || [], v = g.map((w) => E({}, w, { stacktrace: w.stacktrace ? E({}, w.stacktrace, { type: "raw", frames: (w.stacktrace.frames || []).map(($) => E({}, $, { platform: "web:javascript" })) }) : void 0 })), _ = { $exception_message: ((u = g[0]) == null ? void 0 : u.value) || a.message, $exception_type: (c = g[0]) == null ? void 0 : c.type, $exception_personURL: p, $exception_level: a.level, $exception_list: v, $sentry_event_id: a.event_id, $sentry_exception: a.exception, $sentry_exception_message: ((d = g[0]) == null ? void 0 : d.value) || a.message, $sentry_exception_type: (h = g[0]) == null ? void 0 : h.type, $sentry_tags: a.tags };
    return t && r && (_.$sentry_url = (s || "https://sentry.io/organizations/") + t + "/issues/?project=" + r + "&query=" + a.event_id), o && i.exceptions.sendExceptionEvent(_), a;
  };
}
class Zl {
  constructor(e, t, r, s, n, o) {
    this.name = go, this.setupOnce = function(a) {
      a(_o(e, { organization: t, projectId: r, prefix: s, severityAllowList: n, sendExceptionsToPostHog: o == null || o }));
    };
  }
}
var Ql = f != null && f.location ? mr(f.location.hash, "__posthog") || mr(location.hash, "state") : null, Ks = "_postHogToolbarParams", Zs = te("[Toolbar]"), Ve = function(i) {
  return i[i.UNINITIALIZED = 0] = "UNINITIALIZED", i[i.LOADING = 1] = "LOADING", i[i.LOADED = 2] = "LOADED", i;
}(Ve || {});
class eu {
  constructor(e) {
    this.instance = e;
  }
  Wi(e) {
    C.ph_toolbar_state = e;
  }
  Gi() {
    var e;
    return (e = C.ph_toolbar_state) !== null && e !== void 0 ? e : Ve.UNINITIALIZED;
  }
  maybeLoadToolbar(e, t, r) {
    if (e === void 0 && (e = void 0), t === void 0 && (t = void 0), r === void 0 && (r = void 0), !f || !x) return !1;
    e = e ?? f.location, r = r ?? f.history;
    try {
      if (!t) {
        try {
          f.localStorage.setItem("test", "test"), f.localStorage.removeItem("test");
        } catch {
          return !1;
        }
        t = f == null ? void 0 : f.localStorage;
      }
      var s, n = Ql || mr(e.hash, "__posthog") || mr(e.hash, "state"), o = n ? ws(() => JSON.parse(atob(decodeURIComponent(n)))) || ws(() => JSON.parse(decodeURIComponent(n))) : null;
      return o && o.action === "ph_authorize" ? ((s = o).source = "url", s && Object.keys(s).length > 0 && (o.desiredHash ? e.hash = o.desiredHash : r ? r.replaceState(r.state, "", e.pathname + e.search) : e.hash = "")) : ((s = JSON.parse(t.getItem(Ks) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
    } catch {
      return !1;
    }
  }
  Vi(e) {
    var t = C.ph_load_toolbar || C.ph_load_editor;
    !q(t) && Ie(t) ? t(e, this.instance) : Zs.warn("No toolbar load function found");
  }
  loadToolbar(e) {
    var t = !(x == null || !x.getElementById(Gn));
    if (!f || t) return !1;
    var r = this.instance.requestRouter.region === "custom" && this.instance.config.advanced_disable_toolbar_metrics, s = E({ token: this.instance.config.token }, e, { apiURL: this.instance.requestRouter.endpointFor("ui") }, r ? { instrument: !1 } : {});
    if (f.localStorage.setItem(Ks, JSON.stringify(E({}, s, { source: void 0 }))), this.Gi() === Ve.LOADED) this.Vi(s);
    else if (this.Gi() === Ve.UNINITIALIZED) {
      var n;
      this.Wi(Ve.LOADING), (n = C.__PosthogExtensions__) == null || n.loadExternalDependency == null || n.loadExternalDependency(this.instance, "toolbar", (o) => {
        if (o) return Zs.error("[Toolbar] Failed to load", o), void this.Wi(Ve.UNINITIALIZED);
        this.Wi(Ve.LOADED), this.Vi(s);
      }), J(f, "turbolinks:load", () => {
        this.Wi(Ve.UNINITIALIZED), this.loadToolbar(s);
      });
    }
    return !0;
  }
  Ji(e) {
    return this.loadToolbar(e);
  }
  maybeLoadEditor(e, t, r) {
    return e === void 0 && (e = void 0), t === void 0 && (t = void 0), r === void 0 && (r = void 0), this.maybeLoadToolbar(e, t, r);
  }
}
var tu = te("[TracingHeaders]");
class ru {
  constructor(e) {
    this.Ki = void 0, this.Yi = void 0, this.lt = () => {
      var t, r;
      b(this.Ki) && ((t = C.__PosthogExtensions__) == null || (t = t.tracingHeadersPatchFns) == null || t._patchXHR(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager)), b(this.Yi) && ((r = C.__PosthogExtensions__) == null || (r = r.tracingHeadersPatchFns) == null || r._patchFetch(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
    }, this._instance = e;
  }
  nt(e) {
    var t, r;
    (t = C.__PosthogExtensions__) != null && t.tracingHeadersPatchFns && e(), (r = C.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, "tracing-headers", (s) => {
      if (s) return tu.error("failed to load script", s);
      e();
    });
  }
  startIfEnabledOrStop() {
    var e, t;
    this._instance.config.__add_tracing_headers ? this.nt(this.lt) : ((e = this.Ki) == null || e.call(this), (t = this.Yi) == null || t.call(this), this.Ki = void 0, this.Yi = void 0);
  }
}
var ze = te("[Web Vitals]"), Qs = 9e5;
class iu {
  constructor(e) {
    var t;
    this.Xi = !1, this.C = !1, this.H = { url: void 0, metrics: [], firstMetricTimestamp: void 0 }, this.Qi = () => {
      clearTimeout(this.Zi), this.H.metrics.length !== 0 && (this._instance.capture("$web_vitals", this.H.metrics.reduce((r, s) => E({}, r, { ["$web_vitals_" + s.name + "_event"]: E({}, s), ["$web_vitals_" + s.name + "_value"]: s.value }), {})), this.H = { url: void 0, metrics: [], firstMetricTimestamp: void 0 });
    }, this.te = (r) => {
      var s, n = (s = this._instance.sessionManager) == null ? void 0 : s.checkAndGetSessionAndWindowId(!0);
      if (b(n)) ze.error("Could not read session ID. Dropping metrics!");
      else {
        this.H = this.H || { url: void 0, metrics: [], firstMetricTimestamp: void 0 };
        var o = this.ie();
        b(o) || (q(r == null ? void 0 : r.name) || q(r == null ? void 0 : r.value) ? ze.error("Invalid metric received", r) : this.ee && r.value >= this.ee ? ze.error("Ignoring metric with value >= " + this.ee, r) : (this.H.url !== o && (this.Qi(), this.Zi = setTimeout(this.Qi, this.flushToCaptureTimeoutMs)), b(this.H.url) && (this.H.url = o), this.H.firstMetricTimestamp = b(this.H.firstMetricTimestamp) ? Date.now() : this.H.firstMetricTimestamp, r.attribution && r.attribution.interactionTargetElement && (r.attribution.interactionTargetElement = void 0), this.H.metrics.push(E({}, r, { $current_url: o, $session_id: n.sessionId, $window_id: n.windowId, timestamp: Date.now() })), this.H.metrics.length === this.allowedMetrics.length && this.Qi()));
      }
    }, this.lt = () => {
      var r, s, n, o, a = C.__PosthogExtensions__;
      b(a) || b(a.postHogWebVitalsCallbacks) || ({ onLCP: r, onCLS: s, onFCP: n, onINP: o } = a.postHogWebVitalsCallbacks), r && s && n && o ? (this.allowedMetrics.indexOf("LCP") > -1 && r(this.te.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && s(this.te.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && n(this.te.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && o(this.te.bind(this)), this.C = !0) : ze.error("web vitals callbacks not loaded - not starting");
    }, this._instance = e, this.Xi = !((t = this._instance.persistence) == null || !t.props[xs]), this.startIfEnabled();
  }
  get allowedMetrics() {
    var e, t, r = K(this._instance.config.capture_performance) ? (e = this._instance.config.capture_performance) == null ? void 0 : e.web_vitals_allowed_metrics : void 0;
    return b(r) ? ((t = this._instance.persistence) == null ? void 0 : t.props[Rs]) || ["CLS", "FCP", "INP", "LCP"] : r;
  }
  get flushToCaptureTimeoutMs() {
    return (K(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
  }
  get ee() {
    var e = K(this._instance.config.capture_performance) && pe(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : Qs;
    return 0 < e && e <= 6e4 ? Qs : e;
  }
  get isEnabled() {
    var e = we == null ? void 0 : we.protocol;
    if (e !== "http:" && e !== "https:") return ze.info("Web Vitals are disabled on non-http/https protocols"), !1;
    var t = K(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : Ae(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
    return Ae(t) ? t : this.Xi;
  }
  startIfEnabled() {
    this.isEnabled && !this.C && (ze.info("enabled, starting..."), this.nt(this.lt));
  }
  onRemoteConfig(e) {
    var t = K(e.capturePerformance) && !!e.capturePerformance.web_vitals, r = K(e.capturePerformance) ? e.capturePerformance.web_vitals_allowed_metrics : void 0;
    this._instance.persistence && (this._instance.persistence.register({ [xs]: t }), this._instance.persistence.register({ [Rs]: r })), this.Xi = t, this.startIfEnabled();
  }
  nt(e) {
    var t, r;
    (t = C.__PosthogExtensions__) != null && t.postHogWebVitalsCallbacks && e(), (r = C.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, "web-vitals", (s) => {
      s ? ze.error("failed to load script", s) : e();
    });
  }
  ie() {
    var e = f ? f.location.href : void 0;
    return e || ze.error("Could not determine current URL"), e;
  }
}
var su = te("[Heatmaps]");
function en(i) {
  return K(i) && "clientX" in i && "clientY" in i && pe(i.clientX) && pe(i.clientY);
}
class nu {
  constructor(e) {
    var t;
    this.rageclicks = new io(), this.Xi = !1, this.C = !1, this.re = null, this.instance = e, this.Xi = !((t = this.instance.persistence) == null || !t.props[li]);
  }
  get flushIntervalMilliseconds() {
    var e = 5e3;
    return K(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (e = this.instance.config.capture_heatmaps.flush_interval_milliseconds), e;
  }
  get isEnabled() {
    return b(this.instance.config.capture_heatmaps) ? b(this.instance.config.enable_heatmaps) ? this.Xi : this.instance.config.enable_heatmaps : this.instance.config.capture_heatmaps !== !1;
  }
  startIfEnabled() {
    if (this.isEnabled) {
      if (this.C) return;
      su.info("starting..."), this.se(), this.re = setInterval(this.ne.bind(this), this.flushIntervalMilliseconds);
    } else {
      var e, t;
      clearInterval((e = this.re) !== null && e !== void 0 ? e : void 0), (t = this.oe) == null || t.stop(), this.getAndClearBuffer();
    }
  }
  onRemoteConfig(e) {
    var t = !!e.heatmaps;
    this.instance.persistence && this.instance.persistence.register({ [li]: t }), this.Xi = t, this.startIfEnabled();
  }
  getAndClearBuffer() {
    var e = this.H;
    return this.H = void 0, e;
  }
  ae(e) {
    this.le(e.originalEvent, "deadclick");
  }
  se() {
    f && x && (J(f, "beforeunload", this.ne.bind(this)), J(x, "click", (e) => this.le(e || (f == null ? void 0 : f.event)), { capture: !0 }), J(x, "mousemove", (e) => this.he(e || (f == null ? void 0 : f.event)), { capture: !0 }), this.oe = new no(this.instance, Sl, this.ae.bind(this)), this.oe.startIfEnabled(), this.C = !0);
  }
  ue(e, t) {
    var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(a, l, u) {
      for (var c = a; c && Pr(c) && !Ke(c, "body"); ) {
        if (c === u) return !1;
        if (D(l, f == null ? void 0 : f.getComputedStyle(c).position)) return !0;
        c = Jn(c);
      }
      return !1;
    }(Vn(e), ["fixed", "sticky"], n);
    return { x: e.clientX + (o ? 0 : s), y: e.clientY + (o ? 0 : r), target_fixed: o, type: t };
  }
  le(e, t) {
    var r;
    if (t === void 0 && (t = "click"), !Fs(e.target) && en(e)) {
      var s = this.ue(e, t);
      (r = this.rageclicks) != null && r.isRageClick(e.clientX, e.clientY, (/* @__PURE__ */ new Date()).getTime()) && this.de(E({}, s, { type: "rageclick" })), this.de(s);
    }
  }
  he(e) {
    !Fs(e.target) && en(e) && (clearTimeout(this.ve), this.ve = setTimeout(() => {
      this.de(this.ue(e, "mousemove"));
    }, 500));
  }
  de(e) {
    if (f) {
      var t = f.location.href;
      this.H = this.H || {}, this.H[t] || (this.H[t] = []), this.H[t].push(e);
    }
  }
  ne() {
    this.H && !dt(this.H) && this.instance.capture("$$heatmap", { $heatmap_data: this.getAndClearBuffer() });
  }
}
class ou {
  constructor(e) {
    this._instance = e;
  }
  doPageView(e, t) {
    var r, s = this.ce(e, t);
    return this.fe = { pathname: (r = f == null ? void 0 : f.location.pathname) !== null && r !== void 0 ? r : "", pageViewId: t, timestamp: e }, this._instance.scrollManager.resetContext(), s;
  }
  doPageLeave(e) {
    var t;
    return this.ce(e, (t = this.fe) == null ? void 0 : t.pageViewId);
  }
  doEvent() {
    var e;
    return { $pageview_id: (e = this.fe) == null ? void 0 : e.pageViewId };
  }
  ce(e, t) {
    var r = this.fe;
    if (!r) return { $pageview_id: t };
    var s = { $pageview_id: t, $prev_pageview_id: r.pageViewId }, n = this._instance.scrollManager.getContext();
    if (n && !this._instance.config.disable_scroll_properties) {
      var { maxScrollHeight: o, lastScrollY: a, maxScrollY: l, maxContentHeight: u, lastContentY: c, maxContentY: d } = n;
      if (!(b(o) || b(a) || b(l) || b(u) || b(c) || b(d))) {
        o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), c = Math.ceil(c), d = Math.ceil(d);
        var h = o <= 1 ? 1 : Re(a / o, 0, 1, k), p = o <= 1 ? 1 : Re(l / o, 0, 1, k), g = u <= 1 ? 1 : Re(c / u, 0, 1, k), v = u <= 1 ? 1 : Re(d / u, 0, 1, k);
        s = Q(s, { $prev_pageview_last_scroll: a, $prev_pageview_last_scroll_percentage: h, $prev_pageview_max_scroll: l, $prev_pageview_max_scroll_percentage: p, $prev_pageview_last_content: c, $prev_pageview_last_content_percentage: g, $prev_pageview_max_content: d, $prev_pageview_max_content_percentage: v });
      }
    }
    return r.pathname && (s.$prev_pageview_pathname = r.pathname), r.timestamp && (s.$prev_pageview_duration = (e.getTime() - r.timestamp.getTime()) / 1e3), s;
  }
}
var au = function(i) {
  var e, t, r, s, n = "";
  for (e = t = 0, r = (i = (i + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`)).length, s = 0; s < r; s++) {
    var o = i.charCodeAt(s), a = null;
    o < 128 ? t++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), Ye(a) || (t > e && (n += i.substring(e, t)), n += a, e = t = s + 1);
  }
  return t > e && (n += i.substring(e, i.length)), n;
}, lu = !!ii || !!ri, tn = "text/plain", Sr = (i, e) => {
  var [t, r] = i.split("?"), s = E({}, e);
  r == null || r.split("&").forEach((o) => {
    var [a] = o.split("=");
    delete s[a];
  });
  var n = cl(s);
  return t + "?" + (n = n ? (r ? r + "&" : "") + n : r);
}, Lt = (i, e) => JSON.stringify(i, (t, r) => typeof r == "bigint" ? r.toString() : r, e), Xr = (i) => {
  var { data: e, compression: t } = i;
  if (e) {
    if (t === Be.GZipJS) {
      var r = ho(po(Lt(e)), { mtime: 0 }), s = new Blob([r], { type: tn });
      return { contentType: tn, body: s, estimatedSize: s.size };
    }
    if (t === Be.Base64) {
      var n = function(l) {
        var u, c, d, h, p, g = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", v = 0, _ = 0, w = "", $ = [];
        if (!l) return l;
        l = au(l);
        do
          u = (p = l.charCodeAt(v++) << 16 | l.charCodeAt(v++) << 8 | l.charCodeAt(v++)) >> 18 & 63, c = p >> 12 & 63, d = p >> 6 & 63, h = 63 & p, $[_++] = g.charAt(u) + g.charAt(c) + g.charAt(d) + g.charAt(h);
        while (v < l.length);
        switch (w = $.join(""), l.length % 3) {
          case 1:
            w = w.slice(0, -2) + "==";
            break;
          case 2:
            w = w.slice(0, -1) + "=";
        }
        return w;
      }(Lt(e)), o = ((l) => "data=" + encodeURIComponent(typeof l == "string" ? l : Lt(l)))(n);
      return { contentType: "application/x-www-form-urlencoded", body: o, estimatedSize: new Blob([o]).size };
    }
    var a = Lt(e);
    return { contentType: "application/json", body: a, estimatedSize: new Blob([a]).size };
  }
}, ar = [];
ri && ar.push({ transport: "fetch", method: (i) => {
  var e, t, { contentType: r, body: s, estimatedSize: n } = (e = Xr(i)) !== null && e !== void 0 ? e : {}, o = new Headers();
  z(i.headers, function(c, d) {
    o.append(d, c);
  }), r && o.append("Content-Type", r);
  var a = i.url, l = null;
  if (fs) {
    var u = new fs();
    l = { signal: u.signal, timeout: setTimeout(() => u.abort(), i.timeout) };
  }
  ri(a, E({ method: (i == null ? void 0 : i.method) || "GET", headers: o, keepalive: i.method === "POST" && (n || 0) < 52428.8, body: s, signal: (t = l) == null ? void 0 : t.signal }, i.fetchOptions)).then((c) => c.text().then((d) => {
    var h = { statusCode: c.status, text: d };
    if (c.status === 200) try {
      h.json = JSON.parse(d);
    } catch (p) {
      k.error(p);
    }
    i.callback == null || i.callback(h);
  })).catch((c) => {
    k.error(c), i.callback == null || i.callback({ statusCode: 0, text: c });
  }).finally(() => l ? clearTimeout(l.timeout) : null);
} }), ii && ar.push({ transport: "XHR", method: (i) => {
  var e, t = new ii();
  t.open(i.method || "GET", i.url, !0);
  var { contentType: r, body: s } = (e = Xr(i)) !== null && e !== void 0 ? e : {};
  z(i.headers, function(n, o) {
    t.setRequestHeader(o, n);
  }), r && t.setRequestHeader("Content-Type", r), i.timeout && (t.timeout = i.timeout), i.disableXHRCredentials || (t.withCredentials = !0), t.onreadystatechange = () => {
    if (t.readyState === 4) {
      var n = { statusCode: t.status, text: t.responseText };
      if (t.status === 200) try {
        n.json = JSON.parse(t.responseText);
      } catch {
      }
      i.callback == null || i.callback(n);
    }
  }, t.send(s);
} }), xe != null && xe.sendBeacon && ar.push({ transport: "sendBeacon", method: (i) => {
  var e = Sr(i.url, { beacon: "1" });
  try {
    var t, { contentType: r, body: s } = (t = Xr(i)) !== null && t !== void 0 ? t : {}, n = typeof s == "string" ? new Blob([s], { type: r }) : s;
    xe.sendBeacon(e, n);
  } catch {
  }
} });
var bt = function(i, e) {
  if (!function(t) {
    try {
      new RegExp(t);
    } catch {
      return !1;
    }
    return !0;
  }(e)) return !1;
  try {
    return new RegExp(e).test(i);
  } catch {
    return !1;
  }
};
function rn(i, e, t) {
  return Lt({ distinct_id: i, userPropertiesToSet: e, userPropertiesToSetOnce: t });
}
var mo = { exact: (i, e) => e.some((t) => i.some((r) => t === r)), is_not: (i, e) => e.every((t) => i.every((r) => t !== r)), regex: (i, e) => e.some((t) => i.some((r) => bt(t, r))), not_regex: (i, e) => e.every((t) => i.every((r) => !bt(t, r))), icontains: (i, e) => e.map(ir).some((t) => i.map(ir).some((r) => t.includes(r))), not_icontains: (i, e) => e.map(ir).every((t) => i.map(ir).every((r) => !t.includes(r))) }, ir = (i) => i.toLowerCase(), sn = te("[Error tracking]");
class uu {
  constructor(e) {
    var t, r;
    this.pe = [], this.ge = new ja([new Ha(), new Xa(), new Ua(), new qa(), new Wa(), new za(), new Ga(), new Va()], [$a, Na]), this._instance = e, this.pe = (t = (r = this._instance.persistence) == null ? void 0 : r.get_property(ui)) !== null && t !== void 0 ? t : [];
  }
  onRemoteConfig(e) {
    var t, r, s, n = (t = (r = e.errorTracking) == null ? void 0 : r.suppressionRules) !== null && t !== void 0 ? t : [], o = (s = e.errorTracking) == null ? void 0 : s.captureExtensionExceptions;
    this.pe = n, this._instance.persistence && this._instance.persistence.register({ [ui]: this.pe, [ks]: o });
  }
  get _e() {
    var e, t = !!this._instance.get_property(ks), r = this._instance.config.error_tracking.captureExtensionExceptions;
    return (e = r ?? t) !== null && e !== void 0 && e;
  }
  buildProperties(e, t) {
    return this.ge.buildFromUnknown(e, { syntheticException: t == null ? void 0 : t.syntheticException, mechanism: { handled: t == null ? void 0 : t.handled } });
  }
  sendExceptionEvent(e) {
    if (this.me(e)) sn.info("Skipping exception capture because a suppression rule matched");
    else {
      if (this._e || !this.ye(e)) return this._instance.capture("$exception", e, { _noTruncate: !0, _batchKey: "exceptionEvent" });
      sn.info("Skipping exception capture because it was thrown by an extension");
    }
  }
  me(e) {
    var t = e.$exception_list;
    if (!t || !W(t) || t.length === 0) return !1;
    var r = t.reduce((s, n) => {
      var { type: o, value: a } = n;
      return Z(o) && o.length > 0 && s.$exception_types.push(o), Z(a) && a.length > 0 && s.$exception_values.push(a), s;
    }, { $exception_types: [], $exception_values: [] });
    return this.pe.some((s) => {
      var n = s.values.map((o) => {
        var a, l = mo[o.operator], u = W(o.value) ? o.value : [o.value], c = (a = r[o.key]) !== null && a !== void 0 ? a : [];
        return u.length > 0 && l(u, c);
      });
      return s.type === "OR" ? n.some(Boolean) : n.every(Boolean);
    });
  }
  ye(e) {
    var t = e.$exception_list;
    return !(!t || !W(t)) && t.flatMap((r) => {
      var s, n;
      return (s = (n = r.stacktrace) == null ? void 0 : n.frames) !== null && s !== void 0 ? s : [];
    }).some((r) => r.filename && r.filename.startsWith("chrome-extension://"));
  }
}
var Ce = "Mobile", kr = "iOS", $e = "Android", Ut = "Tablet", yo = $e + " " + Ut, bo = "iPad", wo = "Apple", Eo = wo + " Watch", Bt = "Safari", wt = "BlackBerry", So = "Samsung", ko = So + "Browser", xo = So + " Internet", lt = "Chrome", cu = lt + " OS", Ro = lt + " " + kr, Vi = "Internet Explorer", To = Vi + " " + Ce, Xi = "Opera", du = Xi + " Mini", Ji = "Edge", Io = "Microsoft " + Ji, ft = "Firefox", Po = ft + " " + kr, Gt = "Nintendo", Yt = "PlayStation", vt = "Xbox", Co = $e + " " + Ce, Oo = Ce + " " + Bt, Nt = "Windows", Ri = Nt + " Phone", nn = "Nokia", Ti = "Ouya", Ao = "Generic", hu = Ao + " " + Ce.toLowerCase(), Fo = Ao + " " + Ut.toLowerCase(), Ii = "Konqueror", ve = "(\\d+(\\.\\d+)?)", Jr = new RegExp("Version/" + ve), pu = new RegExp(vt, "i"), fu = new RegExp(Yt + " \\w+", "i"), vu = new RegExp(Gt + " \\w+", "i"), Ki = new RegExp(wt + "|PlayBook|BB10", "i"), gu = { "NT3.51": "NT 3.11", "NT4.0": "NT 4.0", "5.0": "2000", 5.1: "XP", 5.2: "XP", "6.0": "Vista", 6.1: "7", 6.2: "8", 6.3: "8.1", 6.4: "10", "10.0": "10" }, _u = (i, e) => e && D(e, wo) || function(t) {
  return D(t, Bt) && !D(t, lt) && !D(t, $e);
}(i), $o = function(i, e) {
  return e = e || "", D(i, " OPR/") && D(i, "Mini") ? du : D(i, " OPR/") ? Xi : Ki.test(i) ? wt : D(i, "IE" + Ce) || D(i, "WPDesktop") ? To : D(i, ko) ? xo : D(i, Ji) || D(i, "Edg/") ? Io : D(i, "FBIOS") ? "Facebook " + Ce : D(i, "UCWEB") || D(i, "UCBrowser") ? "UC Browser" : D(i, "CriOS") ? Ro : D(i, "CrMo") || D(i, lt) ? lt : D(i, $e) && D(i, Bt) ? Co : D(i, "FxiOS") ? Po : D(i.toLowerCase(), Ii.toLowerCase()) ? Ii : _u(i, e) ? D(i, Ce) ? Oo : Bt : D(i, ft) ? ft : D(i, "MSIE") || D(i, "Trident/") ? Vi : D(i, "Gecko") ? ft : "";
}, mu = { [To]: [new RegExp("rv:" + ve)], [Io]: [new RegExp(Ji + "?\\/" + ve)], [lt]: [new RegExp("(" + lt + "|CrMo)\\/" + ve)], [Ro]: [new RegExp("CriOS\\/" + ve)], "UC Browser": [new RegExp("(UCBrowser|UCWEB)\\/" + ve)], [Bt]: [Jr], [Oo]: [Jr], [Xi]: [new RegExp("(Opera|OPR)\\/" + ve)], [ft]: [new RegExp(ft + "\\/" + ve)], [Po]: [new RegExp("FxiOS\\/" + ve)], [Ii]: [new RegExp("Konqueror[:/]?" + ve, "i")], [wt]: [new RegExp(wt + " " + ve), Jr], [Co]: [new RegExp("android\\s" + ve, "i")], [xo]: [new RegExp(ko + "\\/" + ve)], [Vi]: [new RegExp("(rv:|MSIE )" + ve)], Mozilla: [new RegExp("rv:" + ve)] }, yu = function(i, e) {
  var t = $o(i, e), r = mu[t];
  if (b(r)) return null;
  for (var s = 0; s < r.length; s++) {
    var n = r[s], o = i.match(n);
    if (o) return parseFloat(o[o.length - 2]);
  }
  return null;
}, on = [[new RegExp(vt + "; " + vt + " (.*?)[);]", "i"), (i) => [vt, i && i[1] || ""]], [new RegExp(Gt, "i"), [Gt, ""]], [new RegExp(Yt, "i"), [Yt, ""]], [Ki, [wt, ""]], [new RegExp(Nt, "i"), (i, e) => {
  if (/Phone/.test(e) || /WPDesktop/.test(e)) return [Ri, ""];
  if (new RegExp(Ce).test(e) && !/IEMobile\b/.test(e)) return [Nt + " " + Ce, ""];
  var t = /Windows NT ([0-9.]+)/i.exec(e);
  if (t && t[1]) {
    var r = t[1], s = gu[r] || "";
    return /arm/i.test(e) && (s = "RT"), [Nt, s];
  }
  return [Nt, ""];
}], [/((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/, (i) => {
  if (i && i[3]) {
    var e = [i[3], i[4], i[5] || "0"];
    return [kr, e.join(".")];
  }
  return [kr, ""];
}], [/(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i, (i) => {
  var e = "";
  return i && i.length >= 3 && (e = b(i[2]) ? i[3] : i[2]), ["watchOS", e];
}], [new RegExp("(" + $e + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $e + ")", "i"), (i) => {
  if (i && i[2]) {
    var e = [i[2], i[3], i[4] || "0"];
    return [$e, e.join(".")];
  }
  return [$e, ""];
}], [/Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i, (i) => {
  var e = ["Mac OS X", ""];
  if (i && i[1]) {
    var t = [i[1], i[2], i[3] || "0"];
    e[1] = t.join(".");
  }
  return e;
}], [/Mac/i, ["Mac OS X", ""]], [/CrOS/, [cu, ""]], [/Linux|debian/i, ["Linux", ""]]], an = function(i) {
  return vu.test(i) ? Gt : fu.test(i) ? Yt : pu.test(i) ? vt : new RegExp(Ti, "i").test(i) ? Ti : new RegExp("(" + Ri + "|WPDesktop)", "i").test(i) ? Ri : /iPad/.test(i) ? bo : /iPod/.test(i) ? "iPod Touch" : /iPhone/.test(i) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(i) ? Eo : Ki.test(i) ? wt : /(kobo)\s(ereader|touch)/i.test(i) ? "Kobo" : new RegExp(nn, "i").test(i) ? nn : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(i) || /(kf[a-z]+)( bui|\)).+silk\//i.test(i) ? "Kindle Fire" : /(Android|ZTE)/i.test(i) ? !new RegExp(Ce).test(i) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(i) ? /pixel[\daxl ]{1,6}/i.test(i) && !/pixel c/i.test(i) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(i) || /lmy47v/i.test(i) && !/QTAQZ3/i.test(i) ? $e : yo : $e : new RegExp("(pda|" + Ce + ")", "i").test(i) ? hu : new RegExp(Ut, "i").test(i) && !new RegExp(Ut + " pc", "i").test(i) ? Fo : "";
}, sr = "https?://(.*)", Or = ["gclid", "gclsrc", "dclid", "gbraid", "wbraid", "fbclid", "msclkid", "twclid", "li_fat_id", "igshid", "ttclid", "rdt_cid", "epik", "qclid", "sccid", "irclid", "_kx"], bu = Ir(["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gad_source", "mc_cid"], Or), Zi = "<masked>", wu = ["li_fat_id"];
function Mo(i, e, t) {
  if (!x) return {};
  var r, s = e ? Ir([], Or, t || []) : [], n = Lo(Ui(x.URL, s, Zi), i), o = (r = {}, z(wu, function(a) {
    var l = Me.J(a);
    r[a] = l || null;
  }), r);
  return Q(o, n);
}
function Lo(i, e) {
  var t = bu.concat(e || []), r = {};
  return z(t, function(s) {
    var n = _r(i, s);
    r[s] = n || null;
  }), r;
}
function No(i) {
  var e = function(n) {
    return n ? n.search(sr + "google.([^/?]*)") === 0 ? "google" : n.search(sr + "bing.com") === 0 ? "bing" : n.search(sr + "yahoo.com") === 0 ? "yahoo" : n.search(sr + "duckduckgo.com") === 0 ? "duckduckgo" : null : null;
  }(i), t = e != "yahoo" ? "q" : "p", r = {};
  if (!Ye(e)) {
    r.$search_engine = e;
    var s = x ? _r(x.referrer, t) : "";
    s.length && (r.ph_keyword = s);
  }
  return r;
}
function ln() {
  return navigator.language || navigator.userLanguage;
}
function Do() {
  return (x == null ? void 0 : x.referrer) || "$direct";
}
function jo(i, e) {
  var t = i ? Ir([], Or, e || []) : [], r = we == null ? void 0 : we.href.substring(0, 1e3);
  return { r: Do().substring(0, 1e3), u: r ? Ui(r, t, Zi) : void 0 };
}
function Ho(i) {
  var e, { r: t, u: r } = i, s = { $referrer: t, $referring_domain: t == null ? void 0 : t == "$direct" ? "$direct" : (e = mt(t)) == null ? void 0 : e.host };
  if (r) {
    s.$current_url = r;
    var n = mt(r);
    s.$host = n == null ? void 0 : n.host, s.$pathname = n == null ? void 0 : n.pathname;
    var o = Lo(r);
    Q(s, o);
  }
  if (t) {
    var a = No(t);
    Q(s, a);
  }
  return s;
}
function qo() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return;
  }
}
function Eu() {
  try {
    return (/* @__PURE__ */ new Date()).getTimezoneOffset();
  } catch {
    return;
  }
}
function Su(i, e) {
  if (!be) return {};
  var t, r, s, n = i ? Ir([], Or, e || []) : [], [o, a] = function(l) {
    for (var u = 0; u < on.length; u++) {
      var [c, d] = on[u], h = c.exec(l), p = h && (Ie(d) ? d(h, l) : d);
      if (p) return p;
    }
    return ["", ""];
  }(be);
  return Q(Di({ $os: o, $os_version: a, $browser: $o(be, navigator.vendor), $device: an(be), $device_type: (r = be, s = an(r), s === bo || s === yo || s === "Kobo" || s === "Kindle Fire" || s === Fo ? Ut : s === Gt || s === vt || s === Yt || s === Ti ? "Console" : s === Eo ? "Wearable" : s ? Ce : "Desktop"), $timezone: qo(), $timezone_offset: Eu() }), { $current_url: Ui(we == null ? void 0 : we.href, n, Zi), $host: we == null ? void 0 : we.host, $pathname: we == null ? void 0 : we.pathname, $raw_user_agent: be.length > 1e3 ? be.substring(0, 997) + "..." : be, $browser_version: yu(be, navigator.vendor), $browser_language: ln(), $browser_language_prefix: (t = ln(), typeof t == "string" ? t.split("-")[0] : void 0), $screen_height: f == null ? void 0 : f.screen.height, $screen_width: f == null ? void 0 : f.screen.width, $viewport_height: f == null ? void 0 : f.innerHeight, $viewport_width: f == null ? void 0 : f.innerWidth, $lib: "web", $lib_version: Ue.LIB_VERSION, $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10), $time: Date.now() / 1e3 });
}
var Fe = te("[FeatureFlags]"), Kr = "$active_feature_flags", ut = "$override_feature_flags", un = "$feature_flag_payloads", Pt = "$override_feature_flag_payloads", cn = "$feature_flag_request_id", dn = (i) => {
  var e = {};
  for (var [t, r] of or(i || {})) r && (e[t] = r);
  return e;
}, ku = (i) => {
  var e = i.flags;
  return e ? (i.featureFlags = Object.fromEntries(Object.keys(e).map((t) => {
    var r;
    return [t, (r = e[t].variant) !== null && r !== void 0 ? r : e[t].enabled];
  })), i.featureFlagPayloads = Object.fromEntries(Object.keys(e).filter((t) => e[t].enabled).filter((t) => {
    var r;
    return (r = e[t].metadata) == null ? void 0 : r.payload;
  }).map((t) => {
    var r;
    return [t, (r = e[t].metadata) == null ? void 0 : r.payload];
  }))) : Fe.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), i;
}, xu = function(i) {
  return i.FeatureFlags = "feature_flags", i.Recordings = "recordings", i;
}({});
class Ru {
  constructor(e) {
    this.be = !1, this.we = !1, this.Se = !1, this.ke = !1, this.$e = !1, this.xe = !1, this.Ee = !1, this._instance = e, this.featureFlagEventHandlers = [];
  }
  flags() {
    if (this._instance.config.__preview_remote_config) this.xe = !0;
    else {
      var e = !this.Pe && (this._instance.config.advanced_disable_feature_flags || this._instance.config.advanced_disable_feature_flags_on_first_load);
      this.Ie({ disableFlags: e });
    }
  }
  get hasLoadedFlags() {
    return this.we;
  }
  getFlags() {
    return Object.keys(this.getFlagVariants());
  }
  getFlagsWithDetails() {
    var e = this._instance.get_property(hi), t = this._instance.get_property(ut), r = this._instance.get_property(Pt);
    if (!r && !t) return e || {};
    var s = Q({}, e || {}), n = [.../* @__PURE__ */ new Set([...Object.keys(r || {}), ...Object.keys(t || {})])];
    for (var o of n) {
      var a, l, u = s[o], c = t == null ? void 0 : t[o], d = b(c) ? (a = u == null ? void 0 : u.enabled) !== null && a !== void 0 && a : !!c, h = b(c) ? u.variant : typeof c == "string" ? c : void 0, p = r == null ? void 0 : r[o], g = E({}, u, { enabled: d, variant: d ? h ?? (u == null ? void 0 : u.variant) : void 0 });
      d !== (u == null ? void 0 : u.enabled) && (g.original_enabled = u == null ? void 0 : u.enabled), h !== (u == null ? void 0 : u.variant) && (g.original_variant = u == null ? void 0 : u.variant), p && (g.metadata = E({}, u == null ? void 0 : u.metadata, { payload: p, original_payload: u == null || (l = u.metadata) == null ? void 0 : l.payload })), s[o] = g;
    }
    return this.be || (Fe.warn(" Overriding feature flag details!", { flagDetails: e, overriddenPayloads: r, finalDetails: s }), this.be = !0), s;
  }
  getFlagVariants() {
    var e = this._instance.get_property(ht), t = this._instance.get_property(ut);
    if (!t) return e || {};
    for (var r = Q({}, e), s = Object.keys(t), n = 0; n < s.length; n++) r[s[n]] = t[s[n]];
    return this.be || (Fe.warn(" Overriding feature flags!", { enabledFlags: e, overriddenFlags: t, finalFlags: r }), this.be = !0), r;
  }
  getFlagPayloads() {
    var e = this._instance.get_property(un), t = this._instance.get_property(Pt);
    if (!t) return e || {};
    for (var r = Q({}, e || {}), s = Object.keys(t), n = 0; n < s.length; n++) r[s[n]] = t[s[n]];
    return this.be || (Fe.warn(" Overriding feature flag payloads!", { flagPayloads: e, overriddenPayloads: t, finalPayloads: r }), this.be = !0), r;
  }
  reloadFeatureFlags() {
    this.ke || this._instance.config.advanced_disable_feature_flags || this.Pe || (this.Pe = setTimeout(() => {
      this.Ie();
    }, 5));
  }
  Re() {
    clearTimeout(this.Pe), this.Pe = void 0;
  }
  ensureFlagsLoaded() {
    this.we || this.Se || this.Pe || this.reloadFeatureFlags();
  }
  setAnonymousDistinctId(e) {
    this.$anon_distinct_id = e;
  }
  setReloadingPaused(e) {
    this.ke = e;
  }
  Ie(e) {
    var t;
    if (this.Re(), !this._instance.L()) if (this.Se) this.$e = !0;
    else {
      var r = { token: this._instance.config.token, distinct_id: this._instance.get_distinct_id(), groups: this._instance.getGroups(), $anon_distinct_id: this.$anon_distinct_id, person_properties: E({}, ((t = this._instance.persistence) == null ? void 0 : t.get_initial_props()) || {}, this._instance.get_property($t) || {}), group_properties: this._instance.get_property(st) };
      (e != null && e.disableFlags || this._instance.config.advanced_disable_feature_flags) && (r.disable_flags = !0);
      var s = this._instance.config.__preview_remote_config, n = s ? "/flags/?v=2" : "/flags/?v=2&config=true", o = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", a = this._instance.requestRouter.endpointFor("api", n + o);
      s && (r.timezone = qo()), this.Se = !0, this._instance.Te({ method: "POST", url: a, data: r, compression: this._instance.config.disable_compression ? void 0 : Be.Base64, timeout: this._instance.config.feature_flag_request_timeout_ms, callback: (l) => {
        var u, c, d = !0;
        if (l.statusCode === 200 && (this.$e || (this.$anon_distinct_id = void 0), d = !1), this.Se = !1, this.xe || (this.xe = !0, this._instance.Ce((c = l.json) !== null && c !== void 0 ? c : {})), !r.disable_flags || this.$e) if (this.Ee = !d, l.json && (u = l.json.quotaLimited) != null && u.includes(xu.FeatureFlags)) Fe.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
        else {
          var h;
          r.disable_flags || this.receivedFeatureFlags((h = l.json) !== null && h !== void 0 ? h : {}, d), this.$e && (this.$e = !1, this.Ie());
        }
      } });
    }
  }
  getFeatureFlag(e, t) {
    if (t === void 0 && (t = {}), this.we || this.getFlags() && this.getFlags().length > 0) {
      var r = this.getFlagVariants()[e], s = "" + r, n = this._instance.get_property(cn) || void 0, o = this._instance.get_property(pr) || {};
      if ((t.send_event || !("send_event" in t)) && (!(e in o) || !o[e].includes(s))) {
        var a, l, u, c, d, h, p, g, v;
        W(o[e]) ? o[e].push(s) : o[e] = [s], (a = this._instance.persistence) == null || a.register({ [pr]: o });
        var _ = this.getFeatureFlagDetails(e), w = { $feature_flag: e, $feature_flag_response: r, $feature_flag_payload: this.getFeatureFlagPayload(e) || null, $feature_flag_request_id: n, $feature_flag_bootstrapped_response: ((l = this._instance.config.bootstrap) == null || (l = l.featureFlags) == null ? void 0 : l[e]) || null, $feature_flag_bootstrapped_payload: ((u = this._instance.config.bootstrap) == null || (u = u.featureFlagPayloads) == null ? void 0 : u[e]) || null, $used_bootstrap_value: !this.Ee };
        b(_ == null || (c = _.metadata) == null ? void 0 : c.version) || (w.$feature_flag_version = _.metadata.version);
        var $, I = (d = _ == null || (h = _.reason) == null ? void 0 : h.description) !== null && d !== void 0 ? d : _ == null || (p = _.reason) == null ? void 0 : p.code;
        I && (w.$feature_flag_reason = I), _ != null && (g = _.metadata) != null && g.id && (w.$feature_flag_id = _.metadata.id), b(_ == null ? void 0 : _.original_variant) && b(_ == null ? void 0 : _.original_enabled) || (w.$feature_flag_original_response = b(_.original_variant) ? _.original_enabled : _.original_variant), _ != null && (v = _.metadata) != null && v.original_payload && (w.$feature_flag_original_payload = _ == null || ($ = _.metadata) == null ? void 0 : $.original_payload), this._instance.capture("$feature_flag_called", w);
      }
      return r;
    }
    Fe.warn('getFeatureFlag for key "' + e + `" failed. Feature flags didn't load in time.`);
  }
  getFeatureFlagDetails(e) {
    return this.getFlagsWithDetails()[e];
  }
  getFeatureFlagPayload(e) {
    return this.getFlagPayloads()[e];
  }
  getRemoteConfigPayload(e, t) {
    var r = this._instance.config.token;
    this._instance.Te({ method: "POST", url: this._instance.requestRouter.endpointFor("api", "/flags/?v=2&config=true"), data: { distinct_id: this._instance.get_distinct_id(), token: r }, compression: this._instance.config.disable_compression ? void 0 : Be.Base64, timeout: this._instance.config.feature_flag_request_timeout_ms, callback: (s) => {
      var n, o = (n = s.json) == null ? void 0 : n.featureFlagPayloads;
      t((o == null ? void 0 : o[e]) || void 0);
    } });
  }
  isFeatureEnabled(e, t) {
    if (t === void 0 && (t = {}), this.we || this.getFlags() && this.getFlags().length > 0) {
      var r = this.getFeatureFlag(e, t);
      return b(r) ? void 0 : !!r;
    }
    Fe.warn('isFeatureEnabled for key "' + e + `" failed. Feature flags didn't load in time.`);
  }
  addFeatureFlagsHandler(e) {
    this.featureFlagEventHandlers.push(e);
  }
  removeFeatureFlagsHandler(e) {
    this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((t) => t !== e);
  }
  receivedFeatureFlags(e, t) {
    if (this._instance.persistence) {
      this.we = !0;
      var r = this.getFlagVariants(), s = this.getFlagPayloads(), n = this.getFlagsWithDetails();
      (function(o, a, l, u, c) {
        l === void 0 && (l = {}), u === void 0 && (u = {}), c === void 0 && (c = {});
        var d = ku(o), h = d.flags, p = d.featureFlags, g = d.featureFlagPayloads;
        if (p) {
          var v = o.requestId;
          if (W(p)) {
            Fe.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
            var _ = {};
            if (p) for (var w = 0; w < p.length; w++) _[p[w]] = !0;
            a && a.register({ [Kr]: p, [ht]: _ });
          } else {
            var $ = p, I = g, T = h;
            o.errorsWhileComputingFlags && ($ = E({}, l, $), I = E({}, u, I), T = E({}, c, T)), a && a.register(E({ [Kr]: Object.keys(dn($)), [ht]: $ || {}, [un]: I || {}, [hi]: T || {} }, v ? { [cn]: v } : {}));
          }
        }
      })(e, this._instance.persistence, r, s, n), this.Me(t);
    }
  }
  override(e, t) {
    t === void 0 && (t = !1), Fe.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({ flags: e, suppressWarning: t });
  }
  overrideFeatureFlags(e) {
    if (!this._instance.__loaded || !this._instance.persistence) return Fe.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
    if (e === !1) return this._instance.persistence.unregister(ut), this._instance.persistence.unregister(Pt), void this.Me();
    if (e && typeof e == "object" && ("flags" in e || "payloads" in e)) {
      var t, r = e;
      if (this.be = !!((t = r.suppressWarning) !== null && t !== void 0 && t), "flags" in r) {
        if (r.flags === !1) this._instance.persistence.unregister(ut);
        else if (r.flags) if (W(r.flags)) {
          for (var s = {}, n = 0; n < r.flags.length; n++) s[r.flags[n]] = !0;
          this._instance.persistence.register({ [ut]: s });
        } else this._instance.persistence.register({ [ut]: r.flags });
      }
      return "payloads" in r && (r.payloads === !1 ? this._instance.persistence.unregister(Pt) : r.payloads && this._instance.persistence.register({ [Pt]: r.payloads })), void this.Me();
    }
    this.Me();
  }
  onFeatureFlags(e) {
    if (this.addFeatureFlagsHandler(e), this.we) {
      var { flags: t, flagVariants: r } = this.Oe();
      e(t, r);
    }
    return () => this.removeFeatureFlagsHandler(e);
  }
  updateEarlyAccessFeatureEnrollment(e, t, r) {
    var s, n = (this._instance.get_property(Ft) || []).find((u) => u.flagKey === e), o = { ["$feature_enrollment/" + e]: t }, a = { $feature_flag: e, $feature_enrollment: t, $set: o };
    n && (a.$early_access_feature_name = n.name), r && (a.$feature_enrollment_stage = r), this._instance.capture("$feature_enrollment_update", a), this.setPersonPropertiesForFlags(o, !1);
    var l = E({}, this.getFlagVariants(), { [e]: t });
    (s = this._instance.persistence) == null || s.register({ [Kr]: Object.keys(dn(l)), [ht]: l }), this.Me();
  }
  getEarlyAccessFeatures(e, t, r) {
    t === void 0 && (t = !1);
    var s = this._instance.get_property(Ft), n = r ? "&" + r.map((o) => "stage=" + o).join("&") : "";
    if (s && !t) return e(s);
    this._instance.Te({ url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + n), method: "GET", callback: (o) => {
      var a, l;
      if (o.json) {
        var u = o.json.earlyAccessFeatures;
        return (a = this._instance.persistence) == null || a.unregister(Ft), (l = this._instance.persistence) == null || l.register({ [Ft]: u }), e(u);
      }
    } });
  }
  Oe() {
    var e = this.getFlags(), t = this.getFlagVariants();
    return { flags: e.filter((r) => t[r]), flagVariants: Object.keys(t).filter((r) => t[r]).reduce((r, s) => (r[s] = t[s], r), {}) };
  }
  Me(e) {
    var { flags: t, flagVariants: r } = this.Oe();
    this.featureFlagEventHandlers.forEach((s) => s(t, r, { errorsLoading: e }));
  }
  setPersonPropertiesForFlags(e, t) {
    t === void 0 && (t = !0);
    var r = this._instance.get_property($t) || {};
    this._instance.register({ [$t]: E({}, r, e) }), t && this._instance.reloadFeatureFlags();
  }
  resetPersonPropertiesForFlags() {
    this._instance.unregister($t);
  }
  setGroupPropertiesForFlags(e, t) {
    t === void 0 && (t = !0);
    var r = this._instance.get_property(st) || {};
    Object.keys(r).length !== 0 && Object.keys(r).forEach((s) => {
      r[s] = E({}, r[s], e[s]), delete e[s];
    }), this._instance.register({ [st]: E({}, r, e) }), t && this._instance.reloadFeatureFlags();
  }
  resetGroupPropertiesForFlags(e) {
    if (e) {
      var t = this._instance.get_property(st) || {};
      this._instance.register({ [st]: E({}, t, { [e]: {} }) });
    } else this._instance.unregister(st);
  }
  reset() {
    this.we = !1, this.Se = !1, this.ke = !1, this.$e = !1, this.xe = !1, this.Ee = !1, this.$anon_distinct_id = void 0, this.Re(), this.be = !1;
  }
}
var Tu = ["cookie", "localstorage", "localstorage+cookie", "sessionstorage", "memory"];
class Zr {
  constructor(e, t) {
    this.A = e, this.props = {}, this.Fe = !1, this.Ae = ((r) => {
      var s = "";
      return r.token && (s = r.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), r.persistence_name ? "ph_" + r.persistence_name : "ph_" + s + "_posthog";
    })(e), this.it = this.De(e), this.load(), e.debug && k.info("Persistence loaded", e.persistence, E({}, this.props)), this.update_config(e, e, t), this.save();
  }
  isDisabled() {
    return !!this.je;
  }
  De(e) {
    Tu.indexOf(e.persistence.toLowerCase()) === -1 && (k.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
    var t = e.persistence.toLowerCase();
    return t === "localstorage" && ee.G() ? ee : t === "localstorage+cookie" && Zt.G() ? Zt : t === "sessionstorage" && ae.G() ? ae : t === "memory" ? wl : t === "cookie" ? Me : Zt.G() ? Zt : Me;
  }
  properties() {
    var e = {};
    return z(this.props, function(t, r) {
      if (r === ht && K(t)) for (var s = Object.keys(t), n = 0; n < s.length; n++) e["$feature/" + s[n]] = t[s[n]];
      else a = r, l = !1, (Ye(o = tl) ? l : ps && o.indexOf === ps ? o.indexOf(a) != -1 : (z(o, function(u) {
        if (l || (l = u === a)) return cr;
      }), l)) || (e[r] = t);
      var o, a, l;
    }), e;
  }
  load() {
    if (!this.je) {
      var e = this.it.K(this.Ae);
      e && (this.props = Q({}, e));
    }
  }
  save() {
    this.je || this.it.Y(this.Ae, this.props, this.Le, this.Ne, this.Ue, this.A.debug);
  }
  remove() {
    this.it.X(this.Ae, !1), this.it.X(this.Ae, !0);
  }
  clear() {
    this.remove(), this.props = {};
  }
  register_once(e, t, r) {
    if (K(e)) {
      b(t) && (t = "None"), this.Le = b(r) ? this.ze : r;
      var s = !1;
      if (z(e, (n, o) => {
        this.props.hasOwnProperty(o) && this.props[o] !== t || (this.props[o] = n, s = !0);
      }), s) return this.save(), !0;
    }
    return !1;
  }
  register(e, t) {
    if (K(e)) {
      this.Le = b(t) ? this.ze : t;
      var r = !1;
      if (z(e, (s, n) => {
        e.hasOwnProperty(n) && this.props[n] !== s && (this.props[n] = s, r = !0);
      }), r) return this.save(), !0;
    }
    return !1;
  }
  unregister(e) {
    e in this.props && (delete this.props[e], this.save());
  }
  update_campaign_params() {
    if (!this.Fe) {
      var e = Mo(this.A.custom_campaign_params, this.A.mask_personal_data_properties, this.A.custom_personal_data_properties);
      dt(Di(e)) || this.register(e), this.Fe = !0;
    }
  }
  update_search_keyword() {
    var e;
    this.register((e = x == null ? void 0 : x.referrer) ? No(e) : {});
  }
  update_referrer_info() {
    var e;
    this.register_once({ $referrer: Do(), $referring_domain: x != null && x.referrer && ((e = mt(x.referrer)) == null ? void 0 : e.host) || "$direct" }, void 0);
  }
  set_initial_person_info() {
    this.props[gi] || this.props[_i] || this.register_once({ [fr]: jo(this.A.mask_personal_data_properties, this.A.custom_personal_data_properties) }, void 0);
  }
  get_initial_props() {
    var e = {};
    z([_i, gi], (o) => {
      var a = this.props[o];
      a && z(a, function(l, u) {
        e["$initial_" + si(u)] = l;
      });
    });
    var t, r, s = this.props[fr];
    if (s) {
      var n = (t = Ho(s), r = {}, z(t, function(o, a) {
        r["$initial_" + si(a)] = o;
      }), r);
      Q(e, n);
    }
    return e;
  }
  safe_merge(e) {
    return z(this.props, function(t, r) {
      r in e || (e[r] = t);
    }), e;
  }
  update_config(e, t, r) {
    if (this.ze = this.Le = e.cookie_expiration, this.set_disabled(e.disable_persistence || !!r), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie), e.persistence !== t.persistence) {
      var s = this.De(e), n = this.props;
      this.clear(), this.it = s, this.props = n, this.save();
    }
  }
  set_disabled(e) {
    this.je = e, this.je ? this.remove() : this.save();
  }
  set_cross_subdomain(e) {
    e !== this.Ne && (this.Ne = e, this.remove(), this.save());
  }
  set_secure(e) {
    e !== this.Ue && (this.Ue = e, this.remove(), this.save());
  }
  set_event_timer(e, t) {
    var r = this.props[Ot] || {};
    r[e] = t, this.props[Ot] = r, this.save();
  }
  remove_event_timer(e) {
    var t = (this.props[Ot] || {})[e];
    return b(t) || (delete this.props[Ot][e], this.save()), t;
  }
  get_property(e) {
    return this.props[e];
  }
  set_property(e, t) {
    this.props[e] = t, this.save();
  }
}
(function(i) {
  return i.Button = "button", i.Tab = "tab", i.Selector = "selector", i;
})({});
(function(i) {
  return i.TopLeft = "top_left", i.TopRight = "top_right", i.TopCenter = "top_center", i.MiddleLeft = "middle_left", i.MiddleRight = "middle_right", i.MiddleCenter = "middle_center", i.Left = "left", i.Center = "center", i.Right = "right", i.NextToTrigger = "next_to_trigger", i;
})({});
var Qr = function(i) {
  return i.Popover = "popover", i.API = "api", i.Widget = "widget", i.ExternalSurvey = "external_survey", i;
}({});
(function(i) {
  return i.Open = "open", i.MultipleChoice = "multiple_choice", i.SingleChoice = "single_choice", i.Rating = "rating", i.Link = "link", i;
})({});
(function(i) {
  return i.NextQuestion = "next_question", i.End = "end", i.ResponseBased = "response_based", i.SpecificQuestion = "specific_question", i;
})({});
(function(i) {
  return i.Once = "once", i.Recurring = "recurring", i.Always = "always", i;
})({});
var lr = function(i) {
  return i.SHOWN = "survey shown", i.DISMISSED = "survey dismissed", i.SENT = "survey sent", i;
}({}), hn = function(i) {
  return i.SURVEY_ID = "$survey_id", i.SURVEY_NAME = "$survey_name", i.SURVEY_RESPONSE = "$survey_response", i.SURVEY_ITERATION = "$survey_iteration", i.SURVEY_ITERATION_START_DATE = "$survey_iteration_start_date", i.SURVEY_PARTIALLY_COMPLETED = "$survey_partially_completed", i.SURVEY_SUBMISSION_ID = "$survey_submission_id", i.SURVEY_QUESTIONS = "$survey_questions", i.SURVEY_COMPLETED = "$survey_completed", i;
}({}), Uo = function(i) {
  return i.Popover = "popover", i.Inline = "inline", i;
}({});
class Bo {
  constructor() {
    this.qe = {}, this.qe = {};
  }
  on(e, t) {
    return this.qe[e] || (this.qe[e] = []), this.qe[e].push(t), () => {
      this.qe[e] = this.qe[e].filter((r) => r !== t);
    };
  }
  emit(e, t) {
    for (var r of this.qe[e] || []) r(t);
    for (var s of this.qe["*"] || []) s(e, t);
  }
}
class nt {
  constructor(e) {
    this.Be = new Bo(), this.He = (t, r) => this.We(t, r) && this.Ge(t, r) && this.Ve(t, r), this.We = (t, r) => r == null || !r.event || (t == null ? void 0 : t.event) === (r == null ? void 0 : r.event), this._instance = e, this.Je = /* @__PURE__ */ new Set(), this.Ke = /* @__PURE__ */ new Set();
  }
  init() {
    var e;
    if (!b((e = this._instance) == null ? void 0 : e.Ye)) {
      var t;
      (t = this._instance) == null || t.Ye((r, s) => {
        this.on(r, s);
      });
    }
  }
  register(e) {
    var t, r;
    if (!b((t = this._instance) == null ? void 0 : t.Ye) && (e.forEach((o) => {
      var a, l;
      (a = this.Ke) == null || a.add(o), (l = o.steps) == null || l.forEach((u) => {
        var c;
        (c = this.Je) == null || c.add((u == null ? void 0 : u.event) || "");
      });
    }), (r = this._instance) != null && r.autocapture)) {
      var s, n = /* @__PURE__ */ new Set();
      e.forEach((o) => {
        var a;
        (a = o.steps) == null || a.forEach((l) => {
          l != null && l.selector && n.add(l == null ? void 0 : l.selector);
        });
      }), (s = this._instance) == null || s.autocapture.setElementSelectors(n);
    }
  }
  on(e, t) {
    var r;
    t != null && e.length != 0 && (this.Je.has(e) || this.Je.has(t == null ? void 0 : t.event)) && this.Ke && ((r = this.Ke) == null ? void 0 : r.size) > 0 && this.Ke.forEach((s) => {
      this.Xe(t, s) && this.Be.emit("actionCaptured", s.name);
    });
  }
  Qe(e) {
    this.onAction("actionCaptured", (t) => e(t));
  }
  Xe(e, t) {
    if ((t == null ? void 0 : t.steps) == null) return !1;
    for (var r of t.steps) if (this.He(e, r)) return !0;
    return !1;
  }
  onAction(e, t) {
    return this.Be.on(e, t);
  }
  Ge(e, t) {
    if (t != null && t.url) {
      var r, s = e == null || (r = e.properties) == null ? void 0 : r.$current_url;
      if (!s || typeof s != "string" || !nt.Ze(s, t == null ? void 0 : t.url, (t == null ? void 0 : t.url_matching) || "contains")) return !1;
    }
    return !0;
  }
  static Ze(e, t, r) {
    switch (r) {
      case "regex":
        return !!f && bt(e, t);
      case "exact":
        return t === e;
      case "contains":
        var s = nt.tr(t).replace(/_/g, ".").replace(/%/g, ".*");
        return bt(e, s);
      default:
        return !1;
    }
  }
  static tr(e) {
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }
  Ve(e, t) {
    if ((t != null && t.href || t != null && t.tag_name || t != null && t.text) && !this.ir(e).some((n) => !(t != null && t.href && !nt.Ze(n.href || "", t == null ? void 0 : t.href, (t == null ? void 0 : t.href_matching) || "exact")) && (t == null || !t.tag_name || n.tag_name === (t == null ? void 0 : t.tag_name)) && !(t != null && t.text && !nt.Ze(n.text || "", t == null ? void 0 : t.text, (t == null ? void 0 : t.text_matching) || "exact") && !nt.Ze(n.$el_text || "", t == null ? void 0 : t.text, (t == null ? void 0 : t.text_matching) || "exact")))) return !1;
    if (t != null && t.selector) {
      var r, s = e == null || (r = e.properties) == null ? void 0 : r.$element_selectors;
      if (!s || !s.includes(t == null ? void 0 : t.selector)) return !1;
    }
    return !0;
  }
  ir(e) {
    return (e == null ? void 0 : e.properties.$elements) == null ? [] : e == null ? void 0 : e.properties.$elements;
  }
}
var Y = te("[Surveys]"), Pi = "seenSurvey_", Iu = (i, e) => {
  var t = "$survey_" + e + "/" + i.id;
  return i.current_iteration && i.current_iteration > 0 && (t = "$survey_" + e + "/" + i.id + "/" + i.current_iteration), t;
}, pn = (i) => {
  var e = "" + Pi + i.id;
  return i.current_iteration && i.current_iteration > 0 && (e = "" + Pi + i.id + "_" + i.current_iteration), e;
}, Pu = [Qr.Popover, Qr.Widget, Qr.API], Cu = { ignoreConditions: !1, ignoreDelay: !1, displayType: Uo.Popover };
class Ou {
  constructor(e) {
    this._instance = e, this.er = /* @__PURE__ */ new Map(), this.rr = /* @__PURE__ */ new Map();
  }
  register(e) {
    var t;
    b((t = this._instance) == null ? void 0 : t.Ye) || (this.sr(e), this.nr(e));
  }
  nr(e) {
    var t = e.filter((r) => {
      var s, n;
      return ((s = r.conditions) == null ? void 0 : s.actions) && ((n = r.conditions) == null || (n = n.actions) == null || (n = n.values) == null ? void 0 : n.length) > 0;
    });
    t.length !== 0 && (this.ar == null && (this.ar = new nt(this._instance), this.ar.init(), this.ar.Qe((r) => {
      this.onAction(r);
    })), t.forEach((r) => {
      var s, n, o, a, l;
      r.conditions && (s = r.conditions) != null && s.actions && (n = r.conditions) != null && (n = n.actions) != null && n.values && ((o = r.conditions) == null || (o = o.actions) == null || (o = o.values) == null ? void 0 : o.length) > 0 && ((a = this.ar) == null || a.register(r.conditions.actions.values), (l = r.conditions) == null || (l = l.actions) == null || (l = l.values) == null || l.forEach((u) => {
        if (u && u.name) {
          var c = this.rr.get(u.name);
          c && c.push(r.id), this.rr.set(u.name, c || [r.id]);
        }
      }));
    }));
  }
  sr(e) {
    var t;
    e.filter((r) => {
      var s, n;
      return ((s = r.conditions) == null ? void 0 : s.events) && ((n = r.conditions) == null || (n = n.events) == null || (n = n.values) == null ? void 0 : n.length) > 0;
    }).length !== 0 && ((t = this._instance) == null || t.Ye((r, s) => {
      this.onEvent(r, s);
    }), e.forEach((r) => {
      var s;
      (s = r.conditions) == null || (s = s.events) == null || (s = s.values) == null || s.forEach((n) => {
        if (n && n.name) {
          var o = this.er.get(n.name);
          o && o.push(r.id), this.er.set(n.name, o || [r.id]);
        }
      });
    }));
  }
  onEvent(e, t) {
    var r, s, n = ((r = this._instance) == null || (r = r.persistence) == null ? void 0 : r.props[Kt]) || [];
    if (lr.SHOWN === e && t && n.length > 0) {
      var o;
      Y.info("survey event matched, removing survey from activated surveys", { event: e, eventPayload: t, existingActivatedSurveys: n });
      var a = t == null || (o = t.properties) == null ? void 0 : o.$survey_id;
      if (a) {
        var l = n.indexOf(a);
        l >= 0 && (n.splice(l, 1), this.lr(n));
      }
    } else if (this.er.has(e)) {
      Y.info("survey event name matched", { event: e, eventPayload: t, surveys: this.er.get(e) });
      var u = [];
      (s = this._instance) == null || s.getSurveys((d) => {
        u = d.filter((h) => {
          var p;
          return (p = this.er.get(e)) == null ? void 0 : p.includes(h.id);
        });
      });
      var c = u.filter((d) => {
        var h, p = (h = d.conditions) == null || (h = h.events) == null || (h = h.values) == null ? void 0 : h.find((g) => g.name === e);
        return !!p && (!p.propertyFilters || Object.entries(p.propertyFilters).every((g) => {
          var v, [_, w] = g, $ = t == null || (v = t.properties) == null ? void 0 : v[_];
          if (b($) || Ye($)) return !1;
          var I = [String($)], T = mo[w.operator];
          return T ? T(w.values, I) : (Y.warn("Unknown property comparison operator: " + w.operator), !1);
        }));
      });
      this.lr(n.concat(c.map((d) => d.id) || []));
    }
  }
  onAction(e) {
    var t, r = ((t = this._instance) == null || (t = t.persistence) == null ? void 0 : t.props[Kt]) || [];
    this.rr.has(e) && this.lr(r.concat(this.rr.get(e) || []));
  }
  lr(e) {
    var t;
    Y.info("updating activated surveys", { activatedSurveys: e }), (t = this._instance) == null || (t = t.persistence) == null || t.register({ [Kt]: [...new Set(e)] });
  }
  getSurveys() {
    var e, t = (e = this._instance) == null || (e = e.persistence) == null ? void 0 : e.props[Kt];
    return t || [];
  }
  getEventToSurveys() {
    return this.er;
  }
  hr() {
    return this.ar;
  }
}
class Au {
  constructor(e) {
    this.ur = void 0, this._surveyManager = null, this.dr = !1, this.vr = !1, this.cr = [], this._instance = e, this._surveyEventReceiver = null;
  }
  onRemoteConfig(e) {
    if (!this._instance.config.disable_surveys) {
      var t = e.surveys;
      if (q(t)) return Y.warn("Flags not loaded yet. Not loading surveys.");
      var r = W(t);
      this.ur = r ? t.length > 0 : t, Y.info("flags response received, isSurveysEnabled: " + this.ur), this.loadIfEnabled();
    }
  }
  reset() {
    localStorage.removeItem("lastSeenSurveyDate");
    for (var e = [], t = 0; t < localStorage.length; t++) {
      var r = localStorage.key(t);
      (r != null && r.startsWith(Pi) || r != null && r.startsWith("inProgressSurvey_")) && e.push(r);
    }
    e.forEach((s) => localStorage.removeItem(s));
  }
  loadIfEnabled() {
    if (!this._surveyManager) if (this.vr) Y.info("Already initializing surveys, skipping...");
    else if (this._instance.config.disable_surveys) Y.info("Disabled. Not loading surveys.");
    else if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) Y.info("Not loading surveys in cookieless mode without consent.");
    else {
      var e = C == null ? void 0 : C.__PosthogExtensions__;
      if (e) {
        if (!b(this.ur) || this._instance.config.advanced_enable_surveys) {
          var t = this.ur || this._instance.config.advanced_enable_surveys;
          this.vr = !0;
          try {
            var r = e.generateSurveys;
            if (r) return void this.pr(r, t);
            var s = e.loadExternalDependency;
            if (!s) return void this.gr("PostHog loadExternalDependency extension not found.");
            s(this._instance, "surveys", (n) => {
              n || !e.generateSurveys ? this.gr("Could not load surveys script", n) : this.pr(e.generateSurveys, t);
            });
          } catch (n) {
            throw this.gr("Error initializing surveys", n), n;
          } finally {
            this.vr = !1;
          }
        }
      } else Y.error("PostHog Extensions not found.");
    }
  }
  pr(e, t) {
    this._surveyManager = e(this._instance, t), this._surveyEventReceiver = new Ou(this._instance), Y.info("Surveys loaded successfully"), this._r({ isLoaded: !0 });
  }
  gr(e, t) {
    Y.error(e, t), this._r({ isLoaded: !1, error: e });
  }
  onSurveysLoaded(e) {
    return this.cr.push(e), this._surveyManager && this._r({ isLoaded: !0 }), () => {
      this.cr = this.cr.filter((t) => t !== e);
    };
  }
  getSurveys(e, t) {
    if (t === void 0 && (t = !1), this._instance.config.disable_surveys) return Y.info("Disabled. Not loading surveys."), e([]);
    var r = this._instance.get_property(pi);
    if (r && !t) return e(r, { isLoaded: !0 });
    if (this.dr) return e([], { isLoaded: !1, error: "Surveys are already being loaded" });
    try {
      this.dr = !0, this._instance.Te({ url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token), method: "GET", timeout: this._instance.config.surveys_request_timeout_ms, callback: (s) => {
        var n;
        this.dr = !1;
        var o = s.statusCode;
        if (o !== 200 || !s.json) {
          var a = "Surveys API could not be loaded, status: " + o;
          return Y.error(a), e([], { isLoaded: !1, error: a });
        }
        var l, u = s.json.surveys || [], c = u.filter((d) => function(h) {
          return !(!h.start_date || h.end_date);
        }(d) && (function(h) {
          var p;
          return !((p = h.conditions) == null || (p = p.events) == null || (p = p.values) == null || !p.length);
        }(d) || function(h) {
          var p;
          return !((p = h.conditions) == null || (p = p.actions) == null || (p = p.values) == null || !p.length);
        }(d)));
        return c.length > 0 && ((l = this._surveyEventReceiver) == null || l.register(c)), (n = this._instance.persistence) == null || n.register({ [pi]: u }), e(u, { isLoaded: !0 });
      } });
    } catch (s) {
      throw this.dr = !1, s;
    }
  }
  _r(e) {
    for (var t of this.cr) try {
      if (!e.isLoaded) return t([], e);
      this.getSurveys(t);
    } catch (r) {
      Y.error("Error in survey callback", r);
    }
  }
  getActiveMatchingSurveys(e, t) {
    if (t === void 0 && (t = !1), !q(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(e, t);
    Y.warn("init was not called");
  }
  mr(e) {
    var t = null;
    return this.getSurveys((r) => {
      var s;
      t = (s = r.find((n) => n.id === e)) !== null && s !== void 0 ? s : null;
    }), t;
  }
  yr(e) {
    if (q(this._surveyManager)) return { eligible: !1, reason: "SDK is not enabled or survey functionality is not yet loaded" };
    var t = typeof e == "string" ? this.mr(e) : e;
    return t ? this._surveyManager.checkSurveyEligibility(t) : { eligible: !1, reason: "Survey not found" };
  }
  canRenderSurvey(e) {
    if (q(this._surveyManager)) return Y.warn("init was not called"), { visible: !1, disabledReason: "SDK is not enabled or survey functionality is not yet loaded" };
    var t = this.yr(e);
    return { visible: t.eligible, disabledReason: t.reason };
  }
  canRenderSurveyAsync(e, t) {
    return q(this._surveyManager) ? (Y.warn("init was not called"), Promise.resolve({ visible: !1, disabledReason: "SDK is not enabled or survey functionality is not yet loaded" })) : new Promise((r) => {
      this.getSurveys((s) => {
        var n, o = (n = s.find((l) => l.id === e)) !== null && n !== void 0 ? n : null;
        if (o) {
          var a = this.yr(o);
          r({ visible: a.eligible, disabledReason: a.reason });
        } else r({ visible: !1, disabledReason: "Survey not found" });
      }, t);
    });
  }
  renderSurvey(e, t) {
    var r;
    if (q(this._surveyManager)) Y.warn("init was not called");
    else {
      var s = typeof e == "string" ? this.mr(e) : e;
      if (s != null && s.id) if (Pu.includes(s.type)) {
        var n = x == null ? void 0 : x.querySelector(t);
        if (n) return (r = s.appearance) != null && r.surveyPopupDelaySeconds ? (Y.info("Rendering survey " + s.id + " with delay of " + s.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(() => {
          var o, a;
          Y.info("Rendering survey " + s.id + " with delay of " + ((o = s.appearance) == null ? void 0 : o.surveyPopupDelaySeconds) + " seconds"), (a = this._surveyManager) == null || a.renderSurvey(s, n), Y.info("Survey " + s.id + " rendered");
        }, 1e3 * s.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(s, n);
        Y.warn("Survey element not found");
      } else Y.warn("Surveys of type " + s.type + " cannot be rendered in the app");
      else Y.warn("Survey not found");
    }
  }
  displaySurvey(e, t) {
    var r;
    if (q(this._surveyManager)) Y.warn("init was not called");
    else {
      var s = this.mr(e);
      if (s) {
        var n = s;
        if ((r = s.appearance) != null && r.surveyPopupDelaySeconds && t.ignoreDelay && (n = E({}, s, { appearance: E({}, s.appearance, { surveyPopupDelaySeconds: 0 }) })), t.ignoreConditions === !1) {
          var o = this.canRenderSurvey(s);
          if (!o.visible) return void Y.warn("Survey is not eligible to be displayed: ", o.disabledReason);
        }
        t.displayType !== Uo.Inline ? this._surveyManager.handlePopoverSurvey(n) : this.renderSurvey(n, t.selector);
      } else Y.warn("Survey not found");
    }
  }
}
var fn = te("[RateLimiter]");
class Fu {
  constructor(e) {
    var t, r;
    this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (s) => {
      var n = s.text;
      if (n && n.length) try {
        (JSON.parse(n).quota_limited || []).forEach((o) => {
          fn.info((o || "events") + " is quota limited."), this.serverLimits[o] = (/* @__PURE__ */ new Date()).getTime() + 6e4;
        });
      } catch (o) {
        return void fn.warn('could not rate limit - continuing. Error: "' + (o == null ? void 0 : o.message) + '"', { text: n });
      }
    }, this.instance = e, this.captureEventsPerSecond = ((t = e.config.rate_limiting) == null ? void 0 : t.events_per_second) || 10, this.captureEventsBurstLimit = Math.max(((r = e.config.rate_limiting) == null ? void 0 : r.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
  }
  clientRateLimitContext(e) {
    var t, r, s;
    e === void 0 && (e = !1);
    var n = (/* @__PURE__ */ new Date()).getTime(), o = (t = (r = this.instance.persistence) == null ? void 0 : r.get_property(vi)) !== null && t !== void 0 ? t : { tokens: this.captureEventsBurstLimit, last: n };
    o.tokens += (n - o.last) / 1e3 * this.captureEventsPerSecond, o.last = n, o.tokens > this.captureEventsBurstLimit && (o.tokens = this.captureEventsBurstLimit);
    var a = o.tokens < 1;
    return a || e || (o.tokens = Math.max(0, o.tokens - 1)), !a || this.lastEventRateLimited || e || this.instance.capture("$$client_ingestion_warning", { $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + this.captureEventsPerSecond + " events per second and " + this.captureEventsBurstLimit + " events burst limit." }, { skip_client_rate_limiting: !0 }), this.lastEventRateLimited = a, (s = this.instance.persistence) == null || s.set_property(vi, o), { isRateLimited: a, remainingTokens: o.tokens };
  }
  isServerRateLimited(e) {
    var t = this.serverLimits[e || "events"] || !1;
    return t !== !1 && (/* @__PURE__ */ new Date()).getTime() < t;
  }
}
var it = te("[RemoteConfig]");
class $u {
  constructor(e) {
    this._instance = e;
  }
  get remoteConfig() {
    var e;
    return (e = C._POSTHOG_REMOTE_CONFIG) == null || (e = e[this._instance.config.token]) == null ? void 0 : e.config;
  }
  br(e) {
    var t, r;
    (t = C.__PosthogExtensions__) != null && t.loadExternalDependency ? (r = C.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, "remote-config", () => e(this.remoteConfig)) : (it.error("PostHog Extensions not found. Cannot load remote config."), e());
  }
  wr(e) {
    this._instance.Te({ method: "GET", url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"), callback: (t) => {
      e(t.json);
    } });
  }
  load() {
    try {
      if (this.remoteConfig) return it.info("Using preloaded remote config", this.remoteConfig), void this.Ce(this.remoteConfig);
      if (this._instance.L()) return void it.warn("Remote config is disabled. Falling back to local config.");
      this.br((e) => {
        if (!e) return it.info("No config found after loading remote JS config. Falling back to JSON."), void this.wr((t) => {
          this.Ce(t);
        });
        this.Ce(e);
      });
    } catch (e) {
      it.error("Error loading remote config", e);
    }
  }
  Ce(e) {
    e ? this._instance.config.__preview_remote_config ? (this._instance.Ce(e), e.hasFeatureFlags !== !1 && this._instance.featureFlags.ensureFlagsLoaded()) : it.info("__preview_remote_config is disabled. Logging config instead", e) : it.error("Failed to fetch remote config from PostHog.");
  }
}
var Ci = 3e3;
class Mu {
  constructor(e, t) {
    this.Sr = !0, this.kr = [], this.$r = Re((t == null ? void 0 : t.flush_interval_ms) || Ci, 250, 5e3, k.createLogger("flush interval"), Ci), this.Er = e;
  }
  enqueue(e) {
    this.kr.push(e), this.Pr || this.Ir();
  }
  unload() {
    this.Rr();
    var e = this.kr.length > 0 ? this.Tr() : {}, t = Object.values(e);
    [...t.filter((r) => r.url.indexOf("/e") === 0), ...t.filter((r) => r.url.indexOf("/e") !== 0)].map((r) => {
      this.Er(E({}, r, { transport: "sendBeacon" }));
    });
  }
  enable() {
    this.Sr = !1, this.Ir();
  }
  Ir() {
    var e = this;
    this.Sr || (this.Pr = setTimeout(() => {
      if (this.Rr(), this.kr.length > 0) {
        var t = this.Tr(), r = function() {
          var n = t[s], o = (/* @__PURE__ */ new Date()).getTime();
          n.data && W(n.data) && z(n.data, (a) => {
            a.offset = Math.abs(a.timestamp - o), delete a.timestamp;
          }), e.Er(n);
        };
        for (var s in t) r();
      }
    }, this.$r));
  }
  Rr() {
    clearTimeout(this.Pr), this.Pr = void 0;
  }
  Tr() {
    var e = {};
    return z(this.kr, (t) => {
      var r, s = t, n = (s ? s.batchKey : null) || s.url;
      b(e[n]) && (e[n] = E({}, s, { data: [] })), (r = e[n].data) == null || r.push(s.data);
    }), this.kr = [], e;
  }
}
var Lu = ["retriesPerformedSoFar"];
class Nu {
  constructor(e) {
    this.Cr = !1, this.Mr = 3e3, this.kr = [], this._instance = e, this.kr = [], this.Or = !0, !b(f) && "onLine" in f.navigator && (this.Or = f.navigator.onLine, J(f, "online", () => {
      this.Or = !0, this.ne();
    }), J(f, "offline", () => {
      this.Or = !1;
    }));
  }
  get length() {
    return this.kr.length;
  }
  retriableRequest(e) {
    var { retriesPerformedSoFar: t } = e, r = Fn(e, Lu);
    pe(t) && t > 0 && (r.url = Sr(r.url, { retry_count: t })), this._instance.Te(E({}, r, { callback: (s) => {
      s.statusCode !== 200 && (s.statusCode < 400 || s.statusCode >= 500) && (t ?? 0) < 10 ? this.Fr(E({ retriesPerformedSoFar: t }, r)) : r.callback == null || r.callback(s);
    } }));
  }
  Fr(e) {
    var t = e.retriesPerformedSoFar || 0;
    e.retriesPerformedSoFar = t + 1;
    var r = function(o) {
      var a = 3e3 * Math.pow(2, o), l = a / 2, u = Math.min(18e5, a), c = (Math.random() - 0.5) * (u - l);
      return Math.ceil(u + c);
    }(t), s = Date.now() + r;
    this.kr.push({ retryAt: s, requestOptions: e });
    var n = "Enqueued failed request for retry in " + r;
    navigator.onLine || (n += " (Browser is offline)"), k.warn(n), this.Cr || (this.Cr = !0, this.Ar());
  }
  Ar() {
    this.Dr && clearTimeout(this.Dr), this.Dr = setTimeout(() => {
      this.Or && this.kr.length > 0 && this.ne(), this.Ar();
    }, this.Mr);
  }
  ne() {
    var e = Date.now(), t = [], r = this.kr.filter((n) => n.retryAt < e || (t.push(n), !1));
    if (this.kr = t, r.length > 0) for (var { requestOptions: s } of r) this.retriableRequest(s);
  }
  unload() {
    for (var { requestOptions: e } of (this.Dr && (clearTimeout(this.Dr), this.Dr = void 0), this.kr)) try {
      this._instance.Te(E({}, e, { transport: "sendBeacon" }));
    } catch (t) {
      k.error(t);
    }
    this.kr = [];
  }
}
class Du {
  constructor(e) {
    this.jr = () => {
      var t, r, s, n;
      this.Lr || (this.Lr = {});
      var o = this.scrollElement(), a = this.scrollY(), l = o ? Math.max(0, o.scrollHeight - o.clientHeight) : 0, u = a + ((o == null ? void 0 : o.clientHeight) || 0), c = (o == null ? void 0 : o.scrollHeight) || 0;
      this.Lr.lastScrollY = Math.ceil(a), this.Lr.maxScrollY = Math.max(a, (t = this.Lr.maxScrollY) !== null && t !== void 0 ? t : 0), this.Lr.maxScrollHeight = Math.max(l, (r = this.Lr.maxScrollHeight) !== null && r !== void 0 ? r : 0), this.Lr.lastContentY = u, this.Lr.maxContentY = Math.max(u, (s = this.Lr.maxContentY) !== null && s !== void 0 ? s : 0), this.Lr.maxContentHeight = Math.max(c, (n = this.Lr.maxContentHeight) !== null && n !== void 0 ? n : 0);
    }, this._instance = e;
  }
  getContext() {
    return this.Lr;
  }
  resetContext() {
    var e = this.Lr;
    return setTimeout(this.jr, 0), e;
  }
  startMeasuringScrollPosition() {
    J(f, "scroll", this.jr, { capture: !0 }), J(f, "scrollend", this.jr, { capture: !0 }), J(f, "resize", this.jr);
  }
  scrollElement() {
    if (!this._instance.config.scroll_root_selector) return f == null ? void 0 : f.document.documentElement;
    var e = W(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [this._instance.config.scroll_root_selector];
    for (var t of e) {
      var r = f == null ? void 0 : f.document.querySelector(t);
      if (r) return r;
    }
  }
  scrollY() {
    if (this._instance.config.scroll_root_selector) {
      var e = this.scrollElement();
      return e && e.scrollTop || 0;
    }
    return f && (f.scrollY || f.pageYOffset || f.document.documentElement.scrollTop) || 0;
  }
  scrollX() {
    if (this._instance.config.scroll_root_selector) {
      var e = this.scrollElement();
      return e && e.scrollLeft || 0;
    }
    return f && (f.scrollX || f.pageXOffset || f.document.documentElement.scrollLeft) || 0;
  }
}
var ju = (i) => jo(i == null ? void 0 : i.config.mask_personal_data_properties, i == null ? void 0 : i.config.custom_personal_data_properties);
class vn {
  constructor(e, t, r, s) {
    this.Nr = (n) => {
      var o = this.Ur();
      if (!o || o.sessionId !== n) {
        var a = { sessionId: n, props: this.zr(this._instance) };
        this.qr.register({ [fi]: a });
      }
    }, this._instance = e, this.Br = t, this.qr = r, this.zr = s || ju, this.Br.onSessionId(this.Nr);
  }
  Ur() {
    return this.qr.props[fi];
  }
  getSetOnceProps() {
    var e, t = (e = this.Ur()) == null ? void 0 : e.props;
    return t ? "r" in t ? Ho(t) : { $referring_domain: t.referringDomain, $pathname: t.initialPathName, utm_source: t.utm_source, utm_campaign: t.utm_campaign, utm_medium: t.utm_medium, utm_content: t.utm_content, utm_term: t.utm_term } : {};
  }
  getSessionProps() {
    var e = {};
    return z(Di(this.getSetOnceProps()), (t, r) => {
      r === "$current_url" && (r = "url"), e["$session_entry_" + si(r)] = t;
    }), e;
  }
}
var ei = te("[SessionId]");
class gn {
  constructor(e, t, r) {
    var s;
    if (this.Hr = [], this.Wr = (c, d) => Math.abs(c - d) > this.sessionTimeoutMs, !e.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
    if (e.config.cookieless_mode === "always") throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
    this.A = e.config, this.qr = e.persistence, this.pi = void 0, this.Ft = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Gr = t || Xe, this.Vr = r || Xe;
    var n = this.A.persistence_name || this.A.token, o = this.A.session_idle_timeout_seconds || 1800;
    if (this._sessionTimeoutMs = 1e3 * Re(o, 60, 36e3, ei.createLogger("session_idle_timeout_seconds"), 1800), e.register({ $configured_session_timeout_ms: this._sessionTimeoutMs }), this.Jr(), this.Kr = "ph_" + n + "_window_id", this.Yr = "ph_" + n + "_primary_window_exists", this.Xr()) {
      var a = ae.K(this.Kr), l = ae.K(this.Yr);
      a && !l ? this.pi = a : ae.X(this.Kr), ae.Y(this.Yr, !0);
    }
    if ((s = this.A.bootstrap) != null && s.sessionID) try {
      var u = ((c) => {
        var d = c.replace(/-/g, "");
        if (d.length !== 32) throw new Error("Not a valid UUID");
        if (d[12] !== "7") throw new Error("Not a UUIDv7");
        return parseInt(d.substring(0, 12), 16);
      })(this.A.bootstrap.sessionID);
      this.Qr(this.A.bootstrap.sessionID, (/* @__PURE__ */ new Date()).getTime(), u);
    } catch (c) {
      ei.error("Invalid sessionID in bootstrap", c);
    }
    this.Zr();
  }
  get sessionTimeoutMs() {
    return this._sessionTimeoutMs;
  }
  onSessionId(e) {
    return b(this.Hr) && (this.Hr = []), this.Hr.push(e), this.Ft && e(this.Ft, this.pi), () => {
      this.Hr = this.Hr.filter((t) => t !== e);
    };
  }
  Xr() {
    return this.A.persistence !== "memory" && !this.qr.je && ae.G();
  }
  ts(e) {
    e !== this.pi && (this.pi = e, this.Xr() && ae.Y(this.Kr, e));
  }
  es() {
    return this.pi ? this.pi : this.Xr() ? ae.K(this.Kr) : null;
  }
  Qr(e, t, r) {
    e === this.Ft && t === this._sessionActivityTimestamp && r === this._sessionStartTimestamp || (this._sessionStartTimestamp = r, this._sessionActivityTimestamp = t, this.Ft = e, this.qr.register({ [hr]: [t, e, r] }));
  }
  rs() {
    if (this.Ft && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [this._sessionActivityTimestamp, this.Ft, this._sessionStartTimestamp];
    var e = this.qr.props[hr];
    return W(e) && e.length === 2 && e.push(e[0]), e || [0, null, 0];
  }
  resetSessionId() {
    this.Qr(null, null, null);
  }
  Zr() {
    J(f, "beforeunload", () => {
      this.Xr() && ae.X(this.Yr);
    }, { capture: !1 });
  }
  checkAndGetSessionAndWindowId(e, t) {
    if (e === void 0 && (e = !1), t === void 0 && (t = null), this.A.cookieless_mode === "always") throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
    var r = t || (/* @__PURE__ */ new Date()).getTime(), [s, n, o] = this.rs(), a = this.es(), l = pe(o) && o > 0 && Math.abs(r - o) > 864e5, u = !1, c = !n, d = !e && this.Wr(r, s);
    c || d || l ? (n = this.Gr(), a = this.Vr(), ei.info("new session ID generated", { sessionId: n, windowId: a, changeReason: { noSessionId: c, activityTimeout: d, sessionPastMaximumLength: l } }), o = r, u = !0) : a || (a = this.Vr(), u = !0);
    var h = s === 0 || !e || l ? r : s, p = o === 0 ? (/* @__PURE__ */ new Date()).getTime() : o;
    return this.ts(a), this.Qr(n, h, p), e || this.Jr(), u && this.Hr.forEach((g) => g(n, a, u ? { noSessionId: c, activityTimeout: d, sessionPastMaximumLength: l } : void 0)), { sessionId: n, windowId: a, sessionStartTimestamp: p, changeReason: u ? { noSessionId: c, activityTimeout: d, sessionPastMaximumLength: l } : void 0, lastActivityTimestamp: s };
  }
  Jr() {
    clearTimeout(this.ss), this.ss = setTimeout(() => {
      var [e] = this.rs();
      this.Wr((/* @__PURE__ */ new Date()).getTime(), e) && this.resetSessionId();
    }, 1.1 * this.sessionTimeoutMs);
  }
}
var Hu = ["$set_once", "$set"], We = te("[SiteApps]");
class qu {
  constructor(e) {
    this._instance = e, this.ns = [], this.apps = {};
  }
  get isEnabled() {
    return !!this._instance.config.opt_in_site_apps;
  }
  os(e, t) {
    if (t) {
      var r = this.globalsForEvent(t);
      this.ns.push(r), this.ns.length > 1e3 && (this.ns = this.ns.slice(10));
    }
  }
  get siteAppLoaders() {
    var e;
    return (e = C._POSTHOG_REMOTE_CONFIG) == null || (e = e[this._instance.config.token]) == null ? void 0 : e.siteApps;
  }
  init() {
    if (this.isEnabled) {
      var e = this._instance.Ye(this.os.bind(this));
      this.ls = () => {
        e(), this.ns = [], this.ls = void 0;
      };
    }
  }
  globalsForEvent(e) {
    var t, r, s, n, o, a, l;
    if (!e) throw new Error("Event payload is required");
    var u = {}, c = this._instance.get_property("$groups") || [], d = this._instance.get_property("$stored_group_properties") || {};
    for (var [h, p] of Object.entries(d)) u[h] = { id: c[h], type: h, properties: p };
    var { $set_once: g, $set: v } = e;
    return { event: E({}, Fn(e, Hu), { properties: E({}, e.properties, v ? { $set: E({}, (t = (r = e.properties) == null ? void 0 : r.$set) !== null && t !== void 0 ? t : {}, v) } : {}, g ? { $set_once: E({}, (s = (n = e.properties) == null ? void 0 : n.$set_once) !== null && s !== void 0 ? s : {}, g) } : {}), elements_chain: (o = (a = e.properties) == null ? void 0 : a.$elements_chain) !== null && o !== void 0 ? o : "", distinct_id: (l = e.properties) == null ? void 0 : l.distinct_id }), person: { properties: this._instance.get_property("$stored_person_properties") }, groups: u };
  }
  setupSiteApp(e) {
    var t = this.apps[e.id], r = () => {
      var a;
      !t.errored && this.ns.length && (We.info("Processing " + this.ns.length + " events for site app with id " + e.id), this.ns.forEach((l) => t.processEvent == null ? void 0 : t.processEvent(l)), t.processedBuffer = !0), Object.values(this.apps).every((l) => l.processedBuffer || l.errored) && ((a = this.ls) == null || a.call(this));
    }, s = !1, n = (a) => {
      t.errored = !a, t.loaded = !0, We.info("Site app with id " + e.id + " " + (a ? "loaded" : "errored")), s && r();
    };
    try {
      var { processEvent: o } = e.init({ posthog: this._instance, callback: (a) => {
        n(a);
      } });
      o && (t.processEvent = o), s = !0;
    } catch (a) {
      We.error("Error while initializing PostHog app with config id " + e.id, a), n(!1);
    }
    if (s && t.loaded) try {
      r();
    } catch (a) {
      We.error("Error while processing buffered events PostHog app with config id " + e.id, a), t.errored = !0;
    }
  }
  hs() {
    var e = this.siteAppLoaders || [];
    for (var t of e) this.apps[t.id] = { id: t.id, loaded: !1, errored: !1, processedBuffer: !1 };
    for (var r of e) this.setupSiteApp(r);
  }
  us(e) {
    if (Object.keys(this.apps).length !== 0) {
      var t = this.globalsForEvent(e);
      for (var r of Object.values(this.apps)) try {
        r.processEvent == null || r.processEvent(t);
      } catch (s) {
        We.error("Error while processing event " + e.event + " for site app " + r.id, s);
      }
    }
  }
  onRemoteConfig(e) {
    var t, r, s, n = this;
    if ((t = this.siteAppLoaders) != null && t.length) return this.isEnabled ? (this.hs(), void this._instance.on("eventCaptured", (u) => this.us(u))) : void We.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
    if ((r = this.ls) == null || r.call(this), (s = e.siteApps) != null && s.length) if (this.isEnabled) {
      var o = function(u) {
        var c;
        C["__$$ph_site_app_" + u] = n._instance, (c = C.__PosthogExtensions__) == null || c.loadSiteApp == null || c.loadSiteApp(n._instance, l, (d) => {
          if (d) return We.error("Error while initializing PostHog app with config id " + u, d);
        });
      };
      for (var { id: a, url: l } of e.siteApps) o(a);
    } else We.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
  }
}
var Uu = ["amazonbot", "amazonproductbot", "app.hypefactors.com", "applebot", "archive.org_bot", "awariobot", "backlinksextendedbot", "baiduspider", "bingbot", "bingpreview", "chrome-lighthouse", "dataforseobot", "deepscan", "duckduckbot", "facebookexternal", "facebookcatalog", "http://yandex.com/bots", "hubspot", "ia_archiver", "leikibot", "linkedinbot", "meta-externalagent", "mj12bot", "msnbot", "nessus", "petalbot", "pinterest", "prerender", "rogerbot", "screaming frog", "sebot-wa", "sitebulb", "slackbot", "slurp", "trendictionbot", "turnitin", "twitterbot", "vercel-screenshot", "vercelbot", "yahoo! slurp", "yandexbot", "zoombot", "bot.htm", "bot.php", "(bot;", "bot/", "crawler", "ahrefsbot", "ahrefssiteaudit", "semrushbot", "siteauditbot", "splitsignalbot", "gptbot", "oai-searchbot", "chatgpt-user", "perplexitybot", "better uptime bot", "sentryuptimebot", "uptimerobot", "headlesschrome", "cypress", "google-hoteladsverifier", "adsbot-google", "apis-google", "duplexweb-google", "feedfetcher-google", "google favicon", "google web preview", "google-read-aloud", "googlebot", "googleother", "google-cloudvertexbot", "googleweblight", "mediapartners-google", "storebot-google", "google-inspectiontool", "bytespider"], _n = function(i, e) {
  if (!i) return !1;
  var t = i.toLowerCase();
  return Uu.concat(e || []).some((r) => {
    var s = r.toLowerCase();
    return t.indexOf(s) !== -1;
  });
}, Go = function(i, e) {
  if (!i) return !1;
  var t = i.userAgent;
  if (t && _n(t, e)) return !0;
  try {
    var r = i == null ? void 0 : i.userAgentData;
    if (r != null && r.brands && r.brands.some((s) => _n(s == null ? void 0 : s.brand, e))) return !0;
  } catch {
  }
  return !!i.webdriver;
}, Dt = function(i) {
  return i.US = "us", i.EU = "eu", i.CUSTOM = "custom", i;
}({}), mn = "i.posthog.com";
class Bu {
  constructor(e) {
    this.ds = {}, this.instance = e;
  }
  get apiHost() {
    var e = this.instance.config.api_host.trim().replace(/\/$/, "");
    return e === "https://app.posthog.com" ? "https://us.i.posthog.com" : e;
  }
  get uiHost() {
    var e, t = (e = this.instance.config.ui_host) == null ? void 0 : e.replace(/\/$/, "");
    return t || (t = this.apiHost.replace("." + mn, ".posthog.com")), t === "https://app.posthog.com" ? "https://us.posthog.com" : t;
  }
  get region() {
    return this.ds[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.ds[this.apiHost] = Dt.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.ds[this.apiHost] = Dt.EU : this.ds[this.apiHost] = Dt.CUSTOM), this.ds[this.apiHost];
  }
  endpointFor(e, t) {
    if (t === void 0 && (t = ""), t && (t = t[0] === "/" ? t : "/" + t), e === "ui") return this.uiHost + t;
    if (this.region === Dt.CUSTOM) return this.apiHost + t;
    var r = mn + t;
    switch (e) {
      case "assets":
        return "https://" + this.region + "-assets." + r;
      case "api":
        return "https://" + this.region + "." + r;
    }
  }
}
var Gu = { icontains: (i, e) => !!f && e.href.toLowerCase().indexOf(i.toLowerCase()) > -1, not_icontains: (i, e) => !!f && e.href.toLowerCase().indexOf(i.toLowerCase()) === -1, regex: (i, e) => !!f && bt(e.href, i), not_regex: (i, e) => !!f && !bt(e.href, i), exact: (i, e) => e.href === i, is_not: (i, e) => e.href !== i };
class he {
  constructor(e) {
    var t = this;
    this.getWebExperimentsAndEvaluateDisplayLogic = function(r) {
      r === void 0 && (r = !1), t.getWebExperiments((s) => {
        he.vs("retrieved web experiments from the server"), t.cs = /* @__PURE__ */ new Map(), s.forEach((n) => {
          if (n.feature_flag_key) {
            var o;
            t.cs && (he.vs("setting flag key ", n.feature_flag_key, " to web experiment ", n), (o = t.cs) == null || o.set(n.feature_flag_key, n));
            var a = t._instance.getFeatureFlag(n.feature_flag_key);
            Z(a) && n.variants[a] && t.fs(n.name, a, n.variants[a].transforms);
          } else if (n.variants) for (var l in n.variants) {
            var u = n.variants[l];
            he.ps(u) && t.fs(n.name, l, u.transforms);
          }
        });
      }, r);
    }, this._instance = e, this._instance.onFeatureFlags((r) => {
      this.onFeatureFlags(r);
    });
  }
  onFeatureFlags(e) {
    if (this._is_bot()) he.vs("Refusing to render web experiment since the viewer is a likely bot");
    else if (!this._instance.config.disable_web_experiments) {
      if (q(this.cs)) return this.cs = /* @__PURE__ */ new Map(), this.loadIfEnabled(), void this.previewWebExperiment();
      he.vs("applying feature flags", e), e.forEach((t) => {
        var r;
        if (this.cs && (r = this.cs) != null && r.has(t)) {
          var s, n = this._instance.getFeatureFlag(t), o = (s = this.cs) == null ? void 0 : s.get(t);
          n && o != null && o.variants[n] && this.fs(o.name, n, o.variants[n].transforms);
        }
      });
    }
  }
  previewWebExperiment() {
    var e = he.getWindowLocation();
    if (e != null && e.search) {
      var t = _r(e == null ? void 0 : e.search, "__experiment_id"), r = _r(e == null ? void 0 : e.search, "__experiment_variant");
      t && r && (he.vs("previewing web experiments " + t + " && " + r), this.getWebExperiments((s) => {
        this.gs(parseInt(t), r, s);
      }, !1, !0));
    }
  }
  loadIfEnabled() {
    this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
  }
  getWebExperiments(e, t, r) {
    if (this._instance.config.disable_web_experiments && !r) return e([]);
    var s = this._instance.get_property("$web_experiments");
    if (s && !t) return e(s);
    this._instance.Te({ url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token), method: "GET", callback: (n) => {
      if (n.statusCode !== 200 || !n.json) return e([]);
      var o = n.json.experiments || [];
      return e(o);
    } });
  }
  gs(e, t, r) {
    var s = r.filter((n) => n.id === e);
    s && s.length > 0 && (he.vs("Previewing web experiment [" + s[0].name + "] with variant [" + t + "]"), this.fs(s[0].name, t, s[0].variants[t].transforms));
  }
  static ps(e) {
    return !q(e.conditions) && he._s(e) && he.ys(e);
  }
  static _s(e) {
    var t;
    if (q(e.conditions) || q((t = e.conditions) == null ? void 0 : t.url)) return !0;
    var r, s, n, o = he.getWindowLocation();
    return !!o && ((r = e.conditions) == null || !r.url || Gu[(s = (n = e.conditions) == null ? void 0 : n.urlMatchType) !== null && s !== void 0 ? s : "icontains"](e.conditions.url, o));
  }
  static getWindowLocation() {
    return f == null ? void 0 : f.location;
  }
  static ys(e) {
    var t;
    if (q(e.conditions) || q((t = e.conditions) == null ? void 0 : t.utm)) return !0;
    var r = Mo();
    if (r.utm_source) {
      var s, n, o, a, l, u, c, d, h = (s = e.conditions) == null || (s = s.utm) == null || !s.utm_campaign || ((n = e.conditions) == null || (n = n.utm) == null ? void 0 : n.utm_campaign) == r.utm_campaign, p = (o = e.conditions) == null || (o = o.utm) == null || !o.utm_source || ((a = e.conditions) == null || (a = a.utm) == null ? void 0 : a.utm_source) == r.utm_source, g = (l = e.conditions) == null || (l = l.utm) == null || !l.utm_medium || ((u = e.conditions) == null || (u = u.utm) == null ? void 0 : u.utm_medium) == r.utm_medium, v = (c = e.conditions) == null || (c = c.utm) == null || !c.utm_term || ((d = e.conditions) == null || (d = d.utm) == null ? void 0 : d.utm_term) == r.utm_term;
      return h && g && v && p;
    }
    return !1;
  }
  static vs(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) r[s - 1] = arguments[s];
    k.info("[WebExperiments] " + e, r);
  }
  fs(e, t, r) {
    this._is_bot() ? he.vs("Refusing to render web experiment since the viewer is a likely bot") : t !== "control" ? r.forEach((s) => {
      if (s.selector) {
        var n;
        he.vs("applying transform of variant " + t + " for experiment " + e + " ", s);
        var o = (n = document) == null ? void 0 : n.querySelectorAll(s.selector);
        o == null || o.forEach((a) => {
          var l = a;
          s.html && (l.innerHTML = s.html), s.css && l.setAttribute("style", s.css);
        });
      }
    }) : he.vs("Control variants leave the page unmodified.");
  }
  _is_bot() {
    return xe && this._instance ? Go(xe, this._instance.config.custom_blocked_useragents) : void 0;
  }
}
var Yu = te("[PostHog ExternalIntegrations]"), zu = { intercom: "intercom-integration", crispChat: "crisp-chat-integration" };
class Wu {
  constructor(e) {
    this._instance = e;
  }
  nt(e, t) {
    var r;
    (r = C.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, e, (s) => {
      if (s) return Yu.error("failed to load script", s);
      t();
    });
  }
  startIfEnabledOrStop() {
    var e = this, t = function(o) {
      var a, l, u;
      !s || (a = C.__PosthogExtensions__) != null && (a = a.integrations) != null && a[o] || e.nt(zu[o], () => {
        var c;
        (c = C.__PosthogExtensions__) == null || (c = c.integrations) == null || (c = c[o]) == null || c.start(e._instance);
      }), !s && (l = C.__PosthogExtensions__) != null && (l = l.integrations) != null && l[o] && ((u = C.__PosthogExtensions__) == null || (u = u.integrations) == null || (u = u[o]) == null || u.stop());
    };
    for (var [r, s] of Object.entries((n = this._instance.config.integrations) !== null && n !== void 0 ? n : {})) {
      var n;
      t(r);
    }
  }
}
var Oi = "[SessionRecording]", nr = te(Oi);
class Vu {
  get started() {
    var e;
    return !((e = this.bs) == null || !e.isStarted);
  }
  get status() {
    var e;
    return ((e = this.bs) == null ? void 0 : e.status) || "lazy_loading";
  }
  constructor(e) {
    if (this._forceAllowLocalhostNetworkCapture = !1, this._instance = e, !this._instance.sessionManager) throw nr.error("started without valid sessionManager"), new Error(Oi + " started without valid sessionManager. This is a bug.");
    if (this._instance.config.cookieless_mode === "always") throw new Error(Oi + ' cannot be used with cookieless_mode="always"');
  }
  get qt() {
    var e = !!this._instance.get_property(qt), t = !this._instance.config.disable_session_recording, r = this._instance.config.disable_session_recording || this._instance.consent.isOptedOut();
    return f && e && t && !r;
  }
  startIfEnabledOrStop(e) {
    var t;
    if (!this.qt || (t = this.bs) == null || !t.isStarted) {
      var r = !b(Object.assign) && !b(Array.from);
      this.qt && r ? (this.ws(e), nr.info("starting")) : this.stopRecording();
    }
  }
  ws(e) {
    var t, r, s;
    this.qt && (C != null && (t = C.__PosthogExtensions__) != null && (t = t.rrweb) != null && t.record && (r = C.__PosthogExtensions__) != null && r.initSessionRecording ? this.Pi(e) : (s = C.__PosthogExtensions__) == null || s.loadExternalDependency == null || s.loadExternalDependency(this._instance, this.Ii, (n) => {
      if (n) return nr.error("could not load recorder", n);
      this.Pi(e);
    }));
  }
  stopRecording() {
    var e;
    (e = this.bs) == null || e.stop();
  }
  onRemoteConfig(e) {
    this.Ss = e;
    var t, r = this._instance.persistence;
    r && r.register({ [qt]: !!e.sessionRecording, [dr]: (t = e.sessionRecording) == null ? void 0 : t.scriptConfig }), this.bs ? (this.bs.onRemoteConfig(e), this.Ss = void 0) : this.ws(), this.startIfEnabledOrStop();
  }
  log(e, t) {
    var r;
    t === void 0 && (t = "log"), (r = this.bs) != null && r.log ? this.bs.log(e, t) : nr.warn("log called before recorder was ready");
  }
  get Ii() {
    var e;
    return ((e = this._instance) == null || (e = e.persistence) == null || (e = e.get_property(dr)) == null ? void 0 : e.script) || "lazy-recorder";
  }
  Pi(e) {
    var t, r;
    if ((t = C.__PosthogExtensions__) == null || !t.initSessionRecording) throw Error("Called on script loaded before session recording is available");
    this.bs || (this.bs = (r = C.__PosthogExtensions__) == null ? void 0 : r.initSessionRecording(this._instance), this.bs._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture, this.Ss && (this.bs.onRemoteConfig(this.Ss), this.Ss = void 0)), this.bs.start(e);
  }
  onRRwebEmit(e) {
    var t;
    (t = this.bs) == null || t.onRRwebEmit == null || t.onRRwebEmit(e);
  }
  overrideLinkedFlag() {
    var e;
    (e = this.bs) == null || e.overrideLinkedFlag();
  }
  overrideSampling() {
    var e;
    (e = this.bs) == null || e.overrideSampling();
  }
  overrideTrigger(e) {
    var t;
    (t = this.bs) == null || t.overrideTrigger(e);
  }
  get sdkDebugProperties() {
    var e;
    return ((e = this.bs) == null ? void 0 : e.sdkDebugProperties) || { $recording_status: this.status };
  }
  tryAddCustomEvent(e, t) {
    var r;
    return !((r = this.bs) == null || !r.tryAddCustomEvent(e, t));
  }
}
var Ht = {}, Ai = () => {
}, ct = "posthog", Yo = !lu && (be == null ? void 0 : be.indexOf("MSIE")) === -1 && (be == null ? void 0 : be.indexOf("Mozilla")) === -1, yn = (i) => {
  var e;
  return { api_host: "https://us.i.posthog.com", ui_host: null, token: "", autocapture: !0, rageclick: !0, cross_subdomain_cookie: el(x == null ? void 0 : x.location), persistence: "localStorage+cookie", persistence_name: "", loaded: Ai, save_campaign_params: !0, custom_campaign_params: [], custom_blocked_useragents: [], save_referrer: !0, capture_pageview: i !== "2025-05-24" || "history_change", capture_pageleave: "if_capture_pageview", defaults: i ?? "unset", debug: we && Z(we == null ? void 0 : we.search) && we.search.indexOf("__posthog_debug=true") !== -1 || !1, cookie_expiration: 365, upgrade: !1, disable_session_recording: !1, disable_persistence: !1, disable_web_experiments: !0, disable_surveys: !1, disable_surveys_automatic_display: !1, disable_external_dependency_loading: !1, enable_recording_console_log: void 0, secure_cookie: (f == null || (e = f.location) == null ? void 0 : e.protocol) === "https:", ip: !1, opt_out_capturing_by_default: !1, opt_out_persistence_by_default: !1, opt_out_useragent_filter: !1, opt_out_capturing_persistence_type: "localStorage", consent_persistence_name: null, opt_out_capturing_cookie_prefix: null, opt_in_site_apps: !1, property_denylist: [], respect_dnt: !1, sanitize_properties: null, request_headers: {}, request_batching: !0, properties_string_max_length: 65535, session_recording: {}, mask_all_element_attributes: !1, mask_all_text: !1, mask_personal_data_properties: !1, custom_personal_data_properties: [], advanced_disable_flags: !1, advanced_disable_decide: !1, advanced_disable_feature_flags: !1, advanced_disable_feature_flags_on_first_load: !1, advanced_only_evaluate_survey_feature_flags: !1, advanced_enable_surveys: !1, advanced_disable_toolbar_metrics: !1, feature_flag_request_timeout_ms: 3e3, surveys_request_timeout_ms: 1e4, on_request_error: (t) => {
    var r = "Bad HTTP status: " + t.statusCode + " " + t.text;
    k.error(r);
  }, get_device_id: (t) => t, capture_performance: void 0, name: "posthog", bootstrap: {}, disable_compression: !1, session_idle_timeout_seconds: 1800, person_profiles: "identified_only", before_send: void 0, request_queue_config: { flush_interval_ms: Ci }, error_tracking: {}, _onCapture: Ai, __preview_eager_load_replay: !0 };
}, bn = (i) => {
  var e = {};
  b(i.process_person) || (e.person_profiles = i.process_person), b(i.xhr_headers) || (e.request_headers = i.xhr_headers), b(i.cookie_name) || (e.persistence_name = i.cookie_name), b(i.disable_cookie) || (e.disable_persistence = i.disable_cookie), b(i.store_google) || (e.save_campaign_params = i.store_google), b(i.verbose) || (e.debug = i.verbose);
  var t = Q({}, e, i);
  return W(i.property_blacklist) && (b(i.property_denylist) ? t.property_denylist = i.property_blacklist : W(i.property_denylist) ? t.property_denylist = [...i.property_blacklist, ...i.property_denylist] : k.error("Invalid value for property_denylist config: " + i.property_denylist)), t;
};
class Xu {
  constructor() {
    this.__forceAllowLocalhost = !1;
  }
  get ks() {
    return this.__forceAllowLocalhost;
  }
  set ks(e) {
    k.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = e;
  }
}
class Ar {
  get decideEndpointWasHit() {
    var e, t;
    return (e = (t = this.featureFlags) == null ? void 0 : t.hasLoadedFlags) !== null && e !== void 0 && e;
  }
  get flagsEndpointWasHit() {
    var e, t;
    return (e = (t = this.featureFlags) == null ? void 0 : t.hasLoadedFlags) !== null && e !== void 0 && e;
  }
  constructor() {
    this.webPerformance = new Xu(), this.$s = !1, this.version = Ue.LIB_VERSION, this.xs = new Bo(), this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = yn(), this.SentryIntegration = Zl, this.sentryIntegration = (e) => function(t, r) {
      var s = _o(t, r);
      return { name: go, processEvent: (n) => s(n) };
    }(this, e), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.Es = !1, this.Ps = null, this.Is = null, this.Rs = null, this.featureFlags = new Ru(this), this.toolbar = new eu(this), this.scrollManager = new Du(this), this.pageViewManager = new ou(this), this.surveys = new Au(this), this.experiments = new he(this), this.exceptions = new uu(this), this.rateLimiter = new Fu(this), this.requestRouter = new Bu(this), this.consent = new El(this), this.externalIntegrations = new Wu(this), this.people = { set: (e, t, r) => {
      var s = Z(e) ? { [e]: t } : e;
      this.setPersonProperties(s), r == null || r({});
    }, set_once: (e, t, r) => {
      var s = Z(e) ? { [e]: t } : e;
      this.setPersonProperties(void 0, s), r == null || r({});
    } }, this.on("eventCaptured", (e) => k.info('send "' + (e == null ? void 0 : e.event) + '"', e));
  }
  init(e, t, r) {
    if (r && r !== ct) {
      var s, n = (s = Ht[r]) !== null && s !== void 0 ? s : new Ar();
      return n._init(e, t, r), Ht[r] = n, Ht[ct][r] = n, n;
    }
    return this._init(e, t, r);
  }
  _init(e, t, r) {
    var s, n;
    if (t === void 0 && (t = {}), b(e) || ni(e)) return k.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
    if (this.__loaded) return k.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
    this.__loaded = !0, this.config = {}, this.Ts = t, this.Cs = [], t.person_profiles && (this.Is = t.person_profiles), this.set_config(Q({}, yn(t.defaults), bn(t), { name: r, token: e })), this.config.on_xhr_error && k.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = t.disable_compression ? void 0 : Be.GZipJS;
    var o = this.Ms();
    this.persistence = new Zr(this.config, o), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new Zr(E({}, this.config, { persistence: "sessionStorage" }), o);
    var a = E({}, this.persistence.props), l = E({}, this.sessionPersistence.props);
    this.register({ $initialization_time: (/* @__PURE__ */ new Date()).toISOString() }), this.Os = new Mu((I) => this.Fs(I), this.config.request_queue_config), this.As = new Nu(this), this.__request_queue = [];
    var u = this.config.cookieless_mode === "always" || this.config.cookieless_mode === "on_reject" && this.consent.isExplicitlyOptedOut();
    if (u || (this.sessionManager = new gn(this), this.sessionPropsManager = new vn(this, this.sessionManager, this.persistence)), new ru(this).startIfEnabledOrStop(), this.siteApps = new qu(this), (s = this.siteApps) == null || s.init(), u || (this.config.__preview_eager_load_replay ? this.sessionRecording = new Js(this) : this.sessionRecording = new Vu(this), this.sessionRecording.startIfEnabledOrStop()), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new fl(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new nu(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new iu(this), this.exceptionObserver = new xl(this), this.exceptionObserver.startIfEnabled(), this.deadClicksAutocapture = new no(this, kl), this.deadClicksAutocapture.startIfEnabled(), this.historyAutocapture = new Rl(this), this.historyAutocapture.startIfEnabled(), Ue.DEBUG = Ue.DEBUG || this.config.debug, Ue.DEBUG && k.info("Starting in debug mode", { this: this, config: t, thisC: E({}, this.config), p: a, s: l }), ((n = t.bootstrap) == null ? void 0 : n.distinctID) !== void 0) {
      var c, d, h = this.config.get_device_id(Xe()), p = (c = t.bootstrap) != null && c.isIdentifiedID ? h : t.bootstrap.distinctID;
      this.persistence.set_property(je, (d = t.bootstrap) != null && d.isIdentifiedID ? "identified" : "anonymous"), this.register({ distinct_id: t.bootstrap.distinctID, $device_id: p });
    }
    if (this.Ds()) {
      var g, v, _ = Object.keys(((g = t.bootstrap) == null ? void 0 : g.featureFlags) || {}).filter((I) => {
        var T;
        return !((T = t.bootstrap) == null || (T = T.featureFlags) == null || !T[I]);
      }).reduce((I, T) => {
        var y;
        return I[T] = ((y = t.bootstrap) == null || (y = y.featureFlags) == null ? void 0 : y[T]) || !1, I;
      }, {}), w = Object.keys(((v = t.bootstrap) == null ? void 0 : v.featureFlagPayloads) || {}).filter((I) => _[I]).reduce((I, T) => {
        var y, X;
        return (y = t.bootstrap) != null && (y = y.featureFlagPayloads) != null && y[T] && (I[T] = (X = t.bootstrap) == null || (X = X.featureFlagPayloads) == null ? void 0 : X[T]), I;
      }, {});
      this.featureFlags.receivedFeatureFlags({ featureFlags: _, featureFlagPayloads: w });
    }
    if (u) this.register_once({ distinct_id: kt, $device_id: null }, "");
    else if (!this.get_distinct_id()) {
      var $ = this.config.get_device_id(Xe());
      this.register_once({ distinct_id: $, $device_id: $ }, ""), this.persistence.set_property(je, "anonymous");
    }
    return J(f, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), { passive: !1 }), this.toolbar.maybeLoadToolbar(), t.segment ? Kl(this, () => this.js()) : this.js(), Ie(this.config._onCapture) && this.config._onCapture !== Ai && (k.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (I) => this.config._onCapture(I.event, I))), this.config.ip && k.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
  }
  Ce(e) {
    var t, r, s, n, o, a, l, u;
    if (!x || !x.body) return k.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(() => {
      this.Ce(e);
    }, 500);
    this.compression = void 0, e.supportedCompression && !this.config.disable_compression && (this.compression = D(e.supportedCompression, Be.GZipJS) ? Be.GZipJS : D(e.supportedCompression, Be.Base64) ? Be.Base64 : void 0), (t = e.analytics) != null && t.endpoint && (this.analyticsDefaultEndpoint = e.analytics.endpoint), this.set_config({ person_profiles: this.Is ? this.Is : "identified_only" }), (r = this.siteApps) == null || r.onRemoteConfig(e), (s = this.sessionRecording) == null || s.onRemoteConfig(e), (n = this.autocapture) == null || n.onRemoteConfig(e), (o = this.heatmaps) == null || o.onRemoteConfig(e), this.surveys.onRemoteConfig(e), (a = this.webVitalsAutocapture) == null || a.onRemoteConfig(e), (l = this.exceptionObserver) == null || l.onRemoteConfig(e), this.exceptions.onRemoteConfig(e), (u = this.deadClicksAutocapture) == null || u.onRemoteConfig(e);
  }
  js() {
    try {
      this.config.loaded(this);
    } catch (e) {
      k.critical("`loaded` function failed", e);
    }
    this.Ls(), this.config.capture_pageview && setTimeout(() => {
      (this.consent.isOptedIn() || this.config.cookieless_mode === "always") && this.Ns();
    }, 1), new $u(this).load(), this.featureFlags.flags();
  }
  Ls() {
    var e;
    this.is_capturing() && this.config.request_batching && ((e = this.Os) == null || e.enable());
  }
  _dom_loaded() {
    this.is_capturing() && Je(this.__request_queue, (e) => this.Fs(e)), this.__request_queue = [], this.Ls();
  }
  _handle_unload() {
    var e, t;
    this.config.request_batching ? (this.Us() && this.capture("$pageleave"), (e = this.Os) == null || e.unload(), (t = this.As) == null || t.unload()) : this.Us() && this.capture("$pageleave", null, { transport: "sendBeacon" });
  }
  Te(e) {
    this.__loaded && (Yo ? this.__request_queue.push(e) : this.rateLimiter.isServerRateLimited(e.batchKey) || (e.transport = e.transport || this.config.api_transport, e.url = Sr(e.url, { ip: this.config.ip ? 1 : 0 }), e.headers = E({}, this.config.request_headers), e.compression = e.compression === "best-available" ? this.compression : e.compression, e.disableXHRCredentials = this.config.__preview_disable_xhr_credentials, this.config.__preview_disable_beacon && (e.disableTransport = ["sendBeacon"]), e.fetchOptions = e.fetchOptions || this.config.fetch_options, ((t) => {
      var r, s, n, o = E({}, t);
      o.timeout = o.timeout || 6e4, o.url = Sr(o.url, { _: (/* @__PURE__ */ new Date()).getTime().toString(), ver: Ue.LIB_VERSION, compression: o.compression });
      var a = (r = o.transport) !== null && r !== void 0 ? r : "fetch", l = ar.filter((c) => !o.disableTransport || !c.transport || !o.disableTransport.includes(c.transport)), u = (s = (n = qn(l, (c) => c.transport === a)) == null ? void 0 : n.method) !== null && s !== void 0 ? s : l[0].method;
      if (!u) throw new Error("No available transport method");
      u(o);
    })(E({}, e, { callback: (t) => {
      var r, s;
      this.rateLimiter.checkForLimiting(t), t.statusCode >= 400 && ((r = (s = this.config).on_request_error) == null || r.call(s, t)), e.callback == null || e.callback(t);
    } }))));
  }
  Fs(e) {
    this.As ? this.As.retriableRequest(e) : this.Te(e);
  }
  _execute_array(e) {
    var t, r = [], s = [], n = [];
    Je(e, (a) => {
      a && (t = a[0], W(t) ? n.push(a) : Ie(a) ? a.call(this) : W(a) && t === "alias" ? r.push(a) : W(a) && t.indexOf("capture") !== -1 && Ie(this[t]) ? n.push(a) : s.push(a));
    });
    var o = function(a, l) {
      Je(a, function(u) {
        if (W(u[0])) {
          var c = l;
          z(u, function(d) {
            c = c[d[0]].apply(c, d.slice(1));
          });
        } else this[u[0]].apply(this, u.slice(1));
      }, l);
    };
    o(r, this), o(s, this), o(n, this);
  }
  Ds() {
    var e, t;
    return ((e = this.config.bootstrap) == null ? void 0 : e.featureFlags) && Object.keys((t = this.config.bootstrap) == null ? void 0 : t.featureFlags).length > 0 || !1;
  }
  push(e) {
    this._execute_array([e]);
  }
  capture(e, t, r) {
    var s;
    if (this.__loaded && this.persistence && this.sessionPersistence && this.Os) {
      if (this.is_capturing()) if (!b(e) && Z(e)) {
        if (this.config.opt_out_useragent_filter || !this._is_bot()) {
          var n = r != null && r.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
          if (n == null || !n.isRateLimited) {
            t != null && t.$current_url && !Z(t == null ? void 0 : t.$current_url) && (k.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), t == null || delete t.$current_url), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
            var o = /* @__PURE__ */ new Date(), a = (r == null ? void 0 : r.timestamp) || o, l = Xe(), u = { uuid: l, event: e, properties: this.calculateEventProperties(e, t || {}, a, l) };
            n && (u.properties.$lib_rate_limit_remaining_tokens = n.remainingTokens), r != null && r.$set && (u.$set = r == null ? void 0 : r.$set);
            var c, d = this.zs(r == null ? void 0 : r.$set_once);
            if (d && (u.$set_once = d), (u = Za(u, r != null && r._noTruncate ? null : this.config.properties_string_max_length)).timestamp = a, b(r == null ? void 0 : r.timestamp) || (u.properties.$event_time_override_provided = !0, u.properties.$event_time_override_system_time = o), e === lr.DISMISSED || e === lr.SENT) {
              var h = t == null ? void 0 : t[hn.SURVEY_ID], p = t == null ? void 0 : t[hn.SURVEY_ITERATION];
              c = { id: h, current_iteration: p }, localStorage.getItem(pn(c)) || localStorage.setItem(pn(c), "true"), u.$set = E({}, u.$set, { [Iu({ id: h, current_iteration: p }, e === lr.SENT ? "responded" : "dismissed")]: !0 });
            }
            var g = E({}, u.properties.$set, u.$set);
            if (dt(g) || this.setPersonPropertiesForFlags(g), !q(this.config.before_send)) {
              var v = this.qs(u);
              if (!v) return;
              u = v;
            }
            this.xs.emit("eventCaptured", u);
            var _ = { method: "POST", url: (s = r == null ? void 0 : r._url) !== null && s !== void 0 ? s : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), data: u, compression: "best-available", batchKey: r == null ? void 0 : r._batchKey };
            return !this.config.request_batching || r && (r == null || !r._batchKey) || r != null && r.send_instantly ? this.Fs(_) : this.Os.enqueue(_), u;
          }
          k.critical("This capture call is ignored due to client rate limiting.");
        }
      } else k.error("No event name provided to posthog.capture");
    } else k.uninitializedWarning("posthog.capture");
  }
  Ye(e) {
    return this.on("eventCaptured", (t) => e(t.event, t));
  }
  calculateEventProperties(e, t, r, s, n) {
    if (r = r || /* @__PURE__ */ new Date(), !this.persistence || !this.sessionPersistence) return t;
    var o = n ? void 0 : this.persistence.remove_event_timer(e), a = E({}, t);
    if (a.token = this.config.token, a.$config_defaults = this.config.defaults, (this.config.cookieless_mode == "always" || this.config.cookieless_mode == "on_reject" && this.consent.isExplicitlyOptedOut()) && (a.$cookieless_mode = !0), e === "$snapshot") {
      var l = E({}, this.persistence.properties(), this.sessionPersistence.properties());
      return a.distinct_id = l.distinct_id, (!Z(a.distinct_id) && !pe(a.distinct_id) || ni(a.distinct_id)) && k.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
    }
    var u, c = Su(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
    if (this.sessionManager) {
      var { sessionId: d, windowId: h } = this.sessionManager.checkAndGetSessionAndWindowId(n, r.getTime());
      a.$session_id = d, a.$window_id = h;
    }
    this.sessionPropsManager && Q(a, this.sessionPropsManager.getSessionProps());
    try {
      var p;
      this.sessionRecording && Q(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = (p = this.As) == null ? void 0 : p.length;
    } catch (w) {
      a.$sdk_debug_error_capturing_properties = String(w);
    }
    if (this.requestRouter.region === Dt.CUSTOM && (a.$lib_custom_api_host = this.config.api_host), u = e !== "$pageview" || n ? e !== "$pageleave" || n ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(r) : this.pageViewManager.doPageView(r, s), a = Q(a, u), e === "$pageview" && x && (a.title = x.title), !b(o)) {
      var g = r.getTime() - o;
      a.$duration = parseFloat((g / 1e3).toFixed(3));
    }
    be && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser"), (a = Q({}, c, this.persistence.properties(), this.sessionPersistence.properties(), a)).$is_identified = this._isIdentified(), W(this.config.property_denylist) ? z(this.config.property_denylist, function(w) {
      delete a[w];
    }) : k.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
    var v = this.config.sanitize_properties;
    v && (k.error("sanitize_properties is deprecated. Use before_send instead"), a = v(a, e));
    var _ = this.Bs();
    return a.$process_person_profile = _, _ && !n && this.Hs("_calculate_event_properties"), a;
  }
  zs(e) {
    var t;
    if (!this.persistence || !this.Bs() || this.$s) return e;
    var r = this.persistence.get_initial_props(), s = (t = this.sessionPropsManager) == null ? void 0 : t.getSetOnceProps(), n = Q({}, r, s || {}, e || {}), o = this.config.sanitize_properties;
    return o && (k.error("sanitize_properties is deprecated. Use before_send instead"), n = o(n, "$set_once")), this.$s = !0, dt(n) ? void 0 : n;
  }
  register(e, t) {
    var r;
    (r = this.persistence) == null || r.register(e, t);
  }
  register_once(e, t, r) {
    var s;
    (s = this.persistence) == null || s.register_once(e, t, r);
  }
  register_for_session(e) {
    var t;
    (t = this.sessionPersistence) == null || t.register(e);
  }
  unregister(e) {
    var t;
    (t = this.persistence) == null || t.unregister(e);
  }
  unregister_for_session(e) {
    var t;
    (t = this.sessionPersistence) == null || t.unregister(e);
  }
  Ws(e, t) {
    this.register({ [e]: t });
  }
  getFeatureFlag(e, t) {
    return this.featureFlags.getFeatureFlag(e, t);
  }
  getFeatureFlagPayload(e) {
    var t = this.featureFlags.getFeatureFlagPayload(e);
    try {
      return JSON.parse(t);
    } catch {
      return t;
    }
  }
  isFeatureEnabled(e, t) {
    return this.featureFlags.isFeatureEnabled(e, t);
  }
  reloadFeatureFlags() {
    this.featureFlags.reloadFeatureFlags();
  }
  updateEarlyAccessFeatureEnrollment(e, t, r) {
    this.featureFlags.updateEarlyAccessFeatureEnrollment(e, t, r);
  }
  getEarlyAccessFeatures(e, t, r) {
    return t === void 0 && (t = !1), this.featureFlags.getEarlyAccessFeatures(e, t, r);
  }
  on(e, t) {
    return this.xs.on(e, t);
  }
  onFeatureFlags(e) {
    return this.featureFlags.onFeatureFlags(e);
  }
  onSurveysLoaded(e) {
    return this.surveys.onSurveysLoaded(e);
  }
  onSessionId(e) {
    var t, r;
    return (t = (r = this.sessionManager) == null ? void 0 : r.onSessionId(e)) !== null && t !== void 0 ? t : () => {
    };
  }
  getSurveys(e, t) {
    t === void 0 && (t = !1), this.surveys.getSurveys(e, t);
  }
  getActiveMatchingSurveys(e, t) {
    t === void 0 && (t = !1), this.surveys.getActiveMatchingSurveys(e, t);
  }
  renderSurvey(e, t) {
    this.surveys.renderSurvey(e, t);
  }
  displaySurvey(e, t) {
    t === void 0 && (t = Cu), this.surveys.displaySurvey(e, t);
  }
  canRenderSurvey(e) {
    return this.surveys.canRenderSurvey(e);
  }
  canRenderSurveyAsync(e, t) {
    return t === void 0 && (t = !1), this.surveys.canRenderSurveyAsync(e, t);
  }
  identify(e, t, r) {
    if (!this.__loaded || !this.persistence) return k.uninitializedWarning("posthog.identify");
    if (pe(e) && (e = e.toString(), k.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), e) if (["distinct_id", "distinctid"].includes(e.toLowerCase())) k.critical('The string "' + e + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
    else if (e !== kt) {
      if (this.Hs("posthog.identify")) {
        var s = this.get_distinct_id();
        if (this.register({ $user_id: e }), !this.get_property("$device_id")) {
          var n = s;
          this.register_once({ $had_persisted_distinct_id: !0, $device_id: n }, "");
        }
        e !== s && e !== this.get_property(Ct) && (this.unregister(Ct), this.register({ distinct_id: e }));
        var o = (this.persistence.get_property(je) || "anonymous") === "anonymous";
        e !== s && o ? (this.persistence.set_property(je, "identified"), this.setPersonPropertiesForFlags(E({}, r || {}, t || {}), !1), this.capture("$identify", { distinct_id: e, $anon_distinct_id: s }, { $set: t || {}, $set_once: r || {} }), this.Rs = rn(e, t, r), this.featureFlags.setAnonymousDistinctId(s)) : (t || r) && this.setPersonProperties(t, r), e !== s && (this.reloadFeatureFlags(), this.unregister(pr));
      }
    } else k.critical('The string "' + kt + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.');
    else k.error("Unique user id has not been set in posthog.identify");
  }
  setPersonProperties(e, t) {
    if ((e || t) && this.Hs("posthog.setPersonProperties")) {
      var r = rn(this.get_distinct_id(), e, t);
      this.Rs !== r ? (this.setPersonPropertiesForFlags(E({}, t || {}, e || {})), this.capture("$set", { $set: e || {}, $set_once: t || {} }), this.Rs = r) : k.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
    }
  }
  group(e, t, r) {
    if (e && t) {
      if (this.Hs("posthog.group")) {
        var s = this.getGroups();
        s[e] !== t && this.resetGroupPropertiesForFlags(e), this.register({ $groups: E({}, s, { [e]: t }) }), r && (this.capture("$groupidentify", { $group_type: e, $group_key: t, $group_set: r }), this.setGroupPropertiesForFlags({ [e]: r })), s[e] === t || r || this.reloadFeatureFlags();
      }
    } else k.error("posthog.group requires a group type and group key");
  }
  resetGroups() {
    this.register({ $groups: {} }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
  }
  setPersonPropertiesForFlags(e, t) {
    t === void 0 && (t = !0), this.featureFlags.setPersonPropertiesForFlags(e, t);
  }
  resetPersonPropertiesForFlags() {
    this.featureFlags.resetPersonPropertiesForFlags();
  }
  setGroupPropertiesForFlags(e, t) {
    t === void 0 && (t = !0), this.Hs("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(e, t);
  }
  resetGroupPropertiesForFlags(e) {
    this.featureFlags.resetGroupPropertiesForFlags(e);
  }
  reset(e) {
    var t, r, s, n;
    if (k.info("reset"), !this.__loaded) return k.uninitializedWarning("posthog.reset");
    var o = this.get_property("$device_id");
    if (this.consent.reset(), (t = this.persistence) == null || t.clear(), (r = this.sessionPersistence) == null || r.clear(), this.surveys.reset(), this.featureFlags.reset(), (s = this.persistence) == null || s.set_property(je, "anonymous"), (n = this.sessionManager) == null || n.resetSessionId(), this.Rs = null, this.config.cookieless_mode === "always") this.register_once({ distinct_id: kt, $device_id: null }, "");
    else {
      var a = this.config.get_device_id(Xe());
      this.register_once({ distinct_id: a, $device_id: e ? a : o }, "");
    }
    this.register({ $last_posthog_reset: (/* @__PURE__ */ new Date()).toISOString() }, 1);
  }
  get_distinct_id() {
    return this.get_property("distinct_id");
  }
  getGroups() {
    return this.get_property("$groups") || {};
  }
  get_session_id() {
    var e, t;
    return (e = (t = this.sessionManager) == null ? void 0 : t.checkAndGetSessionAndWindowId(!0).sessionId) !== null && e !== void 0 ? e : "";
  }
  get_session_replay_url(e) {
    if (!this.sessionManager) return "";
    var { sessionId: t, sessionStartTimestamp: r } = this.sessionManager.checkAndGetSessionAndWindowId(!0), s = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + t);
    if (e != null && e.withTimestamp && r) {
      var n, o = (n = e.timestampLookBack) !== null && n !== void 0 ? n : 10;
      if (!r) return s;
      s += "?t=" + Math.max(Math.floor(((/* @__PURE__ */ new Date()).getTime() - r) / 1e3) - o, 0);
    }
    return s;
  }
  alias(e, t) {
    return e === this.get_property(Un) ? (k.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Hs("posthog.alias") ? (b(t) && (t = this.get_distinct_id()), e !== t ? (this.Ws(Ct, e), this.capture("$create_alias", { alias: e, distinct_id: t })) : (k.warn("alias matches current distinct_id - skipping api call."), this.identify(e), -1)) : void 0;
  }
  set_config(e) {
    var t = E({}, this.config);
    if (K(e)) {
      var r, s, n, o, a;
      Q(this.config, bn(e));
      var l = this.Ms();
      (r = this.persistence) == null || r.update_config(this.config, t, l), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new Zr(E({}, this.config, { persistence: "sessionStorage" }), l), ee.G() && ee.J("ph_debug") === "true" && (this.config.debug = !0), this.config.debug && (Ue.DEBUG = !0, k.info("set_config", { config: e, oldConfig: t, newConfig: E({}, this.config) })), (s = this.sessionRecording) == null || s.startIfEnabledOrStop(), (n = this.autocapture) == null || n.startIfEnabled(), (o = this.heatmaps) == null || o.startIfEnabled(), this.surveys.loadIfEnabled(), this.Gs(), (a = this.externalIntegrations) == null || a.startIfEnabledOrStop();
    }
  }
  startSessionRecording(e) {
    var t = e === !0, r = { sampling: t || !(e == null || !e.sampling), linked_flag: t || !(e == null || !e.linked_flag), url_trigger: t || !(e == null || !e.url_trigger), event_trigger: t || !(e == null || !e.event_trigger) };
    if (Object.values(r).some(Boolean)) {
      var s, n, o, a, l;
      (s = this.sessionManager) == null || s.checkAndGetSessionAndWindowId(), r.sampling && ((n = this.sessionRecording) == null || n.overrideSampling()), r.linked_flag && ((o = this.sessionRecording) == null || o.overrideLinkedFlag()), r.url_trigger && ((a = this.sessionRecording) == null || a.overrideTrigger("url")), r.event_trigger && ((l = this.sessionRecording) == null || l.overrideTrigger("event"));
    }
    this.set_config({ disable_session_recording: !1 });
  }
  stopSessionRecording() {
    this.set_config({ disable_session_recording: !0 });
  }
  sessionRecordingStarted() {
    var e;
    return !((e = this.sessionRecording) == null || !e.started);
  }
  captureException(e, t) {
    var r = new Error("PostHog syntheticException"), s = this.exceptions.buildProperties(e, { handled: !0, syntheticException: r });
    return this.exceptions.sendExceptionEvent(E({}, s, t));
  }
  loadToolbar(e) {
    return this.toolbar.loadToolbar(e);
  }
  get_property(e) {
    var t;
    return (t = this.persistence) == null ? void 0 : t.props[e];
  }
  getSessionProperty(e) {
    var t;
    return (t = this.sessionPersistence) == null ? void 0 : t.props[e];
  }
  toString() {
    var e, t = (e = this.config.name) !== null && e !== void 0 ? e : ct;
    return t !== ct && (t = ct + "." + t), t;
  }
  _isIdentified() {
    var e, t;
    return ((e = this.persistence) == null ? void 0 : e.get_property(je)) === "identified" || ((t = this.sessionPersistence) == null ? void 0 : t.get_property(je)) === "identified";
  }
  Bs() {
    var e, t;
    return !(this.config.person_profiles === "never" || this.config.person_profiles === "identified_only" && !this._isIdentified() && dt(this.getGroups()) && ((e = this.persistence) == null || (e = e.props) == null || !e[Ct]) && ((t = this.persistence) == null || (t = t.props) == null || !t[vr]));
  }
  Us() {
    return this.config.capture_pageleave === !0 || this.config.capture_pageleave === "if_capture_pageview" && (this.config.capture_pageview === !0 || this.config.capture_pageview === "history_change");
  }
  createPersonProfile() {
    this.Bs() || this.Hs("posthog.createPersonProfile") && this.setPersonProperties({}, {});
  }
  Hs(e) {
    return this.config.person_profiles === "never" ? (k.error(e + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.Ws(vr, !0), !0);
  }
  Ms() {
    if (this.config.cookieless_mode === "always") return !0;
    var e = this.consent.isOptedOut(), t = this.config.opt_out_persistence_by_default || this.config.cookieless_mode === "on_reject";
    return this.config.disable_persistence || e && !!t;
  }
  Gs() {
    var e, t, r, s, n = this.Ms();
    return ((e = this.persistence) == null ? void 0 : e.je) !== n && ((r = this.persistence) == null || r.set_disabled(n)), ((t = this.sessionPersistence) == null ? void 0 : t.je) !== n && ((s = this.sessionPersistence) == null || s.set_disabled(n)), n;
  }
  opt_in_capturing(e) {
    if (this.config.cookieless_mode !== "always") {
      var t;
      this.config.cookieless_mode === "on_reject" && this.consent.isExplicitlyOptedOut() && (this.reset(!0), this.sessionManager = new gn(this), this.persistence && (this.sessionPropsManager = new vn(this, this.sessionManager, this.persistence)), this.sessionRecording = new Js(this), this.sessionRecording.startIfEnabledOrStop()), this.consent.optInOut(!0), this.Gs(), this.config.cookieless_mode == "on_reject" && this.surveys.loadIfEnabled(), (b(e == null ? void 0 : e.captureEventName) || e != null && e.captureEventName) && this.capture((t = e == null ? void 0 : e.captureEventName) !== null && t !== void 0 ? t : "$opt_in", e == null ? void 0 : e.captureProperties, { send_instantly: !0 }), this.config.capture_pageview && this.Ns();
    } else k.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
  }
  opt_out_capturing() {
    var e;
    this.config.cookieless_mode !== "always" ? (this.config.cookieless_mode === "on_reject" && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this.Gs(), this.config.cookieless_mode === "on_reject" && (this.register({ distinct_id: kt, $device_id: null }), this.sessionManager = void 0, this.sessionPropsManager = void 0, (e = this.sessionRecording) == null || e.stopRecording(), this.sessionRecording = void 0, this.Ns())) : k.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
  }
  has_opted_in_capturing() {
    return this.consent.isOptedIn();
  }
  has_opted_out_capturing() {
    return this.consent.isOptedOut();
  }
  get_explicit_consent_status() {
    var e = this.consent.consent;
    return e === He.GRANTED ? "granted" : e === He.DENIED ? "denied" : "pending";
  }
  is_capturing() {
    return this.config.cookieless_mode === "always" || (this.config.cookieless_mode === "on_reject" ? this.consent.isExplicitlyOptedOut() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
  }
  clear_opt_in_out_capturing() {
    this.consent.reset(), this.Gs();
  }
  _is_bot() {
    return xe ? Go(xe, this.config.custom_blocked_useragents) : void 0;
  }
  Ns() {
    x && (x.visibilityState === "visible" ? this.Es || (this.Es = !0, this.capture("$pageview", { title: x.title }, { send_instantly: !0 }), this.Ps && (x.removeEventListener("visibilitychange", this.Ps), this.Ps = null)) : this.Ps || (this.Ps = this.Ns.bind(this), J(x, "visibilitychange", this.Ps)));
  }
  debug(e) {
    e === !1 ? (f == null || f.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({ debug: !1 })) : (f == null || f.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({ debug: !0 }));
  }
  L() {
    var e, t, r, s, n, o, a, l = this.Ts || {};
    return "advanced_disable_flags" in l ? !!l.advanced_disable_flags : this.config.advanced_disable_flags !== !1 ? !!this.config.advanced_disable_flags : this.config.advanced_disable_decide === !0 ? (k.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (r = "advanced_disable_decide", s = !1, n = k, o = (t = "advanced_disable_flags") in (e = l) && !b(e[t]), a = r in e && !b(e[r]), o ? e[t] : a ? (n && n.warn("Config field '" + r + "' is deprecated. Please use '" + t + "' instead. The old field will be removed in a future major version."), e[r]) : s);
  }
  qs(e) {
    if (q(this.config.before_send)) return e;
    var t = W(this.config.before_send) ? this.config.before_send : [this.config.before_send], r = e;
    for (var s of t) {
      if (r = s(r), q(r)) {
        var n = "Event '" + e.event + "' was rejected in beforeSend function";
        return Ra(e.event) ? k.warn(n + ". This can cause unexpected behavior.") : k.info(n), null;
      }
      r.properties && !dt(r.properties) || k.warn("Event '" + e.event + "' has no properties after beforeSend function, this is likely an error.");
    }
    return r;
  }
  getPageViewId() {
    var e;
    return (e = this.pageViewManager.fe) == null ? void 0 : e.pageViewId;
  }
  captureTraceFeedback(e, t) {
    this.capture("$ai_feedback", { $ai_trace_id: String(e), $ai_feedback_text: t });
  }
  captureTraceMetric(e, t, r) {
    this.capture("$ai_metric", { $ai_trace_id: String(e), $ai_metric_name: t, $ai_metric_value: String(r) });
  }
}
(function(i, e) {
  for (var t = 0; t < e.length; t++) i.prototype[e[t]] = Ka(i.prototype[e[t]]);
})(Ar, ["identify"]);
var wn, Ju = (wn = Ht[ct] = new Ar(), function() {
  function i() {
    i.done || (i.done = !0, Yo = !1, z(Ht, function(e) {
      e._dom_loaded();
    }));
  }
  x != null && x.addEventListener ? x.readyState === "complete" ? i() : J(x, "DOMContentLoaded", i, { capture: !1 }) : f && k.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), wn), zo = Wo({ client: Ju }), Ku = function() {
  var i = Vo(zo).client;
  return i;
};
function Zu(i) {
  var e = Ku(), t = xr(function() {
    return e.isFeatureEnabled(i);
  }), r = t[0], s = t[1];
  return zt(function() {
    return e.onFeatureFlags(function() {
      s(e.isFeatureEnabled(i));
    });
  }, [e, i]), r;
}
var Fi = function(i, e) {
  return Fi = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var s in r) Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
  }, Fi(i, e);
};
function Qu(i, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Fi(i, e);
  function t() {
    this.constructor = i;
  }
  i.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var ti = function(i) {
  return typeof i == "function";
}, ec = {
  componentStack: null,
  exceptionEvent: null,
  error: null
}, tc = {
  INVALID_FALLBACK: "[PostHog.js][PostHogErrorBoundary] Invalid fallback prop, provide a valid React element or a function that returns a valid React element."
};
(function(i) {
  Qu(e, i);
  function e(t) {
    var r = i.call(this, t) || this;
    return r.state = ec, r;
  }
  return e.prototype.componentDidCatch = function(t, r) {
    var s = this.props.additionalProperties, n;
    ti(s) ? n = s(t) : typeof s == "object" && (n = s);
    var o = this.context.client, a = o.captureException(t, n), l = r.componentStack;
    this.setState({
      error: t,
      componentStack: l,
      exceptionEvent: a
    });
  }, e.prototype.render = function() {
    var t = this.props, r = t.children, s = t.fallback, n = this.state;
    if (n.componentStack == null)
      return ti(r) ? r() : r;
    var o = ti(s) ? St.createElement(s, {
      error: n.error,
      componentStack: n.componentStack,
      exceptionEvent: n.exceptionEvent
    }) : s;
    return St.isValidElement(o) ? o : (console.warn(tc.INVALID_FALLBACK), St.createElement(St.Fragment, null));
  }, e.contextType = zo, e;
})(St.Component);
const rc = void 0;
function yc() {
  return Zu("showVicSmartSection") || ["dev", "dojo"].includes(rc);
}
function bc(i, e, t) {
  var o;
  const { getConfig: r } = On({
    conversation: i,
    noticeboardData: e,
    useSystemLanguage: !0
  }), { content: s, expert_name: n } = r(
    `${t}.assessment_lights`
  );
  return n ? s : (o = e == null ? void 0 : e.assessment_lights) == null ? void 0 : o.raw_output;
}
const En = {
  councilName: "",
  councilPhoneNumber: "",
  councilPlanningWebsite: "https://www.mylot.ai",
  councilContactLink: "https://www.yarraranges.vic.gov.au/Contact",
  councilWrittenPlanningAdviceLink: "https://www.yarraranges.vic.gov.au/Development/Applications-permits-and-certificates/Apply-for-written-planning-advice",
  councilPrivacyInformationLink: "https://www.yarraranges.vic.gov.au/Council/Corporate-documents/Policies-strategies/Operational-Privacy-Health-Information-Policy",
  councilOrdinanceLink: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/{{}}"
};
function wc(i) {
  const e = Wt(() => i != null && i.localisation_config ? i.localisation_config : En, [i == null ? void 0 : i.localisation_config]);
  return {
    getLocalisationEntry: pt(
      (r) => r in e ? Xo(e, r) : En[r],
      [e]
    )
  };
}
function Ec(i) {
  const { messageType: e, messages: t, senderAccountType: r } = i || {};
  return Wt(() => t.filter((s) => r && s.sender_account_type !== r ? !1 : s.message_type === e), [e, t, r]);
}
function Sc({
  expertName: i,
  noticeboardData: e
}) {
  const t = Wt(() => {
    var n;
    return [...((n = e == null ? void 0 : e[i]) == null ? void 0 : n.revisions) || []].sort((o, a) => new Date(a.created_at).getTime() - new Date(o.created_at).getTime());
  }, [i, e]);
  return {
    hasRevisions: Array.isArray(t) && t.length > 0,
    revisions: t
  };
}
function ic(i) {
  const { messages: e, senderAccountType: t } = i || { messages: [] };
  return Wt(() => e == null ? void 0 : e.filter((r) => t ? r.sender_account_type === t : !0).sort(Jo).at(-1), [e, t]);
}
function sc({
  messages: i
}) {
  const e = ic({
    messages: i,
    senderAccountType: Ko.USER
  });
  return (e == null ? void 0 : e.message_type) === Zo.FOLLOW_UP;
}
function kc({
  conversation: i,
  messages: e
}) {
  return sc({ messages: e }) || (i == null ? void 0 : i.phase) !== Qo.report_ready;
}
function xc({ conversation: i }) {
  const e = i == null ? void 0 : i.review;
  return Wt(() => {
    if (e && !(e != null && e.review_data))
      return [{ ...e, review_data: {} }];
    if (e && typeof e.review_data == "string") {
      const t = JSON.parse(e.review_data || "{}");
      return [{ ...e, review_data: t }];
    } else return e ? [e] : [];
  }, [e]);
}
const Rc = {
  "subdivision of an approved development": "subdivision of an approved development",
  "battle-axe subdivision": "battle-axe subdivision",
  "large lot subdivision in a rural area": "large lot subdivision in a rural area",
  "revising existing boundaries": "revising existing boundaries",
  "lot consolidation": "lot consolidation",
  "n/a": "n/a"
};
function Tc(i, e) {
  const { getConfig: t } = On({
    conversation: i,
    noticeboardData: e
  }), { content: r } = t("enquiry.subdivision_type");
  return r;
}
export {
  gc as P,
  Rc as S,
  dc as a,
  hc as b,
  pc as c,
  fc as d,
  vc as e,
  _c as f,
  mc as g,
  yc as h,
  bc as i,
  wc as j,
  Ec as k,
  Sc as l,
  sc as m,
  kc as n,
  ic as o,
  xc as p,
  Tc as q,
  On as u
};
//# sourceMappingURL=useGetSubdivisionType-CuJXxyQE.js.map
